/* DM REBRAND · capa «es»: comportamientos portados de drmartens.com/es/es. GENERADO por es/build_js.py desde es/js/*.js — no editar a mano.
   El marcado (dm-*.liquid) y el CSS (dm-es.css) son los de España; este archivo reproduce lo que allá hace React: mueve los MISMOS
   atributos de estado (data-*, aria-*) y estilos en línea que su CSS espera. Sin dependencias. */
(() => {
'use strict';

/* ═══ 00-core.js ═══ */
/* ───────── núcleo ─────────
   DMES.on(selector, fn)  registra un componente: fn(el) corre una vez por elemento (al cargar y al re-renderizar una sección en el editor)
   DMES.stepped(opts)     animación «escalonada» de España (buildSteppedTimeline): avanza en tramos con pausas, no en forma continua
   DMES.timing(opts)      = getSteppedAnimationTiming
   Constantes de España: STEPPED_ANIMATION_SPEED 1.2 · CHUNK_VH 12 · MOVE_MS 10 · PAUSE_MS 60 */
const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => [...r.querySelectorAll(s)];
const mq = q => window.matchMedia(q).matches;
const DESKTOP = '(min-width: 1024px)';
const reduced = () => mq('(prefers-reduced-motion: reduce)');
const DMES = (window.DMES = window.DMES || {});
DMES.parts = DMES.parts || [];
DMES.$ = $; DMES.$$ = $$; DMES.mq = mq; DMES.DESKTOP = DESKTOP; DMES.reduced = reduced;
DMES.SPEED = 1.2; DMES.CHUNK_VH = 12; DMES.MOVE_MS = 10; DMES.PAUSE_MS = 60;
/* 16-oct-2026, pedido del user: la apertura del menú «puede ser más smooth» que la escalonada de UK/España ⇒ DMES.SMOOTH hace que
   DMES.stepped recorra el tramo completo en un solo movimiento continuo de SMOOTH_MS con la curva «regular» de allá. Poner en false para volver al escalonado. */
DMES.SMOOTH = true; DMES.SMOOTH_MS = 380;
DMES.bezier = (x1, y1, x2, y2) => {
  const A = (a, b) => 1 - 3 * b + 3 * a, B = (a, b) => 3 * b - 6 * a, C = a => 3 * a;
  const calc = (t, a, b) => ((A(a, b) * t + B(a, b)) * t + C(a)) * t, slope = (t, a, b) => 3 * A(a, b) * t * t + 2 * B(a, b) * t + C(a);
  return x => { if (x <= 0) return 0; if (x >= 1) return 1; let t = x; for (let i = 0; i < 8; i++) { const sl = slope(t, x1, x2); if (!sl) break; t -= (calc(t, x1, x2) - x) / sl; } return calc(t, y1, y2); };
};
DMES.easeSmooth = DMES.bezier(.45, .02, .09, .98);  // (DMES.ease es el objeto de curvas de 40-scale-carousel.js: no pisarlo)
DMES.on = (sel, fn) => { DMES.parts.push([sel, fn]); };
DMES.init = (root = document) => {
  for (const [sel, fn] of DMES.parts) {
    const els = $$(sel, root);
    if (root !== document && root.matches && root.matches(sel)) els.unshift(root);
    for (const el of els) {
      el.__dmes = el.__dmes || new Set();
      if (el.__dmes.has(fn)) continue;
      el.__dmes.add(fn);
      try { fn(el); } catch (e) { console.error('[dm-es]', sel, e); }
    }
  }
};
DMES.timing = ({ speed = 1, chunkVh = 12, moveMs = 10, pauseMs = 60 } = {}) => {
  const n = Number.isFinite(chunkVh) && chunkVh > 0 ? chunkVh : 12, r = Number.isFinite(speed) && speed > 0 ? speed : 1;
  const l = Number.isFinite(moveMs) && moveMs > 0 ? moveMs : 10, o = Number.isFinite(pauseMs) && pauseMs > 0 ? pauseMs : 60;
  return { stepPx: window.innerHeight * (n / 100), moveMs: l / r, pauseMs: o / r };
};
/* Igual a buildSteppedTimeline de España (GSAP): desde start hasta end en pasos de stepPx; cada paso = un tramo corto «move»
   (interpolación lineal) + una pausa. Sin `uniform`, los pasos se van alargando (peso .55 + (i-.5)/p·1.3).
   vars(valor) → objeto de estilos en línea. Devuelve {kill(), then(fn), delay(ms), value}. Arranca solo en el próximo frame. */
DMES.stepped = ({ el, start, end, stepPx, moveMs, pauseMs, vars, onValue, uniform = false, onComplete }) => {
  const d = Math.abs(end - start), m = end >= start ? 1 : -1, p = Math.max(1, Math.ceil(d / stepPx));
  const h = uniform ? () => 1 : e => 0.55 + ((e - 0.5) / p) * 1.3;
  let v = 0; for (let e = 1; e <= p; e++) v += h(e);
  const g = v / p, E = p > 1 ? (v - h(p)) / (p - 1) : 1;
  let segs = []; let t = 0, prev = start;
  for (let i = 1; i <= p; i++) {
    const a = start + m * Math.min(i * stepPx, d), dur = moveMs * (h(i) / g);
    segs.push({ t0: t, t1: t + dur, from: prev, to: a, move: true }); t += dur;
    if (i < p) { const pd = pauseMs * (h(i) / E); segs.push({ t0: t, t1: t + pd, from: a, to: a }); t += pd; }
    prev = a;
  }
  if (DMES.SMOOTH) segs = [{ t0: 0, t1: Math.max(1, DMES.SMOOTH_MS * Math.min(1, d / Math.max(1, window.innerHeight))), from: start, to: end, move: true }];
  const apply = val => { const o = vars(val); for (const k in o) el.style[k] = o[k]; };
  const ctl = { value: start, done: false, killed: false, _delay: 0, _cbs: [] };
  ctl.kill = () => { ctl.killed = true; };
  ctl.then = fn => { ctl._cbs.push(fn); return ctl; };
  ctl.delay = ms => { ctl._delay = ms; return ctl; };
  apply(start);
  let t0 = null, si = 0;
  const tick = now => {
    if (ctl.killed) return;
    if (t0 === null) t0 = now + ctl._delay;
    const el2 = now - t0;
    if (el2 < 0) return requestAnimationFrame(tick);
    while (si < segs.length && el2 >= segs[si].t1) { const s = segs[si++]; if (s.move) { ctl.value = s.to; onValue && onValue(s.to); } }
    if (si >= segs.length) { apply(end); ctl.value = end; ctl.done = true; onComplete && onComplete(); ctl._cbs.forEach(f => f()); return; }
    const s = segs[si]; const pr = (el2 - s.t0) / Math.max(1e-6, s.t1 - s.t0); apply(s.move ? s.from + (s.to - s.from) * (DMES.SMOOTH ? DMES.easeSmooth(Math.min(1, pr)) : pr) : s.to);
    requestAnimationFrame(tick);
  };
  requestAnimationFrame(tick);
  return ctl;
};

/* ═══ 05-panel.js ═══ */
/* ───────── diálogos y paneles (Dialog · Panel · PanelGroup · PanelControls de España) ─────────
   Marcado (dentro de .es):
     <div class="es-panel-group__backdrop" data-open="false"></div>                       ← una vez por página (lo trae el header)
     <dialog id="X" class="es-panel__container" closedby="any" aria-labelledby="X-title">
       <div class="es-panel__content" data-panel-appearance="true" data-alignment="end|start" data-size="default|large" data-expanded="false"> … </div>
     </dialog>
     abrir:   <button commandfor="X" command="show-modal">        cerrar: <button commandfor="X" command="request-close">
   Qué hace (igual que allá):
     · showModal() nativo; al abrir bloquea el scroll del body (scrollbar-gutter:stable; overflow:hidden · en iOS position:fixed)
     · el contenido del panel aparece/desaparece con clip-path escalonado (abrir velocidad 1.2, cerrar 1.8, tramos de 12vh)
     · clic fuera del contenido cierra todos los paneles; el botón «atrás» (data-control="back") cierra solo el de encima
     · en móvil el panel se expande (data-expanded="true") al hacer scroll dentro
   API: DMES.dialog.show(id) · DMES.dialog.requestClose(id) · DMES.dialog.closeAll() */
{
  const html = document.documentElement;
  const iOS = /iP(hone|ad|od)/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  const hasClosedBy = 'closedBy' in HTMLDialogElement.prototype;
  const hasCommand = 'commandForElement' in HTMLButtonElement.prototype;
  // España copia --scrollbar-width a --scrollbar-persisted-width (la usan los paneles para no saltar al liberar el scroll)
  new MutationObserver(() => {
    const e = html.style.getPropertyValue('--scrollbar-width'), t = html.style.getPropertyValue('--scrollbar-persisted-width');
    if (e && t !== e) html.style.setProperty('--scrollbar-persisted-width', e);
  }).observe(html, { attributes: true, attributeFilter: ['style'] });

  const locks = new Set(); let unlock = null;
  const lock = () => {
    const body = document.body, prev = html.style.getPropertyValue('--scrollbar-width');
    const sw = prev ? Number.parseInt(prev, 10) : window.innerWidth - html.clientWidth;
    html.style.setProperty('--scrollbar-width', `${sw}px`);
    const css = body.style.cssText; let restore;
    if (iOS) {
      const { scrollX, scrollY, visualViewport: vv } = window, path = location.pathname, ol = (vv && vv.offsetLeft) || 0, ot = (vv && vv.offsetTop) || 0;
      Object.assign(body.style, { scrollbarGutter: 'stable', position: 'fixed', overflow: 'hidden', top: `${-(scrollY - Math.floor(ot))}px`, left: `${-(scrollX - Math.floor(ol))}px`, right: '0' });
      restore = () => { body.style.cssText = css; if (location.pathname === path) window.scrollTo({ left: scrollX, top: scrollY, behavior: 'instant' }); };
    } else {
      Object.assign(body.style, { scrollbarGutter: 'stable', overflow: 'hidden' });
      restore = () => { body.style.cssText = css; };
    }
    return () => { prev ? html.style.setProperty('--scrollbar-width', prev) : html.style.removeProperty('--scrollbar-width'); restore(); };
  };
  DMES.scrollLock = {
    add(k) { if (!locks.has(k)) { locks.add(k); if (locks.size === 1) unlock = lock(); } },
    remove(k) { if (locks.has(k)) { locks.delete(k); if (!locks.size && unlock) { unlock(); unlock = null; } } },
  };

  const requestClose = (d, value) => {
    let prevented = false;
    if (typeof d.requestClose === 'function') { d.addEventListener('cancel', e => { prevented = e.defaultPrevented; }, { once: true }); d.requestClose(value); }
    else d.close(value);
    return prevented;
  };
  const group = () => $$('.es dialog');
  const syncBackdrop = () => { const b = $('.es-panel-group__backdrop'); if (b) b.dataset.open = String(group().some(d => d.open)); };
  DMES.dialog = {
    get: id => (typeof id === 'string' ? document.getElementById(id) : id),
    show(id) { const d = DMES.dialog.get(id); if (!(d instanceof HTMLDialogElement)) return; if (d.open) d.close('re-show'); d.showModal(); },
    requestClose(id, v) { const d = DMES.dialog.get(id); if (d instanceof HTMLDialogElement && d.open) requestClose(d, v); },
    close(id, v) { const d = DMES.dialog.get(id); if (d instanceof HTMLDialogElement && d.open) d.close(v); },
    closeAll() { group().forEach(d => { if (d.open) requestClose(d); }); },
  };

  DMES.on('.es dialog', d => {
    const content = $('[data-panel-appearance]', d);       // panel (apertura escalonada). Sin esto es un diálogo simple (transición CSS)
    const closedby = d.getAttribute('closedby') || 'any';
    let last = NaN, tl = null;
    if (content) {
      content.dataset.expanded = 'false';
      content.style.clipPath = d.open ? 'inset(0 0 0 0)' : (mq(DESKTOP) ? 'inset(0 0 100% 0)' : 'inset(100% 0 0 0)');
      if (d.open) last = 0;
    }
    const animate = ({ isOpen, nestedClose, nestedOpen, done }) => {
      if (tl) tl.kill();
      const desktop = mq(DESKTOP), H = window.innerHeight;
      const start = Number.isFinite(last) ? last : (isOpen ? H : 0), end = isOpen ? 0 : H;
      const vars = v => (desktop || nestedClose || nestedOpen
        ? (nestedClose ? { clipPath: `inset(${v}px 0 0 0)` } : { clipPath: `inset(0 0 ${v}px 0)` })
        : { clipPath: `inset(${v}px 0 0 0)` });
      if (reduced()) { content.style.clipPath = vars(end).clipPath; last = end; done && done(); return; }
      const { stepPx, moveMs, pauseMs } = DMES.timing({ speed: isOpen ? DMES.SPEED : 1.5 * DMES.SPEED, chunkVh: DMES.CHUNK_VH, moveMs: DMES.MOVE_MS, pauseMs: DMES.PAUSE_MS });
      tl = content.__dmTl = DMES.stepped({ el: content, start, end, stepPx, moveMs, pauseMs, vars, uniform: true, onValue: v => { last = v; }, onComplete: done });
      if (nestedOpen) tl.delay((moveMs + pauseMs) * 2);
    };
    new MutationObserver(() => {
      const open = d.open;
      open ? DMES.scrollLock.add(d) : DMES.scrollLock.remove(d);
      syncBackdrop();
      if (open) { d.returnValue = ''; if (d.scrollTop) d.scrollTo({ top: 0, behavior: 'instant' }); }
      d.dispatchEvent(new CustomEvent('dm:dialog', { bubbles: true, detail: { open } }));
      if (!content) return;
      if (open) { content.scrollTop = 0; if (!mq(DESKTOP) && $("dialog[open] [data-expanded='true']")) content.dataset.expanded = 'true'; }
      else content.dataset.expanded = 'false';
      if (!open && d.dataset.panelSkipCloseAnimation === 'true') { delete d.dataset.panelSkipCloseAnimation; return; }
      const nestedClose = !open && d.dataset.panelNestedClose === 'true';
      let nestedOpen = false;
      if (open) $$('dialog[open] [data-panel-appearance]').forEach(t => { if (t !== content) { nestedOpen = true; if (t.__dmTl) t.__dmTl.kill(); t.style.clipPath = 'inset(0 0 0 0)'; } });
      animate({ isOpen: open, nestedClose, nestedOpen });
    }).observe(d, { attributes: true, attributeFilter: ['open'] });
    d.addEventListener('cancel', e => {
      if (!content || d.dataset.panelNestedClose !== 'true') return;
      e.preventDefault(); d.style.display = 'grid';
      animate({ isOpen: false, nestedClose: true, nestedOpen: false, done: () => { delete d.dataset.panelNestedClose; d.dataset.panelSkipCloseAnimation = 'true'; d.style.removeProperty('display'); d.close(); } });
    });
    if (content) content.addEventListener('scroll', () => { if (!mq(DESKTOP)) content.dataset.expanded = 'true'; }, { capture: true });
    d.addEventListener('click', e => {
      if (e.target !== d || !d.open) return;
      if (content) { DMES.dialog.closeAll(); return; }
      if (closedby !== 'any' || hasClosedBy) return;
      const r = d.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) requestClose(d);
    });
    if (d.open) { DMES.scrollLock.add(d); syncBackdrop(); }
  });

  // disparadores (commandfor / command), como DialogTrigger y DialogDismiss
  document.addEventListener('click', e => {
    const b = e.target.closest && e.target.closest('[commandfor]');
    if (!b || b.disabled) return;
    const d = document.getElementById(b.getAttribute('commandfor')), cmd = b.getAttribute('command');
    if (!(d instanceof HTMLDialogElement) || !d.matches('.es dialog')) return;
    if (b.dataset.control === 'back') d.dataset.panelNestedClose = 'true';
    if (cmd === 'show-modal') { e.preventDefault(); if (d.open) d.close('re-show'); d.showModal(); }
    else if (!hasCommand) { e.preventDefault(); if (cmd === 'request-close') requestClose(d, b.value); else if (cmd === 'close') d.close(b.value); }
  }, true);
}

/* ═══ 10-video.js ═══ */
/* ───────── video (AssetVideo / AssetArtDirectedVideo de España) ─────────
   - autoplay solo si no hay «reducir movimiento» ni ahorro de datos; se reproduce al entrar ≥30 % en pantalla y se pausa al salir
   - al reproducirse uno, se pausan los demás videos de la página
   - con dos videos (vertical/horizontal) actúa sobre el de la orientación actual
   Marcado: .es-asset__videoWrapper[data-dm-video] con <template data-dm-icon="play|pause|audio|audio-slashed|play-big"> */
{
  const videos = new Set();
  const autoplayAllowed = () => !reduced() && !(navigator.connection && navigator.connection.saveData);
  DMES.on('[data-dm-video]', w => {
    const vids = $$('video', w);
    if (!vids.length) return;
    const vp = $('.es-asset__videoPortrait', w), vl = $('.es-asset__videoLandscape', w);
    const both = !!(vp && vl), auto = autoplayAllowed();
    const toggle = $('.es-asset__videoToggleArea', w), status = $('.es-asset__videoStatusIcons', w);
    const [bPlay, bAudio] = $$('.es-asset__iconButton', w);
    const icon = n => { const t = $(`template[data-dm-icon="${n}"]`, w); return t ? t.content.firstElementChild.cloneNode(true) : document.createTextNode(''); };
    let playing = false, muted = true, started = auto, overlay = null;
    const active = () => (both ? (mq('(orientation: portrait)') ? vp : vl) : vids[0]);
    const play = () => { const a = active(); if (a) a.play().catch(() => {}); };
    const flip = () => { if (playing) { vids.forEach(v => v.pause()); return; } play(); };
    const render = () => {
      bPlay.setAttribute('aria-label', playing ? bPlay.dataset.dmLabelPause : bPlay.dataset.dmLabelPlay);
      bPlay.replaceChildren(icon(playing ? 'pause' : 'play'));
      bAudio.setAttribute('aria-label', muted ? bAudio.dataset.dmLabelUnmute : bAudio.dataset.dmLabelMute);
      bAudio.replaceChildren(icon(muted ? 'audio-slashed' : 'audio'));
      const needOverlay = !auto && !started;     // sin autoplay: póster con botón de reproducir en vez del área de clic
      if (needOverlay && !overlay) {
        overlay = document.createElement('button');
        overlay.type = 'button'; overlay.className = 'es-asset__playOverlay'; overlay.setAttribute('aria-label', bPlay.dataset.dmLabelPlay);
        const img = (v, cls) => { if (!v || !v.poster) return; const i = new Image(); i.alt = ''; i.className = cls; i.sizes = '100vw'; i.src = v.poster; i.style.cssText = 'position:absolute;height:100%;width:100%;left:0;top:0;right:0;bottom:0;color:transparent'; overlay.append(i); };
        if (both) { img(vp, 'es-asset__coverImagePortrait'); img(vl, 'es-asset__coverImageLandscape'); } else img(vids[0], 'es-asset__coverImage');
        overlay.append(icon('play-big'));
        overlay.addEventListener('click', play);
        toggle.remove(); w.append(overlay);
      } else if (!needOverlay && overlay) { overlay.remove(); overlay = null; status.before(toggle); }
    };
    vids.forEach(v => {
      videos.add(v);
      v.addEventListener('play', () => { videos.forEach(o => { if (o !== v && !o.paused) o.pause(); }); playing = true; started = true; render(); });
      v.addEventListener('pause', () => { playing = false; render(); });
      if (auto) new IntersectionObserver(([e]) => { if (e) e.isIntersecting ? v.play().catch(() => {}) : v.pause(); }, { threshold: 0.3 }).observe(v);
    });
    toggle.addEventListener('click', flip);
    bPlay.addEventListener('click', flip);
    bAudio.addEventListener('click', () => { muted = !muted; vids.forEach(v => { v.muted = muted; }); render(); });
    // el hero arranca su video antes de que cargue este archivo (sections/dm-hero.liquid): tomar ese estado
    if (vids.some(v => !v.paused)) { playing = true; started = true; }
    render();
  });
}

/* ═══ 12-usp-bar.js ═══ */
/* ───────── barra de avisos superior (UspBar de drmartens.com, igual a UK/España) ─────────
   Marcado: snippets/dm-es-usp-bar.liquid (es-usp-bar__*, mismo árbol que allá; va directo en <body> para que el sticky dure toda la
   página). CSS: assets/dm-es.css (.es-usp-bar__*, :root:has([data-usp-bar]) mueve la barra de escritorio) + es/glue.d/usp-bar.css.
   - botón de cabecera: abre/cierra el desplegable (grid 0fr→1fr + clip-path con --dur-panel/--ease-regular), fondo oscuro con data-active;
     Escape o clic fuera cierran · data-layer-active sube la barra por encima del fondo mientras está abierta
   - data-wrapped: si algún aviso del ticker ocupa 2 líneas la barra mide 2,5 rem (lo mide tickerMeasure, como allá)
   - varios avisos (29-oct-2026): la pista sube un ítem cada 4 s (translateY, 500 ms, como allá) y el aviso saliente se desvanece mientras
     sube (data-active ⇒ opacity); los ítems van duplicados y al llegar al clon del primero vuelve al 0 sin animar, así el bucle no salta.
     Se pausa con el desplegable abierto o la pestaña oculta. Un solo aviso ⇒ sin rotación.
   - esconderse/volver con el header: lo decide es/js/15-nav.js (data-scrolled-down en la raíz), acá no hay scroll. */
{
  DMES.on('[data-usp-bar]', root => {
    const container = $('.es-usp-bar__container', root), header = $('.es-usp-bar__header', root), backdrop = $('.es-usp-bar__backdrop', root);
    const outer = $('.es-usp-bar__dropdownOuter', root), inner = $('.es-usp-bar__dropdownInner', root), measure = $('.es-usp-bar__tickerMeasure', root);
    const track = $('.es-usp-bar__tickerTrack', root);
    if (!container || !header || !outer || !inner) return;
    const wrap = () => {
      const lines = Math.max(1, ...(measure ? $$('.es-usp-bar__tickerText', measure) : []).map(t => Math.round(t.getBoundingClientRect().height / (parseFloat(getComputedStyle(t).lineHeight) || 20))));
      const v = lines > 1 ? 'true' : 'false'; container.setAttribute('data-wrapped', v);
      if (lines > 1) root.setAttribute('data-wrapped', 'true'); else root.removeAttribute('data-wrapped');   // en la raíz sólo si envuelve (así la barra mide 2,5 rem en celular, como allá)
    };
    wrap(); window.addEventListener('resize', wrap);
    inner.style.minHeight = '0';
    let closeT = null;
    const set = open => {
      header.setAttribute('aria-expanded', open ? 'true' : 'false');
      const d = reduced() ? '0s' : 'var(--dur-panel)';
      outer.style.transition = `grid-template-rows ${d} var(--ease-regular)`; inner.style.transition = `clip-path ${d} var(--ease-regular)`;
      if (closeT) { clearTimeout(closeT); closeT = null; }
      if (open) {
        container.setAttribute('data-open', 'true'); container.setAttribute('data-layer-active', 'true'); root.setAttribute('data-layer-active', 'true');
        if (backdrop) backdrop.setAttribute('data-active', 'true');
        outer.style.gridTemplateRows = '1fr'; inner.style.clipPath = 'inset(0px)';
      } else {
        container.removeAttribute('data-open'); if (backdrop) backdrop.removeAttribute('data-active');
        outer.style.gridTemplateRows = '0fr'; inner.style.clipPath = 'inset(0px 0px 100%)';
        closeT = setTimeout(() => { container.removeAttribute('data-layer-active'); root.removeAttribute('data-layer-active'); }, reduced() ? 0 : 460);
      }
    };
    header.addEventListener('click', () => set(header.getAttribute('aria-expanded') !== 'true'));
    if (backdrop) backdrop.addEventListener('click', () => set(false));
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && header.getAttribute('aria-expanded') === 'true') set(false); });

    /* rotación del ticker */
    const items = track ? $$('.es-usp-bar__tickerItem', track) : [];
    const n = items.filter(i => i.getAttribute('aria-hidden') !== 'true').length;
    if (!track || n < 2 || items.length !== 2 * n) return;
    let k = 0, resetting = false;
    const paint = () => items.forEach((it, i) => it.setAttribute('data-active', i % n === k % n ? 'true' : 'false'));   // el ítem y su clon comparten estado: el salto al 0 no parpadea
    const move = animate => {
      track.style.transitionDuration = animate && !reduced() ? '500ms' : '0ms';
      track.style.transform = `translateY(calc(-1 * var(--ticker-item-height) * ${k}))`;
      paint();
    };
    const step = () => {
      if (document.hidden || resetting || header.getAttribute('aria-expanded') === 'true') return;
      k += 1; move(true);
      if (k !== n) return;
      resetting = true;
      let guard = null;
      const done = e => {
        if (e && (e.target !== track || e.propertyName !== 'transform')) return;   // las opacidades de los ítems también disparan transitionend
        track.removeEventListener('transitionend', done); clearTimeout(guard);
        k = 0; move(false); resetting = false;
      };
      if (reduced()) { done(); return; }
      track.addEventListener('transitionend', done);
      guard = setTimeout(() => { if (resetting) done(); }, 800);   // seguro por si no llega transitionend
    };
    paint(); setInterval(step, 4000);
  });
}

/* ═══ 15-nav.js ═══ */
/* ───────── navegación (NavBarClient + ScrollBehaviorProvider + FocusOn de España: js_legible/2vura5dfhfd7v.js y 0jrg4k82j6xzh.js) ─────────
   Marcado: sections/dm-header.liquid (raíz `.es[data-dm-nav]`). Este archivo mueve los mismos atributos que React:
     nav escritorio   data-scrolled-down · data-above-fold · data-at-top · data-deep · data-menu-open
     panel/tarjetas   data-active · aria-hidden · inert · clip-path escalonado (abre speed 1.2 / tramos 12vh; cambios internos speed 2 / 10vh)
     barra móvil      data-scrolled-down · data-initial-animation · botón menú (data-icon-background, aria-expanded, ícono menú/cerrar)
     logo móvil       data-over-hero · data-hidden · data-menu-active · data-initial-animation · data-interactive
     fondo            .es-nav-bar__backdrop[data-active]
     FocusOn          guardas de foco (tabindex), data-focus-lock-disabled, body[data-scroll-locked] + hoja de estilos, aria-hidden +
                      data-focus-on-hidden en todo lo que queda fuera del menú (algoritmo de la librería aria-hidden)
   Reglas de scroll (ScrollBehaviorProvider): baja >5 px → «scrolled down»; sube >5 px → vuelve; «above fold» = scrollY < alto de ventana;
   «at top» = scrollY < 5; el logo móvil además se esconde tras 4 s sin scroll (España declara 8 s en la primera página de la sesión, pero
   lee la marca después de grabarla: en la práctica son 4 s siempre, y así se replica).
   Propio (no existe en España): el ícono de la bolsa abre el drawer de carrito de Horizon y el contador se refresca con sus eventos. */
{
  const NAV_INTRO_KEY = 'dm-mobile-nav-intro-played';
  const ss = { get: k => { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } }, set: (k, v) => { try { window.sessionStorage.setItem(k, v); } catch (e) {} } };
  const flag = (e, k, v) => { if (e) { const s = v ? 'true' : 'false'; if (e.getAttribute(k) !== s) e.setAttribute(k, s); } };
  const opt = (e, k, v) => { if (e) { if (v) { if (e.getAttribute(k) !== 'true') e.setAttribute(k, 'true'); } else if (e.hasAttribute(k)) e.removeAttribute(k); } };
  const inert = (e, v) => { if (e) { if (v) { if (!e.hasAttribute('inert')) e.setAttribute('inert', ''); } else if (e.hasAttribute('inert')) e.removeAttribute('inert'); } };
  const clip = (e, v) => { if (e) e.style.clipPath = v; };
  const kill = (...t) => t.forEach(x => x && x.kill());

  // runNavPanelReveal(e, i, instant): muestra e (recorte inferior alto→0) y oculta i (recorte superior 0→alto) a la vez
  const reveal = (e, i, instant = false) => {
    if (!e || !i || reduced() || instant) { clip(e, 'inset(0 0 0 0)'); clip(i, 'inset(0 0 100% 0)'); return null; }
    const { stepPx, moveMs, pauseMs } = DMES.timing({ speed: 2, chunkVh: 10, moveMs: 12, pauseMs: 90 }), H = window.innerHeight;
    const a = DMES.stepped({ el: e, start: H, end: 0, stepPx, moveMs, pauseMs, vars: v => ({ clipPath: `inset(0 0 ${v}px 0)` }) });
    const b = DMES.stepped({ el: i, start: 0, end: H, stepPx, moveMs, pauseMs, vars: v => ({ clipPath: `inset(${v}px 0 0 0)` }) });
    return { kill() { a.kill(); b.kill(); } };
  };

  /* ── FocusOn (react-focus-on = focus-lock + remove-scroll + aria-hidden) ── */
  const FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type=hidden]),select:not([disabled]),textarea:not([disabled]),summary,[tabindex]:not([tabindex="-1"])';
  const LOC_ID = 'localization-panel';
  // react-remove-scroll-bar (gapMode "margin"): una hoja + contador en body[data-scroll-locked]
  let barStyle = null, barCount = 0, hidStyle = null, hidCount = 0;
  const lockScroll = () => {
    if (barCount++ === 0) {
      const cs = getComputedStyle(document.body), n = v => parseInt(v || '', 10) || 0;
      const left = n(cs.marginLeft), top = n(cs.marginTop), right = n(cs.marginRight), gap = Math.max(0, window.innerWidth - document.documentElement.clientWidth + right - left);
      barStyle = document.createElement('style');
      barStyle.textContent = `\n  .with-scroll-bars-hidden {\n   overflow: hidden !important;\n   padding-right: ${gap}px !important;\n  }\n  body[data-scroll-locked] {\n    overflow: hidden !important;\n    overscroll-behavior: contain;\n    position: relative !important;\n    padding-left: ${left}px;\n    padding-top: ${top}px;\n    padding-right: ${right}px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ${gap}px !important;\n    \n  }\n  \n  .right-scroll-bar-position {\n    right: ${gap}px !important;\n  }\n  \n  .width-before-scroll-bar {\n    margin-right: ${gap}px !important;\n  }\n  \n  .right-scroll-bar-position .right-scroll-bar-position {\n    right: 0 !important;\n  }\n  \n  .width-before-scroll-bar .width-before-scroll-bar {\n    margin-right: 0 !important;\n  }\n  \n  body[data-scroll-locked] {\n    --removed-body-scroll-bar-size: ${gap}px;\n  }\n`;
      document.head.append(barStyle);
    }
    document.body.setAttribute('data-scroll-locked', String((parseInt(document.body.getAttribute('data-scroll-locked') || '0', 10) || 0) + 1));
  };
  const unlockScroll = () => {
    const c = (parseInt(document.body.getAttribute('data-scroll-locked') || '0', 10) || 0) - 1;
    c <= 0 ? document.body.removeAttribute('data-scroll-locked') : document.body.setAttribute('data-scroll-locked', String(c));
    if (--barCount <= 0) { barCount = 0; if (barStyle) barStyle.remove(); barStyle = null; }
  };
  // aria-hidden (hideOthers): desde <body> hacia abajo, todo hijo que no es ancestro de una zona viva queda con data-focus-on-hidden
  // + aria-hidden; las zonas vivas son el candado, sus «shards» y —como en la librería— todo [aria-live] y <script>
  const hideOthers = zones => {
    const body = document.body, marked = [];
    const targets = zones.filter(z => z && body.contains(z)).concat($$('[aria-live], script', body));
    const tset = new Set(targets), keep = new Set();
    const up = e => { if (!e || keep.has(e)) return; keep.add(e); up(e.parentNode); };
    targets.forEach(up);
    const walk = p => {
      if (!p || tset.has(p)) return;
      for (const c of [...p.children]) {
        if (keep.has(c)) { walk(c); continue; }
        const prev = c.getAttribute('aria-hidden'), was = prev !== null && prev !== 'false';
        marked.push([c, was]); c.setAttribute('data-focus-on-hidden', 'true'); if (!was) c.setAttribute('aria-hidden', 'true');
      }
    };
    walk(body);
    if (hidCount++ === 0) { hidStyle = document.createElement('style'); hidStyle.textContent = '\n [data-focus-on-hidden] {\n   pointer-events: none !important;\n }\n'; document.head.append(hidStyle); }
    return () => {
      marked.forEach(([c, was]) => { if (!was) c.removeAttribute('aria-hidden'); c.removeAttribute('data-focus-on-hidden'); });
      if (--hidCount <= 0) { hidCount = 0; if (hidStyle) hidStyle.remove(); hidStyle = null; }
    };
  };
  const locOpen = () => { const d = document.getElementById(LOC_ID); return !!(d && d.open); };
  // un candado = el <div data-focus-lock-disabled> (con sus dos guardas) + zonas hermanas («shards»)
  const focusOn = ({ wrap, shards, onEscape, onOutside }) => {
    const guards = [wrap.previousElementSibling, wrap.nextElementSibling].filter(g => g && g.hasAttribute('data-focus-guard'));
    let active = false, undoHide = null, returnTo = null, touchY = 0;
    const zones = () => [wrap, ...shards()].filter(Boolean);
    const inside = t => t instanceof Node && zones().some(z => z === t || z.contains(t));
    const inDialog = t => !!(t instanceof Element && t.closest('dialog[open]'));
    const tabbables = () => zones().flatMap(z => $$(FOCUSABLE, z)).filter(x => x.tabIndex >= 0 && !x.closest('[inert]') && x.getClientRects().length && getComputedStyle(x).visibility !== 'hidden');
    const onKey = e => {
      if (e.key === 'Escape' || e.keyCode === 27) { if (!e.defaultPrevented && !locOpen()) onEscape(); return; }
      if (e.key !== 'Tab' || inDialog(document.activeElement)) return;
      const f = tabbables(); e.preventDefault(); if (!f.length) return;
      const i = f.indexOf(document.activeElement);
      f[e.shiftKey ? (i <= 0 ? f.length - 1 : i - 1) : (i === -1 || i === f.length - 1 ? 0 : i + 1)].focus({ preventScroll: true });
    };
    const onFocusIn = e => { if (inside(e.target) || inDialog(e.target)) return; const f = tabbables(); if (f.length) f[0].focus({ preventScroll: true }); };
    const onDown = e => {
      if (e.type === 'touchstart') touchY = e.touches[0] ? e.touches[0].clientY : 0;
      if (e.defaultPrevented || (e instanceof MouseEvent && e.button !== 0)) return;
      if (inside(e.target) || inDialog(e.target) || locOpen()) return;
      onOutside();
    };
    // react-remove-scroll: la rueda/arrastre solo mueve lo que tiene scroll dentro del menú; afuera no pasa nada
    const canScroll = (t, dy) => {
      const z = zones();
      for (let n = t; n instanceof Element && n !== document.body; n = n.parentElement) {
        const oy = getComputedStyle(n).overflowY;
        if ((oy === 'auto' || oy === 'scroll') && n.scrollHeight > n.clientHeight + 1 && (dy > 0 ? n.scrollTop + n.clientHeight < n.scrollHeight - 1 : n.scrollTop > 0)) return true;
        if (z.includes(n)) break;
      }
      return false;
    };
    const onWheel = e => { if (e.cancelable && !inDialog(e.target) && (!inside(e.target) || !canScroll(e.target, e.deltaY))) e.preventDefault(); };
    const onTouchMove = e => {
      if (!e.cancelable || e.touches.length !== 1 || inDialog(e.target)) return;
      if (!inside(e.target) || !canScroll(e.target, touchY - e.touches[0].clientY)) e.preventDefault();
    };
    return {
      on() {
        if (active) return; active = true;
        const ae = document.activeElement; returnTo = ae && ae !== document.body ? ae : null;
        guards.forEach(g => g.setAttribute('tabindex', '0')); wrap.setAttribute('data-focus-lock-disabled', 'false');
        lockScroll(); undoHide = hideOthers(zones());
        document.addEventListener('keydown', onKey); document.addEventListener('focusin', onFocusIn);
        document.addEventListener('mousedown', onDown); document.addEventListener('touchstart', onDown, { passive: true });
        document.addEventListener('wheel', onWheel, { passive: false }); document.addEventListener('touchmove', onTouchMove, { passive: false });
        if (!inside(document.activeElement)) { const f = tabbables(); if (f.length) f[0].focus({ preventScroll: true }); }      // autoFocus
      },
      off() {
        if (!active) return; active = false;
        document.removeEventListener('keydown', onKey); document.removeEventListener('focusin', onFocusIn);
        document.removeEventListener('mousedown', onDown); document.removeEventListener('touchstart', onDown);
        document.removeEventListener('wheel', onWheel); document.removeEventListener('touchmove', onTouchMove);
        if (undoHide) undoHide(); undoHide = null; unlockScroll();
        guards.forEach(g => g.setAttribute('tabindex', '-1')); wrap.setAttribute('data-focus-lock-disabled', 'disabled');
        const r = returnTo; returnTo = null;
        if (r && r.isConnected && !inDialog(document.activeElement)) Promise.resolve().then(() => r.focus());                        // returnFocus
      },
    };
  };

  DMES.on('[data-dm-nav]', root => {
    const isHome = root.dataset.dmHome === 'true', isPdp = root.dataset.dmPdp === 'true';
    const q = s => $(s, root), qa = s => $$(s, root);
    const el = {
      mnav: q('.es-nav-bar-mobile__nav'), closedLogo: q('.es-nav-bar-mobile__closedLogo'), mmenu: q('aside[data-nav-mobile-overlay]'),
      links: q('.es-nav-bar-desktop__overlayLinks'), nav: q('.es-nav-bar-desktop__nav'), logo: q('.es-nav-bar-desktop__logo'),
      overlay: q('aside[data-nav-desktop-overlay]'), cards: q('.es-nav-bar-desktop__cards'), intro: q('.es-nav-bar-desktop__desktopIntroLogo'), backdrop: q('.es-nav-bar__backdrop'),
    };
    const menuBtn = el.mnav && $('button[aria-expanded]', el.mnav);
    if (!el.nav || !el.mnav || !el.links || !el.overlay || !el.cards || !el.mmenu || !menuBtn) return;
    const navLinks = $('.es-nav-bar-desktop__links', el.nav);
    const contents = qa('.es-nav-bar-desktop__overlayContent');
    const cardContents = qa('.es-nav-bar-desktop__cardContent');
    const panelsOf = c => (c ? $$(':scope > .es-nav-bar-desktop__overlayPanel', c) : []);
    const cardEl = k => cardContents.find(c => c.dataset.dmCards === k) || null;
    const mpanels = {}; qa('.es-menu__panel').forEach(p => { mpanels[p.dataset.dmPanel] = p; });
    const searchDialog = document.getElementById('search-panel');
    const uspBar = $('[data-usp-bar]');   // snippets/dm-es-usp-bar.liquid (sólo CL; null en AR/MX)

    /* estado (mismos nombres de rol que en España) */
    const S = {
      scrolledDown: false, idleHidden: false, overHero: true, atTop: true, restoring: false,   // ScrollBehaviorProvider
      D: false, EA: false,                 // menú móvil: abierto · activo (sigue true mientras se cierra)
      O: null, A: null, W: false,          // escritorio: ítem activo · ítem mostrado · panel visible
      sub: null,                           // subnivel abierto (clave del ítem de nivel 1)
      Z: null, EN: false,                  // tarjetas: clave · visibles
      mkey: 'root',                        // panel del menú móvil
      overHeroLogo: !!el.closedLogo, footerLogo: false, introPending: false,
    };
    const P = { D: false, open: false, hasCards: false, dispA: null, cardKey: null, e2Z: null, e2EN: false, enA: null, erDeep: false, e3sub: null, e3A: null, em: null, mprev: 'root', lockDesk: false, lockMob: false, V: NaN, everActive: false };
    const T = {};
    const deskLock = focusOn({ wrap: el.links.parentElement, shards: () => [el.cards, document.getElementById(LOC_ID)], onEscape: () => closeAll(), onOutside: () => closeAll() });
    const mobLock = focusOn({ wrap: el.mmenu.parentElement, shards: () => [el.mnav, document.getElementById(LOC_ID)], onEscape: () => closeAll(), onOutside: () => closeAll() });

    const fillDeep = () => {     // el nivel profundo se renderiza al abrir (y es el mismo en todos los contenidos, como en España)
      contents.forEach(c => {
        const deep = panelsOf(c)[1]; if (!deep) return;
        [...deep.children].forEach((ch, i) => { if (i > 0) ch.remove(); });
        if (S.sub === null) return;
        const t = $(`template[data-dm-sub="${S.sub}"]`, el.overlay);
        if (t) deep.append(t.content.cloneNode(true));
      });
    };

    const render = () => {
      const open = S.O !== null, deep = S.sub !== null, hiddenLogo = S.scrolledDown || S.idleHidden;
      // escritorio
      opt(el.links, 'data-active', open); opt(el.links, 'data-deep', deep); flag(el.links, 'data-at-top', S.atTop); flag(el.links, 'aria-hidden', !open); inert(el.links, !open);
      for (const list of [el.links, navLinks]) $$('button', list).forEach((b, i) => { flag(b, 'data-active', S.O === i); flag(b, 'aria-expanded', S.O === i); });
      flag(el.nav, 'data-scrolled-down', S.scrolledDown); flag(el.nav, 'data-above-fold', S.overHero || open || S.W); flag(el.nav, 'data-at-top', S.atTop); flag(el.nav, 'data-deep', deep); flag(el.nav, 'data-menu-open', open);
      flag(uspBar, 'data-scrolled-down', S.scrolledDown && !open && !S.D);   // la huincha de avisos (CL) se esconde y vuelve con el header (es/glue.d/usp-bar.css)
      if (el.logo) { flag(el.logo, 'data-overlay', open); if (open) { if (el.logo.getAttribute('tabindex') !== '-1') el.logo.setAttribute('tabindex', '-1'); } else if (el.logo.hasAttribute('tabindex')) el.logo.removeAttribute('tabindex'); }
      flag(el.overlay, 'data-active', S.W); flag(el.overlay, 'data-deep', deep); flag(el.overlay, 'data-at-top', S.atTop); flag(el.overlay, 'aria-hidden', !S.W); inert(el.overlay, !S.W);
      contents.forEach((c, i) => {
        const on = S.W && S.A === i; flag(c, 'data-active', on); flag(c, 'aria-hidden', !on); inert(c, !on);
        const [p0, p1] = panelsOf(c);
        flag(p0, 'data-active', !deep); flag(p0, 'aria-hidden', deep); inert(p0, deep);
        flag(p1, 'data-active', deep); flag(p1, 'aria-hidden', !deep); inert(p1, !deep);
        $$('button[data-dm-sub]', p0).forEach(b => flag(b, 'aria-expanded', S.sub === b.dataset.dmSub));
      });
      flag(el.cards, 'data-active', S.EN); flag(el.cards, 'data-at-top', S.atTop); flag(el.cards, 'aria-hidden', !S.EN); inert(el.cards, !S.EN);
      cardContents.forEach(c => { const on = S.EN && S.Z === c.dataset.dmCards; flag(c, 'data-active', on); flag(c, 'aria-hidden', !on); inert(c, !on); });
      flag(el.backdrop, 'data-active', S.D || S.EA || open || S.W || S.EN);
      // móvil
      if (S.EA || S.footerLogo) P.everActive = true;
      const entry = !P.everActive && S.introPending && !S.EA;     // animación de entrada: solo la primera página de la sesión
      flag(el.mnav, 'data-scrolled-down', hiddenLogo && !S.D); flag(el.mnav, 'data-initial-animation', entry);
      flag(menuBtn, 'data-icon-background', S.D); flag(menuBtn, 'aria-expanded', S.D);
      const use = $('use', menuBtn), ttl = $('title', menuBtn), href = S.D ? '#_RI-close' : '#_RI-menu';
      if (use && use.getAttribute('href') !== href) { use.setAttribute('href', href); if (ttl) ttl.textContent = S.D ? 'Close' : 'Menu'; }
      flag(el.mmenu, 'data-active', S.EA); flag(el.mmenu, 'aria-hidden', !S.EA); inert(el.mmenu, !S.EA);
      for (const [k, p] of Object.entries(mpanels)) { const on = S.mkey === k; flag(p, 'data-active', on); flag(p, 'aria-hidden', !on); inert(p, !on); }
      $$('button[data-dm-sub]', mpanels.root).forEach(b => flag(b, 'aria-expanded', S.mkey === b.dataset.dmSub));
      if (el.closedLogo) {
        const hid = S.footerLogo || S.restoring || hiddenLogo;
        flag(el.closedLogo, 'data-over-hero', S.overHeroLogo); flag(el.closedLogo, 'data-hidden', hid); flag(el.closedLogo, 'data-menu-active', S.EA);
        flag(el.closedLogo, 'data-initial-animation', entry); flag(el.closedLogo, 'data-interactive', !hid);
      }
    };

    /* efectos (en el orden en que corren allá: contenidos → tarjetas → paneles → animación general → foco) */
    const effects = () => {
      // E1 · contenido mostrado (VER ↔ DESCUBRIR)
      if (S.A !== P.dispA) {
        kill(T.contents);
        const prev = P.dispA, t = S.A !== null ? contents[S.A] : null, n = prev !== null ? contents[prev] : null;
        contents.forEach((c, i) => { if (i !== S.A && i !== prev) clip(c, 'inset(0 0 100% 0)'); });
        T.contents = reveal(t, n); P.dispA = S.A;
        if (S.A !== null) requestAnimationFrame(() => { const f = contents[S.A] && contents[S.A].querySelector("button, a, [tabindex]:not([tabindex='-1'])"); if (f) f.focus({ preventScroll: true }); });
      }
      // E2 · tarjetas mostradas
      if (S.Z !== P.e2Z || S.EN !== P.e2EN) {
        P.e2Z = S.Z; P.e2EN = S.EN; kill(T.cardSwap);
        const prev = P.cardKey, t = S.Z ? cardEl(S.Z) : null, n = prev ? cardEl(prev) : null;
        if (!S.Z) { if (!S.EN && n) { clip(n, 'inset(0 0 100% 0)'); P.cardKey = null; } }
        else { cardContents.forEach(c => { if (c.dataset.dmCards !== S.Z && c.dataset.dmCards !== prev) clip(c, 'inset(0 0 100% 0)'); }); T.cardSwap = reveal(t, n); P.cardKey = S.Z; }
      }
      // E3 · nivel 1 ↔ nivel profundo dentro del contenido mostrado
      if (S.sub !== P.e3sub || S.A !== P.e3A) {
        P.e3sub = S.sub; P.e3A = S.A; kill(T.panels);
        if (S.A === null) { P.erDeep = false; P.enA = null; }
        else {
          const [e, t] = panelsOf(contents[S.A]);
          if (e && t) {
            const n = S.sub !== null, r = S.A !== P.enA, a = n ? t : e, i = n ? e : t;
            if (r && P.enA !== null) { const [x, y] = panelsOf(contents[P.enA]); clip(x, 'inset(0 0 0 0)'); clip(y, 'inset(0 0 100% 0)'); }
            T.panels = reveal(a, i, r || n === P.erDeep); P.enA = S.A; P.erDeep = n;
          }
        }
      }
      // animación general (móvil, panel de escritorio, capa de tarjetas)
      const n = S.O !== null, r = S.Z !== null, a = P.D !== S.D, o = P.open !== n, i = P.hasCards !== r;
      P.D = S.D; P.open = n; P.hasCards = r;
      if (a || o || i) {
        kill(T.mobile, T.overlay, T.cards);
        const red = reduced(), tm = DMES.timing({ speed: DMES.SPEED, chunkVh: DMES.CHUNK_VH, moveMs: DMES.MOVE_MS, pauseMs: DMES.PAUSE_MS });
        if (a) {
          const e = el.mmenu; if (S.D) S.EA = true;
          const h = e.offsetHeight;
          if (h === 0) { e.style.removeProperty('clip-path'); P.V = NaN; if (!S.D) S.EA = false; }
          else {
            const start = Number.isFinite(P.V) ? P.V : h, end = S.D ? 0 : h;
            if (red) { clip(e, S.D ? `inset(${end}px 0 0 0)` : 'inset(100% 0 0 0)'); P.V = S.D ? end : NaN; if (!S.D) S.EA = false; }
            else T.mobile = DMES.stepped({ el: e, start, end, ...tm, vars: v => ({ clipPath: `inset(${v}px 0 0 0)` }), onValue: v => { P.V = v; },
              onComplete: S.D ? null : () => { clip(e, 'inset(100% 0 0 0)'); P.V = NaN; S.EA = false; update(); } });
          }
        }
        if (o) {
          const closing = !n, H = window.innerHeight, end = n ? 0 : H;
          if (red) { clip(el.overlay, closing ? 'inset(0 0 100% 0)' : `inset(0 0 ${end}px 0)`); if (closing) { S.W = false; S.A = null; S.sub = null; } }
          else T.overlay = DMES.stepped({ el: el.overlay, start: n ? H : 0, end, ...tm, vars: v => ({ clipPath: `inset(0 0 ${v}px 0)` }),
            onComplete: closing ? () => { clip(el.overlay, 'inset(0 0 100% 0)'); S.W = false; S.A = null; S.sub = null; update(); } : null });
        }
        if (el.cards) {
          if (!r && !i) { clip(el.cards, 'inset(0 0 100% 0)'); S.EN = false; S.Z = null; }
          if (i) {
            const closing = !r, H = window.innerHeight, end = r ? 0 : H;
            if (red) { clip(el.cards, closing ? 'inset(0 0 100% 0)' : `inset(0 0 ${end}px 0)`); if (closing) { S.EN = false; S.Z = null; } }
            else T.cards = DMES.stepped({ el: el.cards, start: r ? H : 0, end, ...tm, vars: v => ({ clipPath: `inset(0 0 ${v}px 0)` }),
              onComplete: closing ? () => { clip(el.cards, 'inset(0 0 100% 0)'); S.EN = false; S.Z = null; update(); } : null });
          }
        }
      }
      // menú móvil: al quedar inactivo vuelve al panel raíz; panel raíz ↔ subpaneles
      if (!S.EA && !S.D && S.mkey !== 'root') { S.mkey = 'root'; P.mprev = 'root'; }
      if (S.mkey !== P.mshown) {
        kill(T.mpanels);
        const e = mpanels[S.mkey], prev = P.mprev, nn = prev !== S.mkey ? mpanels[prev] || null : null;
        if (e) { for (const [k, p] of Object.entries(mpanels)) if (k !== S.mkey && k !== prev) clip(p, 'inset(0 0 100% 0)'); T.mpanels = reveal(e, nn); P.mprev = S.mkey; }
        P.mshown = S.mkey;
      }
      // FocusOn (escritorio: activo mientras hay ítem activo · móvil: mientras el menú está abierto)
      const lockDesk = S.O !== null, lockMob = S.D;
      if (lockDesk !== P.lockDesk) { P.lockDesk = lockDesk; lockDesk ? deskLock.on() : deskLock.off(); }
      if (lockMob !== P.lockMob) { P.lockMob = lockMob; lockMob ? mobLock.on() : mobLock.off(); }
    };

    function update() {
      if (!root.isConnected) return;       // la sección se volvió a renderizar (editor de temas): esta instancia ya no manda
      // tarjetas: las del subnivel abierto (onCardsItemChange)
      const em = S.O !== null && S.sub !== null && cardEl(S.sub) ? S.sub : null;
      if (em !== P.em) { P.em = em; S.Z = em; if (em) S.EN = true; }
      if (S.sub !== P.filled) { P.filled = S.sub; fillDeep(); }
      render(); effects(); render();
    }
    function closeAll() { if (!S.D && S.O === null && S.Z === null) return; S.D = false; S.O = null; S.Z = null; update(); }

    /* clics */
    const onRoot = i => { const t = S.O === i ? null : i; S.O = t; if (t !== null) { if (S.A !== t) { S.A = t; S.sub = null; } S.W = true; } S.Z = null; update(); };
    for (const list of [el.links, navLinks]) $$('button', list).forEach((b, i) => b.addEventListener('click', () => onRoot(i)));
    el.overlay.addEventListener('click', e => {
      const b = e.target.closest('button[data-dm-sub], .es-nav-bar-desktop__backButton, a[href]');
      if (!b) return;
      if (b.matches('button[data-dm-sub]')) { S.sub = b.dataset.dmSub; update(); }
      else if (b.matches('.es-nav-bar-desktop__backButton')) { S.sub = null; update(); }
      else closeAll();
    });
    el.cards.addEventListener('click', e => { if (e.target.closest('a[href]')) closeAll(); });
    menuBtn.addEventListener('click', () => { S.D = !S.D; update(); });
    el.mmenu.addEventListener('click', e => {
      const b = e.target.closest('button[data-dm-sub], .es-menu__backButton, a[href]');
      if (!b) return;
      if (b.matches('button[data-dm-sub]')) { S.mkey = b.dataset.dmSub; update(); }
      else if (b.matches('.es-menu__backButton')) { S.mkey = 'root'; update(); }
      else closeAll();
    });
    // buscar (SearchPanelTrigger): abre el panel; en la página de búsqueda lleva el foco a su campo
    const plain = e => !e.defaultPrevented && e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey;
    qa('[data-dm-search]').forEach(a => a.addEventListener('click', e => {
      if (a.tagName === 'BUTTON') {      // en la página de resultados: foco al campo de esa página (allá #search-page-input; hoy, el de Horizon)
        const i = document.getElementById('search-page-input') || document.querySelector('main input[type="search"], main input[name="q"]');
        if (i instanceof HTMLInputElement) { i.focus(); i.select(); }
        closeAll(); return;
      }
      if (!plain(e) || !searchDialog) return;
      e.preventDefault(); closeAll(); DMES.dialog.show(searchDialog);
    }));
    // barra móvil: cualquier enlace (carrito, cuenta) cierra el menú
    el.mnav.addEventListener('click', e => { if (e.target.closest('a[href]') && !e.target.closest('[data-dm-search]')) closeAll(); });

    /* carrito: como en España no hay cajón; la bolsa es un enlace normal a la página /cart (sections/dm-cart.liquid). El cajón de Horizon
       sigue en el theme (oculto en .dm-header__hidden-actions) pero ya no se abre desde acá.
       El contador es el CartCountBadge de España (se crea con ≥1, data-multi-digit desde 10, se quita en 0) */
    const cartLinks = qa('[data-dm-cart]');
    const setCount = n => cartLinks.forEach(a => {
      const swap = a.closest('.es-cart-wishlist-icon__cartSwap'), host = swap || a;
      let b = $(':scope > .es-cart-count-badge__badge', host);
      if (!(n > 0)) { if (b) b.remove(); return; }
      if (!b) {
        b = document.createElement('span'); b.className = swap ? 'es-cart-count-badge__badge es-cart-wishlist-icon__countBadge' : 'es-cart-count-badge__badge';
        b.setAttribute('aria-hidden', 'true'); swap ? swap.append(b) : a.insertBefore(b, $('.es-sr-only__container', a));
      }
      if (n >= 10) b.setAttribute('data-multi-digit', 'true'); else b.removeAttribute('data-multi-digit');
      if (b.textContent !== String(n)) b.textContent = String(n);
    });
    let cartSeq = 0;
    const refreshCount = () => {
      const k = ++cartSeq, base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(`${base}cart.js`, { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(r => r.json())
        .then(c => { if (k === cartSeq && c && typeof c.item_count === 'number') setCount(c.item_count); }).catch(() => {});
    };
    document.addEventListener('cart:update', refreshCount);
    window.addEventListener('pageshow', e => { if (e.persisted) refreshCount(); });
    const bubble = document.querySelector('.dm-header__hidden-actions .cart-bubble__text');
    if (bubble) new MutationObserver(refreshCount).observe(bubble, { childList: true, subtree: true, characterData: true });

    /* scroll (ScrollBehaviorProvider) */
    let lastY = window.scrollY, idleT = null;
    const introWasPlayed = ss.get(NAV_INTRO_KEY) === 'true';
    // wasNavIntroAlreadyPlayed de España: se lee (y se fija) la primera vez que se arma el temporizador, que allá corre DESPUÉS de
    // markNavIntroPlayed ⇒ en la práctica el logo móvil se esconde a los 4 s también en la primera página (medido 7-oct)
    let playedCache = null;
    const wasPlayed = () => (playedCache === null ? (playedCache = ss.get(NAV_INTRO_KEY) === 'true') : playedCache);
    const hasDecision = () => { try { const cp = window.Shopify && window.Shopify.customerPrivacy; return !(cp && cp.shouldShowBanner && cp.shouldShowBanner()); } catch (e) { return true; } };
    const setDown = v => { S.idleHidden = false; S.scrolledDown = v; };
    const armIdle = () => {
      clearTimeout(idleT); idleT = null;
      if (isPdp || !hasDecision()) return;
      idleT = setTimeout(() => { if (!hasDecision()) return; S.idleHidden = true; update(); }, wasPlayed() ? 4000 : 8000);
    };
    // el drawer de Horizon bloquea el scroll con body{position:fixed;width:100%} (scrollY salta a 0 y vuelve): no es scroll del usuario
    const horizonLock = () => document.body.style.position === 'fixed' && document.body.style.width === '100%';
    const onScroll = () => {
      if (horizonLock()) return;
      armIdle();
      const y = window.scrollY, t = lastY;
      if (y > t + 5 && y > 0) { Math.abs(y - t) >= 50 ? setDown(y > 5) : setDown(true); }
      else if (y < t - 5) { if (y < 5 && t - y > 10) requestAnimationFrame(() => { if (window.scrollY < 5) { setDown(false); update(); } }); else setDown(false); }
      S.overHero = y < window.innerHeight; S.atTop = y < 5; lastY = y; update();
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('visitorConsentCollected', armIdle);

    /* cambio de punto de quiebre (1024): se reinicia todo, como allá */
    let wasDesktop = document.documentElement.clientWidth >= 1024;
    const onResize = () => {
      const d = document.documentElement.clientWidth >= 1024;
      if (d === wasDesktop) return;
      wasDesktop = d; kill(T.mobile, T.overlay, T.cards);
      clip(el.mmenu, 'inset(100% 0 0 0)'); clip(el.overlay, 'inset(0 0 100% 0)'); clip(el.cards, 'inset(0 0 100% 0)');
      P.V = NaN; P.D = false; P.open = false; P.hasCards = false;
      S.D = false; S.EA = false; S.O = null; S.A = null; S.W = false; S.Z = null; S.EN = false; S.sub = null; update();
    };
    new ResizeObserver(onResize).observe(document.documentElement);
    window.matchMedia(DESKTOP).addEventListener('change', onResize); window.addEventListener('resize', onResize);
    if (window.visualViewport) window.visualViewport.addEventListener('resize', onResize);

    /* logo móvil: sobre el hero (franja a la altura del logo; solo si la página trae [data-mobile-logo-color]) y logo del footer a la vista */
    const logoColor = $('[data-mobile-logo-color]');
    if (el.closedLogo && logoColor) {
      let io = null;
      const arm = () => {
        if (io) io.disconnect();
        if (!el.closedLogo.getClientRects().length) return;
        const bottom = parseFloat(getComputedStyle(el.closedLogo).bottom), t = Math.round(window.innerHeight - bottom - el.closedLogo.offsetHeight / 2);
        io = new IntersectionObserver(es => { const x = es.at(-1); if (x) { S.overHeroLogo = x.isIntersecting; update(); } }, { rootMargin: `${-t}px 0px ${-(window.innerHeight - t - 1)}px 0px` });
        io.observe(logoColor);
      };
      arm(); window.addEventListener('resize', arm);
    } else S.overHeroLogo = false;
    const footLogos = $$('[data-footer-logo]');
    if (footLogos.length) {
      const seen = new Set();
      const io = new IntersectionObserver(es => { for (const x of es) x.isIntersecting ? seen.add(x.target) : seen.delete(x.target); const v = seen.size > 0; if (v !== S.footerLogo) { S.footerLogo = v; update(); } });
      footLogos.forEach(f => io.observe(f));
    }
    // logo de entrada de escritorio: no se muestra si el logo del footer ya está a la vista al cargar
    if (el.intro && isHome && footLogos.some(f => { const r = f.getBoundingClientRect(); return r.height > 0 && r.top < window.innerHeight; })) el.intro.dataset.suppressIntro = 'true';
    // tablet (768–1023): el logo móvil se va hacia abajo a los 0,6 s, una vez (allá gsap.to(logo, {y:'100%', duration .3, delay .6}))
    if (el.closedLogo && !isPdp && mq('(min-width: 768px) and (max-width: 1023px)')) {
      const an = el.closedLogo.animate([{ transform: 'translate(0%, 0%)' }, { transform: 'translate(0%, 100%)' }], { duration: 300, delay: 600, easing: 'cubic-bezier(.45,.02,.09,.98)', fill: 'both' });
      an.finished.then(() => { el.closedLogo.style.transform = 'translate(0%, 100%)'; an.cancel(); }).catch(() => {});
    }

    /* primera página de la sesión: animación de entrada de la barra y el logo móviles (hasNavIntroPlayed / markNavIntroPlayed) */
    S.introPending = !introWasPlayed; ss.set(NAV_INTRO_KEY, 'true');
    S.overHero = window.scrollY < window.innerHeight; S.atTop = window.scrollY < 5;
    // volver atrás / adelante (allá popstate; acá una carga nueva o bfcache): toma el scroll ya restaurado durante 3 cuadros
    const restore = () => {
      if (isPdp) return;
      S.restoring = true; let k = 0;
      const step = () => { const y = window.scrollY; lastY = y; S.overHero = y < window.innerHeight; S.atTop = y < 5; setDown(y > 5); if (++k >= 3) { S.restoring = false; update(); } else { update(); requestAnimationFrame(step); } };
      step();
    };
    window.addEventListener('pageshow', e => { if (e.persisted) restore(); });
    try { const nav = performance.getEntriesByType('navigation')[0]; if (nav && nav.type === 'back_forward') restore(); } catch (e) {}

    armIdle(); update();
    DMES.nav = { state: S, closeAll, update, setCount, refreshCount };
  });
}

/* ═══ 16-search.js ═══ */
/* ───────── panel de búsqueda (SearchPanel de España: js_legible/41rvnxj5yzquj.js · useSuggestions, AutoGrow, SearchHighlightedText,
   useProductListingData y ProductListingGridSkeleton en 2gd49b61todti.js · isValidSearchQuery / SEARCH_INPUT_MIN_CHARACTERS = 3) ─────────
   Marcado: snippets/dm-es-search-panel.liquid (dialog#search-panel; lo abre la lupa, es/js/15-nav.js; abrir/cerrar/animar: 05-panel.js).
   Datos: sections/dm-predictive-search.liquid por la búsqueda predictiva de Shopify. Qué hace, igual que allá:
     campo        el botón del campo es lupa con el campo vacío y «borrar» con texto (vacía la búsqueda); el valor queda también en el atributo value
     sugerencias  con 3 o más caracteres (sin los espacios de los extremos) se piden las del término; mientras llegan, la lista anterior sigue
                  a la vista con data-loading="true"; lo escrito va resaltado palabra a palabra, por prefijo (strong.es-search-panel__highlightedText);
                  elegir una la pone en el campo. La última lista cargada se conserva aunque se borre el texto (keepPreviousData de SWR)
     contenedor   es-auto-grow__container lleva en línea el alto de su contenido (ResizeObserver); la transición es del CSS
     productos    con 3 o más caracteres: grilla esqueleto mientras no hay datos; el término se usa 500 ms después de la última tecla (al tiro
                  si ya se pidió antes); con productos anteriores a la vista la grilla queda con data-loading="true"; 0 productos → estado
                  «sin resultados»; menos de 3 caracteres → nada. «Ver todos los resultados» solo si hay más de los 4 que se muestran
     Enter        con 3 o más caracteres va a /search?q=…&type=product&options[unavailable_products]=last (la URL que espera la página de resultados), cierra el panel y vacía el campo
     analítica    view_search_results { search_term, search_results, section_location: 'search overlay' }, una vez por término cargado
   Distinto de España por el origen de los datos: una sola consulta por término trae sugerencias y productos; sale 150 ms después de la
   última tecla (allá las sugerencias se piden al instante; la búsqueda predictiva de Shopify limita las solicitudes) y el total de
   productos se conoce hasta 5 (4 a la vista + «hay más»). */
{
  const MIN = 3, DEBOUNCE_MS = 500, REQUEST_WAIT_MS = 150;
  const valid = q => typeof q === 'string' && q.length >= MIN;      // isValidSearchQuery
  const loadingAttr = (e, on) => { if (!e) return; if (on) { if (e.getAttribute('data-loading') !== 'true') e.setAttribute('data-loading', 'true'); } else if (e.hasAttribute('data-loading')) e.removeAttribute('data-loading'); };
  // SearchHighlightedText: parte el texto en palabras (\w+) y resalta el comienzo de cada una que calza con un término escrito
  const highlight = (text, sub) => {
    const f = document.createDocumentFragment();
    if (!sub) { f.append(text); return f; }
    const terms = sub.toLowerCase().split(/\s+/).filter(Boolean);
    for (const tok of text.split(/(\w+)/)) {
      const r = tok.toLowerCase(), hit = terms.find(t => r.startsWith(t) || t.startsWith(r));
      if (!hit) { if (tok) f.append(tok); continue; }
      const n = Math.min(tok.length, hit.length), st = document.createElement('strong');
      st.className = 'es-search-panel__highlightedText'; st.textContent = tok.slice(0, n); f.append(st);
      if (tok.length > n) f.append(tok.slice(n));
    }
    return f;
  };

  DMES.on('dialog[data-dm-search-panel]', d => {
    const input = $('#search-panel-input', d), iconBtn = $('.es-input__icon', d), outer = $('.es-search-panel__suggestionsOuter', d), content = $('.es-panel-content__content', d);
    if (!input || !iconBtn || !outer || !content || !outer.firstElementChild) return;
    const inner = outer.firstElementChild;
    const tpl = k => { const t = document.querySelector(`template[data-dm-search-tpl="${k}"]`); return t ? t.content.cloneNode(true) : document.createDocumentFragment(); };
    const searchUrl = d.dataset.dmSearchUrl || '/search', suggestUrl = d.dataset.dmSuggestUrl || '/search/suggest';
    const cache = new Map();                                     // término → { done, data: { term, suggestions, total, node } }
    let q = '', dq = '', debT = null, reqT = null, failed = null;
    let sug = null, res = null;                                  // últimos datos cargados (se conservan mientras llegan los nuevos)
    let slot = null, slotKey = null, lastSent;

    const load = term => {
      let e = cache.get(term); if (e) return e;
      e = { done: false, data: null }; cache.set(term, e); if (failed === term) failed = null;
      const u = new URL(suggestUrl, window.location.origin);
      u.searchParams.set('q', term); u.searchParams.set('resources[type]', 'product,query'); u.searchParams.set('resources[limit]', '5');
      u.searchParams.set('resources[limit_scope]', 'each'); u.searchParams.set('section_id', 'dm-predictive-search');
      fetch(u.toString(), { headers: { Accept: 'text/html' } })
        .then(r => { if (!r.ok) throw new Error(`búsqueda ${r.status}`); return r.text(); })
        .then(html => {
          const root = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-dm-predictive]');
          if (!root) throw new Error('búsqueda: respuesta sin datos');
          let list = []; try { list = JSON.parse($('script[data-dm-part="suggestions"]', root).textContent) || []; } catch (x) { list = []; }
          const t = $('template[data-dm-part="results"]', root);
          e.data = { term, suggestions: list.filter(x => typeof x === 'string' && x).slice(0, 4), total: Number(root.dataset.dmTotal) || 0, node: t ? document.importNode(t.content, true).firstElementChild : null };
          e.done = true;
        })
        .catch(() => { cache.delete(term); failed = term; })
        .then(() => { if (term === q.trim()) { adopt(); render(); } });
      return e;
    };
    const done = term => { const e = cache.get(term); return e && e.done ? e.data : null; };
    // toma los datos del término actual si ya están (sugerencias: al llegar · productos: además pasado el retardo)
    const adopt = () => {
      const s = q.trim(), data = done(s);
      if (!data) return;
      if (s.length >= MIN) sug = data.suggestions;
      if (dq === q && valid(q)) res = data;
    };

    const syncIcon = () => {
      const want = q.length > 0 ? 'clear' : 'search';
      if ((iconBtn.dataset.dmIcon || 'search') === want) return;
      iconBtn.dataset.dmIcon = want; iconBtn.replaceChildren(tpl(`icon-${want}`));
      const label = iconBtn.getAttribute(`data-dm-label-${want}`); if (label) iconBtn.setAttribute('aria-label', label);
    };

    const render = () => {
      const s = q.trim();
      // sugerencias (componente «L» + useSuggestions)
      const sugLoading = s.length >= MIN && !done(s) && failed !== s;
      let ul = $(':scope > ul.es-search-panel__suggestions', inner);
      if (!sug || !sug.length) { if (ul) ul.remove(); }
      else {
        if (!ul) { ul = document.createElement('ul'); ul.className = 'es-search-panel__suggestions'; inner.append(ul); }
        loadingAttr(ul, sugLoading);
        const old = new Map([...ul.children].map(li => [li.dataset.dmKey, li]));       // se reutiliza la fila de cada texto (como las «key» de React)
        const rows = sug.map(label => {
          let li = old.get(label); if (li) old.delete(label); else { li = tpl('suggestion').firstElementChild; li.dataset.dmKey = label; }
          const sig = `${label}\u0001${q}`;
          if (li.dataset.dmSig !== sig) { li.dataset.dmSig = sig; $('button > div', li).replaceChildren(highlight(label, q)); }
          return li;
        });
        old.forEach(li => li.remove());
        rows.forEach((li, i) => { if (ul.children[i] !== li) ul.insertBefore(li, ul.children[i] || null); });
      }
      // productos (componente «V» + useProductListingData)
      const m = valid(q) && s.length > 0;
      const resLoading = dq !== q || (m && !done(s) && failed !== s);
      let mode = null;
      if (m) mode = !res || res.total === 0 ? (resLoading ? 'skeleton' : (res && res.node ? 'empty' : null)) : (res.node ? 'results' : null);
      const key = mode === 'results' || mode === 'empty' ? `${mode}:${res.term}` : mode;
      if (key !== slotKey) {
        if (slot) slot.remove();
        slot = mode === 'skeleton' ? tpl('skeleton').firstElementChild : mode ? res.node.cloneNode(true) : null;
        if (slot) { content.append(slot); DMES.init(slot); }
        slotKey = key;
      }
      if (mode === 'results') loadingAttr($('.es-product-listing-grid__outer', slot), resLoading);
      if (m && !resLoading && res && res.term === s && lastSent !== q) {
        lastSent = q; (window.dataLayer = window.dataLayer || []).push({ search_term: q, search_results: res.total, section_location: 'search overlay', event: 'view_search_results' });
      }
    };

    const setQuery = (v, typed = false) => {
      q = v; if (!typed && input.value !== v) input.value = v;
      if (input.getAttribute('value') !== v) input.setAttribute('value', v);
      syncIcon();
      const s = q.trim();
      clearTimeout(reqT); clearTimeout(debT);
      if (s.length >= MIN && !cache.has(s)) reqT = setTimeout(() => load(s), REQUEST_WAIT_MS);
      // useDebouncedValue(href, 500, yaEstáEnCaché)
      if (done(s)) dq = q;
      else debT = setTimeout(() => { dq = q; if (valid(q) && q.trim() && d.open) load(q.trim()); adopt(); render(); }, DEBOUNCE_MS);
      adopt(); render();
    };

    input.addEventListener('input', () => setQuery(input.value, true));
    input.addEventListener('keydown', e => {
      if (e.key !== 'Enter' || e.isComposing) return;
      e.preventDefault();
      if (!valid(q)) return;
      const url = `${searchUrl}?q=${encodeURIComponent(q)}&type=product&options%5Bunavailable_products%5D=last`;
      DMES.dialog.close(d); setQuery(''); window.location.assign(url);
    });
    iconBtn.addEventListener('click', () => { if (q.length > 0) setQuery(''); });
    inner.addEventListener('click', e => { const b = e.target.closest('button.es-search-panel__suggestionItem'); if (b && b.parentElement.dataset.dmKey) setQuery(b.parentElement.dataset.dmKey); });
    // al abrir: retoma lo que haya en el campo (allá la consulta de productos se habilita solo con el panel abierto)
    d.addEventListener('dm:dialog', e => { if (e.target === d && e.detail && e.detail.open && (input.value !== q || (valid(q) && !done(q.trim())))) setQuery(input.value, true); });
    new ResizeObserver(es => { const x = es[es.length - 1]; if (x) outer.style.height = `${x.contentRect.height}px`; }).observe(inner);
    if (input.value) setQuery(input.value, true);
  });
}

/* ═══ 20-headline.js ═══ */
/* ───────── titular «headline» (Headline de España · js_legible/1s_6-rdlpveo0.js) ─────────
   Cada línea con énfasis es un <svg preserveAspectRatio="none"><text>…</text></svg>: se mide el texto y se ajusta el viewBox para que la línea
   ocupe todo el ancho. La altura de la línea más alta queda en --emphasis-height (la usan las líneas normales) y data-ready="true" lo muestra
   (el CSS lo deja en opacity:0 hasta entonces). Se recalcula al cargar las fuentes y cuando cambia el tamaño del contenedor. */
{
  DMES.on('.es-headline__headline', el => {
    let raf = 0;
    const measure = () => {
      let max = 0;
      el.querySelectorAll('svg').forEach(svg => {
        const text = svg.querySelector('text');
        let b = null;
        try { b = text && text.getBBox(); } catch (e) { b = null; }
        if (!b) return;
        const w = 0.998 * b.width + -0.3, h = b.height + -9;
        if (w <= 0 || h <= 0) return;
        const vb = [b.x + 0.2, b.y + 4.2, w, h].join(' ');
        if (svg.getAttribute('viewBox') !== vb) svg.setAttribute('viewBox', vb);
        max = Math.max(max, svg.getBoundingClientRect().height);
      });
      if (max) el.style.setProperty('--emphasis-height', `${max / 16}`);
      el.dataset.ready = 'true';
    };
    const schedule = () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(measure); };
    document.fonts.ready.then(schedule);
    new ResizeObserver(schedule).observe(el);
  });
}

/* ═══ 21-icons.js ═══ */
/* ───────── «Nuestros íconos»: barra de íconos + cabecera (IconsNav y HeroIcons de España) ─────────
   Port de js_legible/09fvdxzsi_ki-.js (IconsNav, módulo 308368) y js_legible/3xwywgmm5w79-.js (HeroIcons, módulo 978575; ganchos
   useIconsNavPinned / useIconsNavOverContent, módulo 105985; Flip de GSAP, módulo 405233) + ScrollBehaviorProvider (0jrg4k82j6xzh.js).
   Marcado: snippets/dm-pg-icons*.liquid (generado). Este archivo mueve los mismos atributos y estilos en línea que React + GSAP:
     nav[data-icons-nav]      data-collapsed (scrollY ≥ 5) · data-pinned / data-over-content (los dos disparadores de la cabecera cruzan el borde
                              superior de la ventana) · --icons-nav-progress (scrollY / posición del disparador, 0…1) · data-intro-pending (se quita)
     header.es-hero-icons     data-scrolled · data-nav-pinned · data-hero-intro-pending (se quita al terminar la entrada)
     entrada (una vez)        el panel activo aparece encajado en el primer hueco de la fila de miniaturas, las otras tres aparecen en cascada,
                              el panel crece hasta ocupar la cabecera, las miniaturas se van y entran título y botón. Con «reducir movimiento»
                              no hay entrada: solo se quitan los atributos «pendiente» (igual que allá).
   La navegación entre íconos sin recargar, el arrastre táctil y el cambio animado de textos están en 22-icons-swap.js.
   DMES.motion = { EASE, DUR, timeline } queda disponible para ese archivo. */
{
  /* curvas y duraciones de España (registerMotion, módulo 721773: CustomEase) + las «power2» de GSAP que usa el arrastre de la cabecera */
  const bez = (x1, y1, x2, y2) => {
    const cx = 3 * x1, bx = 3 * (x2 - x1) - cx, ax = 1 - cx - bx, cy = 3 * y1, by = 3 * (y2 - y1) - cy, ay = 1 - cy - by;
    const fx = t => ((ax * t + bx) * t + cx) * t, fy = t => ((ay * t + by) * t + cy) * t, dx = t => (3 * ax * t + 2 * bx) * t + cx;
    return x => {
      if (x <= 0) return 0; if (x >= 1) return 1;
      let t = x;
      for (let i = 0; i < 8; i++) { const e = fx(t) - x; if (Math.abs(e) < 1e-6) return fy(t); const d = dx(t); if (Math.abs(d) < 1e-6) break; t -= e / d; }
      let lo = 0, hi = 1; t = x;
      for (let i = 0; i < 40 && hi - lo > 1e-7; i++) { const e = fx(t); if (Math.abs(e - x) < 1e-6) break; if (x > e) lo = t; else hi = t; t = (hi + lo) / 2; }
      return fy(t);
    };
  };
  const EASE = {
    regular: bez(0.45, 0.02, 0.09, 0.98), exit: bez(0.4, 0, 1, 1), expand: bez(0.8, 0, 0.2, 1), glide: bez(0.64, 0.03, 0.21, 1),
    'power2.out': p => 1 - (1 - p) ** 3, 'power2.inOut': p => (p < 0.5 ? 4 * p * p * p : 1 - ((1 - p) * 2) ** 3 / 2),
  };
  const DUR = { micro: 0.12, short: 0.2, base: 0.3, panel: 0.42, expressive: 0.6 };                 // DURATIONS_S
  /* Línea de tiempo mínima (lo que acá se usa de gsap.timeline), en segundos: to(inicio, duración, curva, pintar(valor 0…1)) y call(instante, fn).
     Reloj como el de GSAP (lagSmoothing 500/33): un cuadro que llega con más de 500 ms de atraso —pestaña en segundo plano— cuenta 33 ms,
     así la animación sigue donde iba en vez de saltar al final. kill() la corta sin llamar a onComplete. */
  const timeline = onComplete => {
    const items = []; let end = 0, t = 0, last = null, raf = 0, dead = false;
    const tick = now => {
      if (dead) return;
      if (last !== null) { const d = now - last; t += (d > 500 ? 33 : d) / 1000; }
      last = now;
      for (const it of items) {
        if (it.done || t < it.at) continue;
        if (it.fn) { it.done = true; it.fn(); continue; }
        const p = it.dur > 0 ? Math.min(1, (t - it.at) / it.dur) : 1;
        it.run(it.ease(p));
        if (p >= 1) it.done = true;
      }
      if (dead) return;
      if (t >= end) { dead = true; onComplete && onComplete(); return; }
      raf = requestAnimationFrame(tick);
    };
    const tl = {
      to(at, dur, ease, run) { items.push({ at, dur, ease: EASE[ease], run }); end = Math.max(end, at + dur); return tl; },
      call(at, fn) { items.push({ at, fn }); end = Math.max(end, at); return tl; },
      play() { raf = requestAnimationFrame(tick); return tl; },
      kill() { dead = true; cancelAnimationFrame(raf); },
      get active() { return !dead; },
    };
    return tl;
  };
  DMES.motion = { EASE, DUR, timeline };

  const flag = (el, k, v) => { const s = v ? 'true' : 'false'; if (el.getAttribute(k) !== s) el.setAttribute(k, s); };
  const atTop = () => window.scrollY < 5;                                                          // isScrolledToTop (ScrollBehaviorProvider)
  /* useIconsNavPinned / useIconsNavOverContent: un IntersectionObserver sobre el disparador; vale «true» cuando su borde superior
     llegó al de la ventana o lo pasó (boundingClientRect.top ≤ 0). Avisa al observar y cada vez que el disparador entra o sale.
     Un solo observador por disparador para la barra y la cabecera: así cambian siempre en el mismo orden (barra, luego cabecera), como en
     la grabación de España; con un observador por componente el orden entre los dos lo decide el navegador. */
  const watched = new WeakMap();
  const crossed = (sel, cb) => {
    const t = $(sel); if (!t) return;
    let w = watched.get(t);
    if (!w) {
      w = { cbs: [], v: null }; watched.set(t, w);
      new IntersectionObserver(es => es.forEach(e => { w.v = e.boundingClientRect.top <= 0; w.cbs.forEach(fn => fn(w.v)); })).observe(t);
    }
    w.cbs.push(cb);
    if (w.v !== null) cb(w.v);
  };
  const PIN = '[data-icons-nav-pin-trigger]', EXIT = '[data-icons-nav-exit-trigger]';

  /* ── barra (IconsNav) ── */
  DMES.on('nav[data-icons-nav]', nav => {
    let top = 0, raf = 0;
    const paint = () => { nav.style.setProperty('--icons-nav-progress', `${top > 0 ? Math.min(Math.max(window.scrollY / top, 0), 1) : 1}`); };
    /* NUESTRO (es/glue.d/icons.css): si el nombre grande no cabe (en móvil «MOCASINES» estira la grilla y la página queda más ancha que la
       pantalla), data-dm-fit le deja cortar como el título del hero. Se mide sin la marca; con nombres que caben no se agrega nada. */
    const fit = () => {
      if (nav.hasAttribute('data-dm-fit')) nav.removeAttribute('data-dm-fit');
      if (nav.scrollWidth > nav.clientWidth + 1) nav.setAttribute('data-dm-fit', '');
    };
    const measure = () => { fit(); const t = $(PIN); top = t ? t.getBoundingClientRect().top + window.scrollY : 0; paint(); };
    /* en cada cuadro con scroll: primero el progreso (allá va en requestAnimationFrame) y después data-collapsed (allá es estado de React,
       que se pinta un instante después del evento); ese es el orden de la grabación */
    const frame = () => { raf = 0; paint(); flag(nav, 'data-collapsed', !atTop()); };
    const onScroll = () => {
      if (!nav.isConnected) { window.removeEventListener('scroll', onScroll); window.removeEventListener('resize', measure); return; }
      if (!raf) raf = requestAnimationFrame(frame);
    };
    measure();
    if (document.fonts) document.fonts.ready.then(() => { if (nav.isConnected) measure(); });   // el ancho del nombre depende de la letra DOCS
    flag(nav, 'data-collapsed', !atTop());
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', measure);
    crossed(PIN, v => flag(nav, 'data-pinned', v));
    crossed(EXIT, v => flag(nav, 'data-over-content', v));
    nav.dmIconsNav = { measure };                                                                  // 22-icons-swap.js vuelve a medir al cambiar de ícono
  });

  /* ── entrada de la cabecera (useGSAP de HeroIcons: gsap.timeline + Flip.getState / Flip.fit / Flip.to) ── */
  let flipN = 1;                                                                                  // Flip numera los elementos que mide: data-flip-id="auto-N"
  const flipId = el => { if (!el.hasAttribute('data-flip-id')) el.setAttribute('data-flip-id', 'auto-' + flipN++); };
  const none3 = el => { el.style.translate = 'none'; el.style.rotate = 'none'; el.style.scale = 'none'; };   // lo que GSAP deja en línea al leer o escribir un transform
  const snap = (v, off = 0) => Math.round((v + off) * 10) / 10;                                    // Flip redondea posiciones y tamaños a décimas
  const clear = (el, ...props) => props.forEach(p => el.style.removeProperty(p));                  // clearProps
  const intro = header => {
    const done = () => { header.removeAttribute('data-hero-intro-pending'); const n = $('[data-icons-nav]'); n && n.removeAttribute('data-intro-pending'); };
    const box = $('[data-hero-intro]', header), slot = $('[data-hero-intro-slot]', header), items = $$('[data-hero-intro-item]', header);
    const panel = $('[data-hero-panel="active"]', header), text = $('[data-hero-text="active"]', header);
    const content = text && $('[data-hero-content]', text), ctas = text && $('[data-hero-ctas]', text);
    if (reduced() || !box || !slot || !panel) return done();
    const desk = mq(DESKTOP);                                                                      // useBreakpoint('lg'): el título entra de lado en escritorio y desde arriba en móvil
    const shift = v => (desk ? `translate(${v}, 0px)` : `translate(0px, ${v})`);
    box.style.display = 'flex';
    items.forEach(i => { i.style.visibility = 'hidden'; });
    if (content) { content.style.visibility = 'hidden'; none3(content); content.style.transform = shift('-20%'); }
    if (ctas) ctas.style.visibility = 'hidden';
    /* Flip.getState(panel) guarda el panel a tamaño completo; Flip.fit(panel, hueco, {absolute: true}) lo encaja en el primer hueco de la fila */
    flipId(panel);
    const full = panel.getBoundingClientRect(), W = snap(full.width, 0.04), H = snap(full.height, 0.04);
    panel.style.visibility = 'hidden';
    flipId(slot); none3(slot);
    const to = slot.getBoundingClientRect();
    const x0 = snap(to.left - full.left, 0.02), y0 = snap(to.top - full.top, 0.02), w0 = snap(to.width), h0 = snap(to.height);
    const place = (x, y, w, h) => { panel.style.width = `${w}px`; panel.style.height = `${h}px`; panel.style.transform = `translate(${x}px, ${y}px)`; };
    Object.assign(panel.style, { transition: 'none', position: 'absolute', top: '0px', left: '0px' }); none3(panel);
    place(x0, y0, w0, h0);
    const tl = timeline(() => { box.style.display = 'none'; done(); });
    /* 1) panel + miniaturas: visibles en cascada (retardo 0,1 s · 0,15 s entre uno y otro · cada tramo dura 0,2 s) */
    [panel, ...items].forEach((el, i) => tl.call(0.1 + i * 0.15, () => { el.style.visibility = 'visible'; }));
    /* 2) 0,2 s después de la cascada, Flip.to(estado): el panel crece hasta su tamaño (0,6 s, curva «expand»); al terminar se limpia */
    const t1 = 0.1 + items.length * 0.15 + DUR.short + DUR.short;
    tl.to(t1, DUR.expressive, 'expand', e => place(x0 * (1 - e), y0 * (1 - e), w0 + (W - w0) * e, h0 + (H - h0) * e));
    tl.call(t1 + DUR.expressive, () => { done(); panel.style.cssText = ''; });
    /* 3) 0,2 s más tarde se van las miniaturas y el fondo (visibility no se interpola: cambia al empezar el tramo de 0,6 s) … */
    const t2 = t1 + 0.2;
    tl.call(t2, () => { items.forEach(i => { i.style.visibility = 'hidden'; }); box.style.visibility = 'hidden'; });
    tl.to(t2, DUR.expressive, 'regular', () => {});
    /* … entra el título (−20 % → 0 en 0,5 s, curva «glide») y, 0,1 s después, el botón (0,3 s) */
    if (content) {
      let d = 0;
      tl.call(t2, () => { d = -0.2 * (desk ? content.offsetWidth : content.offsetHeight); content.style.visibility = 'visible'; });
      tl.to(t2, 0.5, 'glide', e => { content.style.transform = shift(`${Math.round(d * (1 - e) * 1000) / 1000}px`); });
      tl.call(t2 + 0.5, () => clear(content, 'visibility', 'transform', 'translate', 'rotate', 'scale'));
    }
    if (ctas) { tl.call(t2 + 0.1, () => { ctas.style.visibility = 'visible'; }); tl.call(t2 + 0.1 + DUR.base, () => clear(ctas, 'visibility')); }
    tl.play();
  };

  /* ── cabecera (HeroIcons): estados de scroll + entrada ── */
  DMES.on('header.es-hero-icons__header', header => {
    let raf = 0;
    const frame = () => { raf = 0; flag(header, 'data-scrolled', !atTop()); };                      // mismo cuadro que la barra, después de ella
    const onScroll = () => {
      if (!header.isConnected) { window.removeEventListener('scroll', onScroll); return; }
      if (!raf) raf = requestAnimationFrame(frame);
    };
    frame();
    window.addEventListener('scroll', onScroll, { passive: true });
    crossed(PIN, v => flag(header, 'data-nav-pinned', v));
    intro(header);
  });
}

/* ═══ 22-icons-swap.js ═══ */
/* ───────── «Nuestros íconos»: pasar de un ícono a otro sin recargar (HeroIcons de España + navegación de Next.js) ─────────
   En España las cuatro páginas son UNA vista de Next.js: las flechas de la barra (Link prefetch scroll={false}) y el arrastre táctil de la
   cabecera (router.push(href, {scroll: false})) cambian la URL y React vuelve a pintar los mismos componentes con la entrada vecina:
   IconsNav cambia nombre y enlaces; HeroIcons reutiliza paneles y textos por «slug» (el vecino pasa a «active», el activo a «prev» o «next»,
   por el otro lado entra uno nuevo); los bloques de abajo se reemplazan; el scroll no se mueve y la animación de entrada no se repite.
   Acá cada ícono es una página de Shopify, así que eso mismo se hace a mano: se trae el HTML de la página vecina (precargado en reposo),
   se deja el DOM como lo dejaría React (morph(): mismos nodos, otros atributos y textos), se cambia la URL con history.pushState y corren
   las mismas animaciones (js_legible/3xwywgmm5w79-.js, módulo 978575):
     · paneles           no los mueve JS: cambia data-hero-panel y el CSS de España los desliza (translate 0,6 s · --hero-slide-ease)
     · textos            useGSAP [activeIndex]: sale el anterior (opacity → 0 · 0,2 s «exit»), entra el nuevo (0,12 s desde 0,14 s); en móvil los
                         títulos además se cruzan de lado (± ancho · 0,6 s); el botón parte con el ancho del anterior y pasa al suyo (0,3 s
                         «expand» desde 0,2 s). Mientras tanto la capa de textos va con transition:none; al terminar se limpia todo (clearProps)
     · arrastre táctil   dragHandlers: desde 8 px en horizontal la pista sigue al dedo y los títulos se cruzan; al soltar pasa de ícono si recorrió
                         más de la mitad del ancho, o más de un cuarto a más de 0,5 px/ms; si no, vuelve (0,4 s «power2.out»). El clic que sigue a
                         un arrastre se anula. Tras cambiar por arrastre la cabecera se acomoda sin transición (data-hero-settling por un cuadro)
     · reducir movimiento  sin animación de textos ni de pista (duración 0) y sin deslizamiento de paneles (CSS), igual que allá
   Atrás / adelante del navegador (popstate) hace el mismo cambio. Si algo falla (red, HTML inesperado, página que no es vecina) se navega normal.
   NUESTRO (no existe en España): las fotos de los paneles vecinos se piden en reposo para que el deslizamiento nunca muestre un panel vacío,
   y un aviso aria-live con el título nuevo (el equivalente del «route announcer» de Next.js). */
{
  /* INTERRUPTOR (nuestro). Sin recarga, Shopify Analytics y los píxeles que solo miden al cargar la página no registran una vista por cada
     ícono visitado con las flechas o el arrastre. SOFT = false → esos dos gestos cargan la página vecina de forma normal (con su animación de
     entrada); todo lo demás (barra, cabecera, carrusel) sigue igual. */
  const SOFT = true;
  const M = DMES.motion;                                                                           // 21-icons.js (curvas, duraciones y línea de tiempo)
  if (M) {
    const { DUR, timeline } = M;
    const r4 = v => Math.round(v * 10000) / 10000;                                                 // GSAP escribe con 4 decimales
    const setX = (el, x) => { el.style.translate = 'none'; el.style.rotate = 'none'; el.style.scale = 'none'; el.style.transform = `translate(${x}, 0px)`; };
    const op = (els, v) => els.forEach(e => { e.style.opacity = `${r4(v)}`; });
    const all = (root, sel) => (root ? $$(sel, root) : []);
    const T = '[data-hero-title]', SUB = '[data-hero-subtitle]', CTAS = '[data-hero-ctas]', CTA = '[data-hero-cta]', LABEL = '[data-hero-cta-label]';
    /* w() y S() de España: toda la capa de textos sin transiciones CSS mientras se anima · limpiar lo que dejó la animación */
    const layer = h => { const t = $('[data-hero-text-layer]', h); return t ? [t, ...t.querySelectorAll('*')] : []; };
    const freeze = h => layer(h).forEach(e => { e.style.transition = 'none'; });
    const CLEAR = ['transform', 'translate', 'rotate', 'scale', 'opacity', 'visibility', 'width', 'transition'];
    const release = h => layer(h).forEach(e => CLEAR.forEach(p => e.style.removeProperty(p)));

    /* Deja el nodo vivo `a` con las etiquetas, atributos y textos de `b` (HTML de la otra página) sin recrear lo que ya calza: lo que hace React
       al volver a pintar el mismo componente con otra entrada. No toca lo que es estado en vivo (style en línea, data-flip-id, data-dm-*). */
    const KEEP = /^(style|data-flip-id|data-dm-.*)$/;
    const morph = (a, b) => {
      if (a.nodeType !== b.nodeType || a.nodeName !== b.nodeName) { const c = document.importNode(b, true); a.replaceWith(c); return c; }
      if (a.nodeType === 3) { if (a.data !== b.data) a.data = b.data; return a; }
      if (a.nodeType !== 1) return a;
      for (const at of [...a.attributes]) if (!b.hasAttribute(at.name) && !KEEP.test(at.name)) a.removeAttribute(at.name);
      for (const at of [...b.attributes]) if (!KEEP.test(at.name) && a.getAttribute(at.name) !== at.value) a.setAttribute(at.name, at.value);
      const ca = [...a.childNodes], cb = [...b.childNodes];
      cb.forEach((n, i) => { if (ca[i]) morph(ca[i], n); else a.append(document.importNode(n, true)); });
      ca.slice(cb.length).forEach(n => n.remove());
      return a;
    };

    /* HTML de las páginas vecinas (una vez por página; lo que en España es el prefetch de Next) */
    const cache = new Map();
    const load = url => {
      const k = url.split('#')[0];
      if (!cache.has(k)) {
        cache.set(k, fetch(k, { credentials: 'same-origin' })
          .then(r => { if (!r.ok) throw new Error(`HTTP ${r.status}`); return r.text(); })
          .then(t => new DOMParser().parseFromString(t, 'text/html'))
          .catch(e => { cache.delete(k); throw e; }));
      }
      return cache.get(k);
    };
    const SIDES = ['prev', 'active', 'next'];
    const pageOf = doc => {
      const nav = doc.querySelector('nav[data-icons-nav]'), header = doc.querySelector('header.es-hero-icons__header');
      if (!nav || !header || nav.parentElement !== header.parentElement) return null;
      if (!SIDES.every(s => header.querySelector(`[data-hero-panel="${s}"]`) && header.querySelector(`[data-hero-text="${s}"]`))) return null;
      return { doc, nav, header, box: header.parentElement, title: doc.title };
    };
    let live = null;
    const announce = text => {
      if (!live) {
        live = document.createElement('div'); live.setAttribute('aria-live', 'assertive'); live.setAttribute('role', 'alert'); live.setAttribute('data-dm-route-announcer', '');
        live.style.cssText = 'position:absolute;border:0;height:1px;margin:-1px;padding:0;width:1px;clip:rect(0 0 0 0);overflow:hidden;white-space:nowrap;word-wrap:normal';
        document.body.append(live);
      }
      live.textContent = text;
    };

    DMES.on('header.es-hero-icons__header', header => {
      const box = header.parentElement, nav = box && $('nav[data-icons-nav]', box);
      if (!nav || $$('[data-hero-panel]', header).length < 2) return;                              // enabled: count > 1
      let shown = location.pathname, tl = null, glide = null, moved = false, tx = 0, queue = Promise.resolve();
      const track = () => $('[data-hero-track]', header);
      const textSet = s => $(`[data-hero-text="${s}"]`, header);
      const parts = s => { const e = textSet(s); return { title: all(e, T), held: all(e, `${SUB},${CTAS}`) }; };
      const moveTrack = x => { const t = track(); tx = x; if (t) setX(t, `${r4(x)}px`); };
      const hrefOf = side => { const a = $$('.es-icons-nav-arrow__arrow', nav)[side === 'prev' ? 0 : 1]; return (a && a.getAttribute('href')) || null; };
      const pathOf = h => { try { return h ? new URL(h, location.href).pathname : null; } catch (e) { return null; } };
      const sideOf = p => (p && p === pathOf(hrefOf('next')) ? 'next' : p && p === pathOf(hrefOf('prev')) ? 'prev' : null);
      /* NUESTRO: en reposo se precargan las páginas vecinas (no con «ahorro de datos») y se piden las fotos de sus paneles */
      const warm = () => {
        $$('[data-hero-panel] img[loading="lazy"]', header).forEach(i => { i.loading = 'eager'; });
        if (!SOFT || (navigator.connection && navigator.connection.saveData)) return;
        ['prev', 'next'].forEach(s => { const h = hrefOf(s); if (h) load(new URL(h, location.href).href).catch(() => {}); });
      };
      const idle = fn => (window.requestIdleCallback ? window.requestIdleCallback(fn, { timeout: 3000 }) : setTimeout(fn, 1200));

      /* ── textos (useGSAP de HeroIcons, dependencia [activeIndex]) ── */
      const swapText = side => {
        if (reduced()) { moveTrack(0); return; }
        const inS = textSet('active'), outS = textSet(side === 'next' ? 'prev' : 'next'), mobile = !mq(DESKTOP);
        const inT = all(inS, T), outT = all(outS, T), inSub = all(inS, SUB), outSub = all(outS, SUB);
        const inC = inS && $(CTAS, inS), outC = outS && $(CTAS, outS), inB = all(inC, CTA), outB = all(outC, CTA), inL = all(inC, LABEL), outL = all(outC, LABEL);
        const wOut = outB.map(e => e.offsetWidth), wIn = inB.map(e => e.offsetWidth), same = inB.length > 0 && inB.length === outB.length;
        freeze(header);
        if (outS) outS.style.visibility = 'visible';
        op([...inT, ...inSub], 0);
        if (inC) op([inC], 0);
        if (same) op(inL, 0);
        const t = timeline(() => { release(header); if (tl === t) tl = null; });
        tl = t;
        const fade = (els, at, dur, ease, to) => {                                                // gsap.to(els, {opacity}): parte del valor que tengan al empezar
          if (!els.length) return;
          let from = null;
          t.to(at, dur, ease, e => { from = from || els.map(x => parseFloat(getComputedStyle(x).opacity) || 0); els.forEach((x, i) => { x.style.opacity = `${r4(from[i] + (to - from[i]) * e)}`; }); });
        };
        const X = 0.7 * DUR.short;
        fade(mobile ? outSub : [...outT, ...outSub], 0, DUR.short, 'exit', 0);
        fade(mobile ? inSub : [...inT, ...inSub], X, DUR.micro, 'regular', 1);
        if (mobile) {
          const w = (side === 'next' ? 1 : -1) * header.clientWidth;
          if (outT.length) { t.to(0, DUR.expressive, 'power2.inOut', e => outT.forEach(x => setX(x, `${r4(-w * e)}px`))); fade(outT, 0, DUR.panel, 'regular', 0); }
          if (inT.length) { inT.forEach(x => setX(x, `${w}px`)); t.to(0, DUR.expressive, 'glide', e => inT.forEach(x => setX(x, `${r4(w * (1 - e))}px`))); fade(inT, 0, DUR.expressive, 'regular', 1); }
        }
        if (same) {
          fade(outL, 0, DUR.short, 'exit', 0);
          t.call(X, () => op([inC], 1));
          fade(inL, X, DUR.micro, 'regular', 1);
          t.call(DUR.short, () => op([outC], 0));
          inB.forEach((b, i) => { b.style.width = `${wOut[i]}px`; t.to(DUR.short, DUR.base, 'expand', e => { b.style.width = `${Math.round(wOut[i] + (wIn[i] - wOut[i]) * e)}px`; }); });
        } else {
          if (outC) fade([outC], 0, DUR.short, 'exit', 0);
          if (inC) t.call(DUR.short, () => op([inC], 1));
        }
        t.play();
      };

      /* ── deja la página como la de `pg` (lo que React vuelve a pintar al cambiar la ruta) ── */
      const apply = (pg, side, href, push, dragged) => {
        const other = side === 'next' ? 'prev' : 'next', h2 = pg.header;
        if (tl) { tl.kill(); tl = null; release(header); }
        if (push) history.pushState({ dmIcons: 1 }, '', href);
        shown = pathOf(href); document.title = pg.title;
        [['link[rel="canonical"]', 'href'], ['meta[name="description"]', 'content'], ['meta[property="og:url"]', 'content'], ['meta[property="og:title"]', 'content'], ['meta[property="og:description"]', 'content']]
          .forEach(([s, k]) => { const a = document.head.querySelector(s), b = pg.doc.head.querySelector(s); if (a && b && b.hasAttribute(k)) a.setAttribute(k, b.getAttribute(k)); });
        /* barra: nombre, enlaces y colores de la entrada nueva (los estados de scroll no cambian) */
        ['data-text-color-mobile', 'data-text-color-desktop'].forEach(k => { if (pg.nav.hasAttribute(k)) nav.setAttribute(k, pg.nav.getAttribute(k)); });
        [...nav.children].forEach((c, i) => { if (pg.nav.children[i]) morph(c, pg.nav.children[i]); });
        /* cabecera: paneles y textos por lado. El vecino pasa a «active», el activo al lado contrario, sale el del fondo y entra uno nuevo */
        if (h2.hasAttribute('data-nav-theme')) header.setAttribute('data-nav-theme', h2.getAttribute('data-nav-theme'));
        [['data-hero-panel', track()], ['data-hero-text', $('[data-hero-text-layer]', header)]].forEach(([attr, parent]) => {
          const q = (root, s) => root.querySelector(`[${attr}="${s}"]`);
          const gone = q(header, other), was = q(header, 'active'), now = q(header, side);
          if (gone) gone.remove();
          morph(was, q(h2, other)); morph(now, q(h2, 'active'));
          const fresh = document.importNode(q(h2, side), true);
          if (side === 'next') parent.append(fresh); else parent.prepend(fresh);
        });
        const slot = $('[data-hero-intro-slot]', header);
        if (slot) {                                                                                 // miniaturas de la entrada (ya ocultas): las de la entrada nueva
          $$('[data-hero-intro-item]', header).forEach(i => i.remove());
          all(h2, '[data-hero-intro-item]').forEach(i => { const c = document.importNode(i, true); c.style.visibility = 'hidden'; slot.parentElement.append(c); });
        }
        /* bloques de la página: todo lo que sigue a la cabecera */
        if (pg.box.hasAttribute('data-content-container-theme')) box.setAttribute('data-content-container-theme', pg.box.getAttribute('data-content-container-theme'));
        while (header.nextSibling) header.nextSibling.remove();
        const frag = document.createDocumentFragment();
        for (let n = h2.nextSibling; n; n = n.nextSibling) frag.append(document.importNode(n, true));
        box.append(frag);
        DMES.init(box);
        /* animación: tras un arrastre la pista ya llegó, solo se acomoda sin transición; con las flechas, cambio animado de textos */
        if (dragged || moved) {
          moved = false;
          header.setAttribute('data-hero-settling', ''); requestAnimationFrame(() => header.removeAttribute('data-hero-settling'));
          moveTrack(0); release(header);
        } else swapText(side);
        if (nav.dmIconsNav) nav.dmIconsNav.measure();
        announce(pg.title);
        idle(warm);
      };
      const go = async (url, { push = true, dragged = false } = {}) => {
        const to = new URL(url, location.href), hard = () => { if (push) location.assign(to.href); else location.reload(); };
        if (!SOFT || to.origin !== location.origin) return hard();
        if (to.pathname === shown) { if (dragged) { moved = false; moveTrack(0); release(header); } return; }
        const side = sideOf(to.pathname);
        if (!side) return hard();
        let pg = null;
        try { pg = pageOf(await load(to.href)); } catch (e) { pg = null; }
        if (!pg || !header.isConnected) return hard();
        try { apply(pg, side, to.href, push, dragged); } catch (e) { console.error('[dm-es] icons', e); hard(); }
      };
      const run = (url, o) => { queue = queue.then(() => go(url, o)).catch(() => {}); };

      /* flechas de la barra (Link): clic simple o Enter cambian sin recargar; con Ctrl/⌘/Mayús/Alt o botón medio, el navegador hace lo suyo */
      nav.addEventListener('click', e => {
        const a = e.target instanceof Element ? e.target.closest('a.es-icons-nav-arrow__arrow') : null;
        if (!SOFT || !a || !nav.contains(a) || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || (a.target && a.target !== '_self')) return;
        e.preventDefault(); run(a.href);
      });
      window.addEventListener('popstate', () => { if (header.isConnected && location.pathname !== shown) run(location.href, { push: false }); });

      /* ── arrastre táctil (dragHandlers) ── */
      let pid = null, dragging = false, vertical = false, eat = false, vel = 0, x0 = 0, y0 = 0, start = 0, lx = 0, lt = 0;
      const follow = x => {
        const W = header.clientWidth; if (!W) return;
        const r = Math.min(Math.abs(x) / W, 1), s = x < 0 ? 'next' : 'prev', a = s === 'next' ? W : -W;
        const A = parts('active'), B = parts(s), C = parts(s === 'next' ? 'prev' : 'next');
        A.title.forEach(t => setX(t, `${r4(x)}px`)); op(A.title, 1 - r);
        B.title.forEach(t => setX(t, `${r4(x + a)}px`)); op(B.title, r);
        C.title.forEach(t => setX(t, '0px')); op(C.title, 0);
        op(A.held, 1 - Math.min(r / 0.5, 1)); op(B.held, Math.max((r - 0.5) / 0.5, 0)); op(C.held, 0);
      };
      /* gsap.to(...) de las dos salidas del arrastre: pista + textos desde donde estén, 0,4 s «power2.out» (0 con «reducir movimiento») */
      const settleTo = (toX, texts, done) => {
        const d = reduced() ? 0 : 0.4, from = tx, g = timeline(() => { if (glide === g) glide = null; done(); });
        glide = g;
        g.to(0, d, 'power2.out', e => moveTrack(from + (toX - from) * e));
        texts.forEach(([els, toOp, toPx]) => {
          if (!els.length) return;
          const o0 = els.map(x => parseFloat(getComputedStyle(x).opacity) || 0), p0 = toPx === undefined ? null : els.map(x => new DOMMatrixReadOnly(getComputedStyle(x).transform).m41);
          g.to(0, d, 'power2.out', e => els.forEach((x, i) => { x.style.opacity = `${r4(o0[i] + (toOp - o0[i]) * e)}`; if (p0) setX(x, `${r4(p0[i] + (toPx - p0[i]) * e)}px`); }));
        });
        g.play();
      };
      header.addEventListener('pointerdown', e => {
        if (e.pointerType !== 'touch') return;
        pid = e.pointerId; dragging = false; vertical = false; eat = false; vel = 0; x0 = e.clientX; y0 = e.clientY; lx = e.clientX; lt = e.timeStamp;
      });
      header.addEventListener('pointermove', e => {
        if (pid !== e.pointerId || vertical) return;
        const dx = e.clientX - x0, dy = e.clientY - y0;
        if (!dragging) {
          if (Math.abs(dx) < 8) return;
          if (Math.abs(dy) > Math.abs(dx)) { vertical = true; return; }
          if (!track()) return;
          dragging = true; eat = true; header.setAttribute('data-dragging', 'true');
          start = tx;
          if (glide) { glide.kill(); glide = null; }
          if (tl) { tl.kill(); tl = null; }
          release(header); freeze(header);
          $$('[data-hero-text]', header).forEach(s => { s.style.visibility = 'visible'; });
          moved = false;
          try { header.setPointerCapture(e.pointerId); } catch (err) { /* el puntero ya no está */ }
        }
        const dt = e.timeStamp - lt;
        if (dt > 0) vel = (e.clientX - lx) / dt;
        lx = e.clientX; lt = e.timeStamp;
        moveTrack(start + dx); follow(start + dx);
      });
      const drop = e => {
        if (pid !== e.pointerId) return;
        pid = null;
        if (!dragging) return;
        dragging = false; header.removeAttribute('data-dragging');
        const W = header.clientWidth, x = start + (e.clientX - x0), side = x < 0 ? 'next' : 'prev', href = hrefOf(side), v = e.timeStamp - lt > 100 ? 0 : vel, dist = Math.abs(x);
        if (href && (dist > 0.5 * W || (dist > 0.25 * W && Math.abs(v) > 0.5))) {
          const a = side === 'next' ? W : -W, A = parts('active'), B = parts(side);
          moved = true;
          settleTo(-a, [[A.title, 0, -a], [B.title, 1, 0], [A.held, 0], [B.held, 1]], () => { const t = track(); if (t) setX(t, side === 'next' ? '-100%' : '100%'); run(new URL(href, location.href).href, { dragged: true }); });
        } else {
          const A = parts('active'), P = parts('prev'), N = parts('next');
          settleTo(0, [[A.title, 1, 0], [A.held, 1], [P.title, 0], [P.held, 0], [N.title, 0], [N.held, 0]], () => release(header));
        }
      };
      header.addEventListener('pointerup', drop);
      header.addEventListener('pointercancel', drop);
      header.addEventListener('click', e => { if (eat) { e.preventDefault(); e.stopPropagation(); eat = false; } }, true);

      if (document.readyState === 'complete') idle(warm); else window.addEventListener('load', () => idle(warm), { once: true });
    });
  }
}

/* ═══ 26-size-guide.js ═══ */
/* ───────── guía de tallas (página): pestañas e interruptor cm / in ─────────
   BlockSizeGuides (js_legible/0ccohg_h7ygc3.js) · SizeGuideTable (1s_6-rdlpveo0.js) · Switch y Toggle (10fv5_1_va_8_.js) de España.
   Marcado: sections/dm-size-guide-tables.liquid + snippets/dm-size-guide-table.liquid.
   · Pestañas: el botón elegido queda con aria-pressed="true" y su <span> con data-selected="true". En el DOM solo están las tablas de la pestaña
     activa (España las monta al elegirla): acá las demás esperan en <template data-dm-sg-tab="n"> y se intercambian con las visibles.
   · cm / in: cada tabla lleva su propio estado. «cm» e «in» son botones que fijan la unidad y el interruptor la alterna; cambian data-active de las
     dos etiquetas y el texto de las celdas con medida (data-dm-cm / data-dm-in; España trae los dos valores del CMS, acá los deja el Liquid).
   · Al cambiar de pestaña React conserva el componente de cada POSICIÓN (la 1.ª tabla sigue siendo la 1.ª): la unidad elegida se mantiene en las
     tablas que ocupan una posición que ya existía y las posiciones nuevas arrancan en cm. Se reproduce igual.
   El enlace «Cómo medir» abre dialog#content-panel: lo resuelven 05-panel.js y el «panel de contenido» de 73-pdp-info.js (data-dm-panel="sg-medir").
   · Foco al abrir el panel (ContentPanel, js_legible/2gd49b61todti.js): España abre el diálogo y recién después llega el contenido, así que el
     autofocus del título no actúa y el foco queda en el contenedor con scroll del panel (anillo de foco del navegador si se llegó con teclado).
     Acá el contenido ya está al abrir: el título viene sin autofocus (sections/dm-size-guide-tables.liquid) y el atributo se le pone después de
     abrir, que es como queda el DOM allá.
   Las preguntas son <details name> nativos: no llevan JS. */
{
  const GUIDE = '.es-block-size-guides__guide';
  const unit = (guide, on) => {
    guide.__dmIn = on;
    const sw = $('[data-dm-unit-switch]', guide);
    if (sw) {
      const [bCm, bIn] = $$('.es-switch__label', sw), chk = $('.es-toggle__input', sw);
      if (chk) chk.checked = on;
      if (bCm) bCm.dataset.active = String(!on);
      if (bIn) bIn.dataset.active = String(on);
    }
    $$('[data-dm-cm]', guide).forEach(c => { c.textContent = on ? c.dataset.dmIn : c.dataset.dmCm; });
  };
  // delegado en el documento: las tablas de las otras pestañas todavía no están en el DOM
  document.addEventListener('click', e => {
    const b = e.target.closest && e.target.closest(`${GUIDE} .es-switch__label`); if (!b) return;
    const sw = b.closest('[data-dm-unit-switch]'); if (!sw) return;
    unit(b.closest(GUIDE), $$('.es-switch__label', sw).indexOf(b) === 1);          // Switch: onClick={() => onChange(false | true)}
  });
  document.addEventListener('change', e => {
    const c = e.target; if (!c || !c.matches || !c.matches(`${GUIDE} [data-dm-unit-switch] .es-toggle__input`)) return;
    unit(c.closest(GUIDE), c.checked);                                              // Toggle: onChange={e => onChange(e.target.checked)}
  });

  document.addEventListener('dm:dialog', e => {
    if (!e.detail || !e.detail.open || !e.target || !e.target.querySelector) return;
    const t = e.target.querySelector('[data-dm-sg-title]'); if (t) t.setAttribute('autofocus', '');
  });

  DMES.on('[data-dm-sg-tabs]', tabs => {
    const bar = $(':scope > .es-block-size-guides__tabButtons', tabs); if (!bar) return;
    const buttons = $$(':scope > .es-block-size-guides__tabButton', bar);
    const store = new Map();                                                        // pestaña → sus tablas (nodos) mientras no están en el DOM
    let cur = Math.max(0, buttons.findIndex(b => b.getAttribute('aria-pressed') === 'true'));
    const guidesOf = i => {
      if (!store.has(i)) { const t = $(`:scope > template[data-dm-sg-tab="${i}"]`, tabs); store.set(i, t ? [...t.content.children] : []); }
      return store.get(i);
    };
    const select = i => {
      if (i === cur || !buttons[i]) return;
      const old = $$(`:scope > ${GUIDE}`, tabs), units = old.map(g => !!g.__dmIn), next = guidesOf(i);
      store.set(cur, old);
      old.forEach(g => g.remove());
      next.forEach((g, k) => unit(g, k < units.length ? units[k] : false));
      bar.after(...next);
      buttons.forEach((b, k) => { b.setAttribute('aria-pressed', String(k === i)); const s = b.firstElementChild; if (s) s.dataset.selected = String(k === i); });
      cur = i;
    };
    buttons.forEach((b, i) => b.addEventListener('click', () => select(i)));
  });
}

/* ═══ 27-store-finder.js ═══ */
/* ───────── buscador de tiendas (página /pages/nuestras-tiendas · «store finder» de España) ─────────
   De dónde sale: js_legible/1jx51kcduw7vk.js (StoreFinderWithTracking → StoreFinder «G» → SearchSection «E»), 2iplgk9wh06vw.js (StoreFinderMap),
   0q4ogydaqhugq.js (LocationSelector + toLocationItem, StoreDetail, OpeningHours, usePaginatedStoreSearch) y 2gd49b61todti.js (Input).
   Marcado: sections/dm-store-finder.liquid (plantillas <template data-dm-tpl> = lo que dibuja cada componente de España).
   Qué hace, igual que allá:
     estado en la URL   ?q= búsqueda · ?near=lat,lng «usar mi ubicación» · ?store=id ficha abierta (pushState al abrir la ficha, replaceState en lo demás)
     campo              foco → abre el cajón y habilita sugerencias; el botón del campo es «usar mi ubicación» con el campo vacío y «borrar» con texto;
                        sugerencias con 2+ caracteres, 200 ms después de la última tecla (flechas, Enter, Escape, ratón; aria-activedescendant);
                        elegir una pone «lugar, zona» en el campo. Los resultados usan el texto 300 ms después de la última tecla
     cajón (móvil)      data-open / data-store-finder-drawer / data-panel-open; aparece y se va con clip-path escalonado desde abajo (cerrar: 1,5× más rápido),
                        se cierra con el botón, arrastrándolo hacia abajo más de un 25 % de su alto o con Escape; en escritorio es una lista fija
     ficha              data-detail-open; se descubre de arriba abajo con clip-path escalonado (con 2 pasos de espera); al volver, en escritorio la lista
                        se descubre igual; la página sube al inicio al elegir tienda; Escape o «atrás» la cierran y la tienda queda marcada
     lista              LocationSelector: «Abierto/Cerrado» + horario de hoy según la hora de la tienda; distancia si se usó la ubicación
     mapa               MapLibre GL (misma versión que España) con el estilo «liberty» de OpenFreeMap; un marcador por tienda con coordenadas
                        (relleno si está elegida o con el puntero encima); al elegir tienda vuela a ella (zoom 13); si no, encuadra los resultados
                        (margen 64, zoom máx. 14, 1 s); botones +/− (zoomTo ±1); data-stuck con IntersectionObserver; sin animación si el sistema
                        pide menos movimiento
   Adaptado (acá no hay servicio de búsqueda: las tiendas son los bloques de la sección):
     · buscar = filtrar las tiendas locales: cada palabra escrita debe ser comienzo de alguna palabra de nombre, dirección, comuna/barrio, ciudad,
       región, código postal o palabras clave (sin tildes ni mayúsculas); si ninguna tienda calza con todas, se muestran las que calzan con más
       palabras; las sugerencias son las comunas, ciudades, regiones y direcciones de las tiendas
     · «usar mi ubicación» ordena todas las tiendas por cercanía y muestra los kilómetros (allá el servicio devuelve las cercanas)
     · modo «lista a la vista» (ajuste de la sección): sin búsqueda se muestran todas las tiendas y el cajón parte abierto
     · la hora de «Abierto/Cerrado» y el día resaltado usan la zona horaria de la tienda (allá: la del navegador y UTC, respectivamente)
     · el mapa se carga solo cuando queda a la vista (import() de assets/dm-maplibre-gl-*.js); si falla, queda el fondo de reserva de España
       (div.es-store-finder__mapFallback) y la lista y las fichas siguen funcionando. Lleva atribución (OpenFreeMap / OpenMapTiles / OpenStreetMap)
       abajo a la izquierda: España la tiene apagada; la licencia de los datos la exige. Estilo «soft» = el mismo «liberty» con los colores apagados
       (lo que hoy se ve en el mapa de España es solo el fondo y el relieve del estilo: su capa vectorial no llega a dibujarse); en los dos estilos
       los rótulos van en español (name:es; si no hay, el nombre local), no en inglés como en el «liberty» original
     · si el mapa estaba oculto (cajón abierto en móvil) al pedir un encuadre, se encuadra cuando vuelve a tener tamaño
     · si al crearse el mapa ya hay tiendas a la vista (modo lista, ?q= ?near= ?store=), nace encuadrado en ellas: sin el vuelo desde la vista del
       país, que gasta teselas que se cancelan (allá no pasa porque el estado inicial no trae resultados); lo que sigue va animado como allá
     · al pasar de escritorio a móvil con el cajón abierto se deja visible (allá queda sin dibujar hasta volver a abrirlo)
     · foco: al abrir la ficha pasa al botón «atrás» y al cerrarla vuelve a la tienda en la lista (allá se pierde)
   No se portó: «cargar más tiendas» (paginación del servicio), eventos de analítica (store_finder), imagen y servicios de la ficha (sin referencia capturada). */
{
  const OFM_STYLE = 'https://tiles.openfreemap.org/styles/liberty';                 // = MAP_STYLE de España (js_legible/3nrx3apindw1t.js)
  const STORE_ZOOM = 13, FIT = { padding: 64, maxZoom: 14, duration: 1000 };        // constantes de StoreFinderMap
  const STOP = new Set(['de', 'del', 'la', 'el', 'en', 'y']);
  const plain = s => (s == null ? '' : String(s)).normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
  const words = s => plain(s).split(/[^a-z0-9]+/).filter(Boolean);
  const flag = (el, k, v) => { const s = String(v); if (el.getAttribute(k) !== s) el.setAttribute(k, s); };
  const km = (a, b) => {                                                             // distancia en línea recta (haversine)
    const r = x => (x * Math.PI) / 180, dLat = r(b.lat - a.lat), dLng = r(b.lng - a.lng);
    const h = Math.sin(dLat / 2) ** 2 + Math.cos(r(a.lat)) * Math.cos(r(b.lat)) * Math.sin(dLng / 2) ** 2;
    return 6371 * 2 * Math.asin(Math.min(1, Math.sqrt(h)));
  };
  const HHMM = /^\d{1,2}:\d{2}$/;
  const minutes = t => { const [h, m] = t.split(':').map(Number); return Number.isNaN(h) || Number.isNaN(m) || h < 0 || h > 23 || m < 0 || m > 59 ? null : 60 * h + m; };
  // día (0 = domingo) y minutos del día en la zona horaria de la tienda (la función de España acepta timeZone; allá no se la pasan)
  const nowIn = tz => {
    const d = new Date(), local = { day: d.getDay(), minutes: 60 * d.getHours() + d.getMinutes() };
    if (!tz) return local;
    try {
      const p = new Intl.DateTimeFormat('en-US', { timeZone: tz, weekday: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(d);
      const get = k => (p.find(x => x.type === k) || {}).value;
      const day = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 }[get('weekday')], h = Number(get('hour')), m = Number(get('minute'));
      return day === undefined || Number.isNaN(h) || Number.isNaN(m) ? local : { day, minutes: 60 * (h % 24) + m };
    } catch (x) { return local; }
  };
  // estado de apertura de LocationSelector: abierto si la hora cae en un tramo de hoy (o en uno de ayer que cruza la medianoche)
  const openState = (st, tz) => {
    const ranges = [];
    (st.hours || []).forEach((h, i) => { if (h && HHMM.test(h[0]) && HHMM.test(h[1])) ranges.push({ day: (i + 1) % 7, opensAt: h[0], closesAt: h[1] }); });
    if (!ranges.length) return null;
    const { day, minutes: now } = nowIn(tz), today = ranges.find(r => r.day === day), first = ranges[0];
    for (const r of ranges) {
      const o = minutes(r.opensAt), c = minutes(r.closesAt);
      if (o === null || c === null) continue;
      if (o < c) { if (r.day === day && now >= o && now < c) return { isOpen: true, hours: `${r.opensAt}-${r.closesAt}` }; continue; }
      if (o > c && ((r.day === day && now >= o) || ((r.day + 1) % 7 === day && now < c))) return { isOpen: true, hours: `${r.opensAt}-${r.closesAt}` };
    }
    return { isOpen: false, hours: today ? `${today.opensAt}-${today.closesAt}` : first ? `${first.opensAt}-${first.closesAt}` : undefined };
  };

  /* Estilo «soft»: el «liberty» de OpenFreeMap con cada color casi sin saturación y más cerca del fondo (#f8f4f0), el agua como se ve en el mapa
     de España (casi blanca de lejos; gris muy claro al acercarse, para que ríos y costa se lean) y sin comercios ajenos ni escudos de ruta. */
  const rgb2hsl = (r, g, b, a) => {
    r /= 255; g /= 255; b /= 255;
    const mx = Math.max(r, g, b), mn = Math.min(r, g, b), l = (mx + mn) / 2; let h = 0, s = 0;
    if (mx !== mn) { const d = mx - mn; s = l > 0.5 ? d / (2 - mx - mn) : d / (mx + mn); h = (mx === r ? (g - b) / d + (g < b ? 6 : 0) : mx === g ? (b - r) / d + 2 : (r - g) / d + 4) * 60; }
    return [h, s * 100, l * 100, a];
  };
  const alpha = v => (v === undefined ? 1 : v.endsWith('%') ? parseFloat(v) / 100 : Number(v));
  const parseColor = s => {
    let m;
    if ((m = /^#([0-9a-f]{3,8})$/i.exec(s))) {
      let h = m[1]; if (h.length <= 4) h = [...h].map(c => c + c).join('');
      const n = parseInt(h.slice(0, 6), 16);
      return rgb2hsl((n >> 16) & 255, (n >> 8) & 255, n & 255, h.length === 8 ? parseInt(h.slice(6), 16) / 255 : 1);
    }
    if ((m = /^rgba?\(\s*([\d.]+)[\s,]+([\d.]+)[\s,]+([\d.]+)(?:[\s,/]+([\d.]+%?))?\s*\)$/i.exec(s))) return rgb2hsl(+m[1], +m[2], +m[3], alpha(m[4]));
    if ((m = /^hsla?\(\s*([\d.]+)(?:deg)?[\s,]+([\d.]+)%[\s,]+([\d.]+)%(?:[\s,/]+([\d.]+%?))?\s*\)$/i.exec(s))) return [+m[1], +m[2], +m[3], alpha(m[4])];
    return null;
  };
  const recolor = (v, fn) => {
    if (typeof v === 'string') { const c = parseColor(v.trim()); return c ? fn(c) : v; }
    if (Array.isArray(v)) return v.map(x => recolor(x, fn));
    if (v && typeof v === 'object' && Array.isArray(v.stops)) return { ...v, stops: v.stops.map(([z, c]) => [z, recolor(c, fn)]) };
    return v;
  };
  const soften = style => {
    const KS = 0.15, KL = 0.4, L0 = 95, r1 = x => Math.round(x * 10) / 10;
    const out = JSON.parse(JSON.stringify(style));
    out.layers = out.layers.filter(l => !/^(poi_r\d+|highway-shield|road_shield)/.test(l.id));
    for (const l of out.layers) {
      if (l.type === 'background' || l.type === 'raster' || !l.paint) continue;
      const text = l.type === 'symbol';
      for (const k of Object.keys(l.paint)) {
        if (!/color$/.test(k)) continue;
        l.paint[k] = recolor(l.paint[k], ([h, s, li, a]) => `hsla(${Math.round(h)},${r1(s * KS)}%,${r1(text ? li : li + (L0 - li) * KL)}%,${Math.round(a * 1000) / 1000})`);
      }
      if (l.type === 'fill' && l['source-layer'] === 'water') l.paint['fill-color'] = ['interpolate', ['linear'], ['zoom'], 6, '#f8f7f3', 10, '#e3e8ea'];
    }
    return out;
  };
  // rótulos en español: el estilo pide name_en (inglés) antes que el nombre local («Mexico City», «Falkland Islands»); las teselas de OpenMapTiles
  // traen name:es, así que se pide ese y, si un lugar no lo tiene, el nombre local (calles y comunas ya vienen en español)
  const labelsEs = style => {
    const swap = v => (Array.isArray(v) ? (v[0] === 'get' && v[1] === 'name_en' ? ['get', 'name:es'] : v.map(swap)) : v);
    for (const l of style.layers || []) if (l.layout && l.layout['text-field']) l.layout['text-field'] = swap(l.layout['text-field']);
    return style;
  };
  const stylesheet = href => new Promise((ok, ko) => {
    for (const l of document.querySelectorAll('link[rel="stylesheet"]')) if (l.href === href) return l.sheet ? ok() : (l.addEventListener('load', () => ok()), l.addEventListener('error', ko));
    const l = document.createElement('link'); l.rel = 'stylesheet'; l.href = href; l.addEventListener('load', () => ok()); l.addEventListener('error', ko); document.head.append(l);
  });

  DMES.on('[data-dm-store-finder]', root => {
    const scope = root.parentElement;                             // div.es: las plantillas y los datos son hermanos del layout
    let cfg; try { cfg = JSON.parse($('script[data-dm-store-finder-data]', scope).textContent); } catch (x) { return; }
    const input = $('#store-search', root), iconBtn = $('.es-input__icon', root), inputWrapper = $('.es-search-section__inputWrapper', root);
    const panel = $('.es-search-section__storePanel', root), closeBtn = $('.es-search-section__panelCloseButton', root), mapSection = $('.es-search-section__map', root);
    if (!input || !iconBtn || !inputWrapper || !panel || !closeBtn || !mapSection) return;
    const tpl = (k, id) => {
      const t = scope.querySelector(`template[data-dm-tpl="${k}"]${id ? `[data-dm-store="${CSS.escape(id)}"]` : ''}`);
      return t && t.content.firstElementChild ? t.content.firstElementChild.cloneNode(true) : null;
    };
    const L = cfg.labels || {}, tz = cfg.timezone, listMode = cfg.mode === 'list';
    const stores = (cfg.stores || []).map(s => ({ ...s, lat: typeof s.lat === 'number' && typeof s.lng === 'number' ? s.lat : null, lng: typeof s.lat === 'number' && typeof s.lng === 'number' ? s.lng : null }));
    const byId = new Map(stores.map(s => [s.id, s]));
    for (const s of stores) s.hay = words([s.name, s.address, s.district, s.city, s.region, s.postal, s.keywords].join(' '));
    const nf = (o => { try { return new Intl.NumberFormat(cfg.locale, o); } catch (x) { return new Intl.NumberFormat(undefined, o); } });
    const nfList = nf({ maximumFractionDigits: 1 }), nfDetail = nf({ minimumFractionDigits: 1, maximumFractionDigits: 1 });
    // lugares para las sugerencias: comunas/barrios, ciudades, regiones y direcciones de las tiendas (etiqueta + descripción, como el servicio de España)
    const places = []; { const seen = new Set();
      const add = (label, description) => { if (!label) return; const id = plain(label + '|' + description); if (seen.has(id)) return; seen.add(id); places.push({ id, label, description, w: words(label) }); };
      for (const s of stores) add(s.district, [s.city, s.region].filter(x => x && x !== s.district).join(', '));
      for (const s of stores) add(s.city, s.region && s.region !== s.city ? s.region : '');
      for (const s of stores) add(s.region, '');
      for (const s of stores) add(s.address, [s.district, s.city].filter(Boolean).join(', ')); }
    const tokens = q => words(q).filter(w => !STOP.has(w));

    // ── estado (los nombres entre paréntesis son los del componente de España) ──
    const S = { query: '', dq: '', z: '', near: null, store: null, active: undefined, open: listMode, focused: false, sugs: [], sugIdx: -1, hovered: undefined, results: [], searched: false, W: mq(DESKTOP) };
    const ac = new AbortController(), on = (t, ev, fn, o) => t.addEventListener(ev, fn, { signal: ac.signal, ...(o || {}) });
    const alive = () => (root.isConnected ? true : (ac.abort(), false));
    const readUrl = () => {
      const p = new URLSearchParams(location.search), n = (p.get('near') || '').split(',').map(Number);
      return { q: p.get('q') || '', near: n.length === 2 && n.every(Number.isFinite) ? { lat: n[0], lng: n[1] } : null, store: byId.has(p.get('store')) ? p.get('store') : null };
    };
    const writeUrl = push => {
      const u = new URL(location.href), p = u.searchParams;
      S.query ? p.set('q', S.query) : p.delete('q'); S.near ? p.set('near', `${S.near.lat},${S.near.lng}`) : p.delete('near'); S.store ? p.set('store', S.store) : p.delete('store');
      const qs = p.toString();
      try { history[push ? 'pushState' : 'replaceState'](history.state, '', u.pathname + (qs ? `?${qs}` : '') + u.hash); } catch (x) {}
    };
    const search = () => {                                        // searchByCoords / searchByQuery / reset
      if (S.near) { S.results = stores.map(s => ({ s, d: s.lat === null ? undefined : km(S.near, s) })).sort((a, b) => (a.d === undefined ? Infinity : a.d) - (b.d === undefined ? Infinity : b.d)); S.searched = true; }
      else if (S.dq) {
        // todas las palabras tienen que calzar; si ninguna tienda calza con todas, las que calzan con más («palermo centro» → Palermo)
        const t = tokens(S.dq), sc = stores.map(s => ({ s, k: t.filter(w => s.hay.some(h => h.startsWith(w))).length }));
        let hit = sc.filter(x => x.k === t.length);
        if (!hit.length && t.length > 1) { const best = Math.max(0, ...sc.map(x => x.k)); if (best > 0) hit = sc.filter(x => x.k === best); }
        S.results = hit.map(x => ({ s: x.s })); S.searched = true;
      }
      else { S.results = listMode ? stores.map(s => ({ s })) : []; S.searched = false; }
    };
    const suggest = () => {                                       // efecto [enfocado, país, texto con 200 ms de espera]
      const t = S.focused && S.z.length >= 2 ? tokens(S.z) : [];
      S.sugs = t.length ? places.filter(p => t.every(w => p.w.some(h => h.startsWith(w)))).slice(0, 7) : []; S.sugIdx = -1;
    };
    let tq = null, ts = null;
    const setQuery = v => {                                       // onQueryChange: quita la tienda activa, «near» y «store»
      S.active = undefined; S.query = v; S.near = null; S.store = null; writeUrl(false); search();
      clearTimeout(tq); tq = setTimeout(() => { if (!alive()) return; S.dq = S.query; search(); render(); }, 300);
      clearTimeout(ts); ts = setTimeout(() => { if (!alive()) return; S.z = S.query.trim(); suggest(); render(); }, 200);
    };

    // ── dibujo ──
    const distance = d => `${nfList.format(d)} km`;
    const item = ({ s, d }) => {                                  // LocationSelector
      const b = tpl('item', s.id); if (!b) return document.createComment('');
      if (typeof d === 'number') { const g = $('.es-location-selector__distanceGroup', b), sp = document.createElement('span'); sp.className = 'es-location-selector__distance'; sp.textContent = distance(d); g.prepend(sp); }
      b.addEventListener('click', () => select(s.id));
      return b;
    };
    // lo que cambia sin que cambie la lista (tienda elegida, «Abierto/Cerrado» según la hora) se actualiza sobre los mismos nodos:
    // si se rehiciera la lista entre que se aprieta y se suelta el botón del ratón, el clic se perdería
    const refresh = b => {
      const s = byId.get(b.dataset.dmStore); if (!s) return;
      flag(b, 'data-selected', S.active === s.id);
      const os = $('.es-location-selector__openingState', b), state = os && openState(s, tz);
      if (!os) return;
      if (!state) { os.remove(); return; }
      const st = $('.es-location-selector__openingStatus', os), wh = $('.es-location-selector__workingHours', os), status = state.isOpen ? 'open' : 'closed', label = (state.isOpen ? L.open : L.closed) || '';
      if (st.dataset.openStatus !== status) st.dataset.openStatus = status;
      if (st.textContent !== label) st.textContent = label;
      if (wh) { if (!state.hours) wh.remove(); else if (wh.textContent !== state.hours) wh.textContent = state.hours; }
    };
    let listKey = null;
    const renderPanel = () => {
      const showEmpty = S.searched && S.results.length === 0, initial = !S.query && S.results.length === 0 && !showEmpty;
      const p = panel.querySelector(':scope > .es-search-section__initialStateDescription');
      if (initial && !p) { const n = tpl('initial'); if (n) panel.prepend(n); } else if (!initial && p) p.remove();
      let empty = panel.querySelector(':scope > .es-search-section__emptyStateContent'), list = panel.querySelector(':scope > .es-search-section__storeList');
      if (showEmpty) { if (!empty && (empty = tpl('empty'))) { list ? list.replaceWith(empty) : panel.append(empty); listKey = null; } return; }
      if (!list) { list = document.createElement('div'); list.className = 'es-search-section__storeList'; empty ? empty.replaceWith(list) : panel.append(list); listKey = null; }
      const key = S.results.map(r => `${r.s.id}:${r.d === undefined ? '' : distance(r.d)}`).join('|');
      if (key !== listKey) {
        const had = list.contains(document.activeElement) ? document.activeElement.dataset.dmStore : null;
        listKey = key; list.replaceChildren(...S.results.map(item));
        if (had) { const b = list.querySelector(`[data-dm-store="${CSS.escape(had)}"]`); if (b) b.focus({ preventScroll: true }); }
      }
      for (const b of list.children) if (b.dataset && b.dataset.dmStore) refresh(b);
    };
    let sugEl = null, sugKey = '';
    const renderSuggestions = show => {
      if (!show) { if (sugEl) { sugEl.remove(); sugEl = null; sugKey = ''; } return; }
      const key = S.sugs.map(s => s.id).join('\n');
      if (!sugEl || key !== sugKey) {
        const ul = document.createElement('ul'); ul.className = 'es-search-section__suggestions'; ul.id = 'store-search-suggestions'; ul.setAttribute('role', 'listbox'); ul.setAttribute('aria-label', L.suggestions || '');
        S.sugs.forEach((sg, i) => {
          const li = document.createElement('li'), b = document.createElement('button'), la = document.createElement('span');
          li.setAttribute('role', 'presentation'); b.type = 'button'; b.id = `store-search-suggestion-${i}`; b.setAttribute('role', 'option'); b.setAttribute('aria-selected', 'false'); b.className = 'es-search-section__suggestionButton';
          la.className = 'es-search-section__suggestionLabel'; la.textContent = sg.label; b.append(la);
          if (sg.description) { const de = document.createElement('span'); de.className = 'es-search-section__suggestionDescription'; de.textContent = sg.description; b.append(de); }
          b.addEventListener('mousedown', e => { e.preventDefault(); pick(sg); });
          b.addEventListener('mouseenter', () => { if (S.sugIdx !== i) { S.sugIdx = i; render(); } });
          li.append(b); ul.append(li);
        });
        sugEl ? sugEl.replaceWith(ul) : inputWrapper.append(ul); sugEl = ul; sugKey = key;
      }
      [...sugEl.children].forEach((li, i) => { const b = li.firstElementChild, act = i === S.sugIdx; flag(b, 'aria-selected', act); act ? b.setAttribute('data-active', 'true') : b.removeAttribute('data-active'); });
    };
    let detailEl = null, detailKey = null;
    const renderDetail = st => {                                  // StoreDetail dentro de div.detail (se inserta antes del cajón)
      if (!st) { if (detailEl) { detailEl.remove(); detailEl = null; detailKey = null; } return; }
      const d = S.near && st.lat !== null ? km(S.near, st) : undefined, key = `${st.id}:${d === undefined ? '' : nfDetail.format(d)}`;
      if (detailEl && key === detailKey) return;
      const el = tpl('detail', st.id); if (!el) return;
      if (d !== undefined) { const sp = document.createElement('span'); sp.className = 'es-store-detail__distance'; sp.textContent = (L.distance || 'a [distancia]').replace('[distancia]', `${nfDetail.format(d)} km`); $('.es-store-detail__intro', el).prepend(sp); }
      const day = nowIn(tz).day, row = el.querySelector(`[data-dm-day="${day === 0 ? 7 : day}"]`); if (row) row.setAttribute('data-current', 'true');
      $('.es-search-section__detailBackButton', el).addEventListener('click', () => closeDetail());
      if (detailEl) detailEl.replaceChildren(...el.childNodes); else { panel.before(el); detailEl = el; }      // otra tienda con la ficha abierta: mismo nodo, como React
      detailKey = key;
    };

    // ── animaciones (los dos useLayoutEffect y el useEffect([W]) de SearchSection) ──
    const timing = speed => DMES.timing({ speed, chunkVh: DMES.CHUNK_VH, moveMs: DMES.MOVE_MS, pauseMs: DMES.PAUSE_MS });
    let prevEE = false, prevER = false, prevW = S.W, lastClip = null, revealTl = null, revealEl = null, panelTl = null;
    const effects = (ee, er) => {
      if (ee !== prevEE || S.W !== prevW) {                       // limpieza del efecto anterior
        if (revealTl) { revealTl.kill(); revealTl = null; if (revealEl && revealEl.isConnected) revealEl.style.removeProperty('clip-path'); revealEl = null; }
        if (panelTl) { panelTl.kill(); panelTl = null; }
      }
      if (ee !== prevEE) {                                        // ficha que se abre, o lista que vuelve (escritorio): se descubre de arriba abajo
        const el = ee ? detailEl : S.W ? panel : null;
        if (el && !reduced()) {
          const { stepPx, moveMs, pauseMs } = timing(DMES.SPEED), H = window.innerHeight;
          revealEl = el; revealTl = DMES.stepped({ el, start: H, end: 0, stepPx, moveMs, pauseMs, vars: v => ({ clipPath: `inset(0 0 ${v}px 0)` }) });
          if (ee) revealTl.delay((moveMs + pauseMs) * 2);
        }
      }
      if (er !== prevER && !S.W) {                                // cajón móvil
        if (panelTl) { panelTl.kill(); panelTl = null; }
        const H = window.innerHeight;
        if (reduced() || ee) { panel.style.clipPath = `inset(${er ? 0 : H}px 0 0 0)`; panel.style.visibility = er ? 'visible' : 'hidden'; lastClip = er ? 0 : H; }
        else {
          panel.style.visibility = 'visible';
          panelTl = DMES.stepped({ el: panel, start: lastClip === null ? (er ? H : 0) : lastClip, end: er ? 0 : H, ...timing(er ? DMES.SPEED : 1.5 * DMES.SPEED),
            vars: v => ({ clipPath: `inset(${v}px 0 0 0)` }), onValue: v => { lastClip = v; }, onComplete: er ? undefined : () => { panel.style.visibility = 'hidden'; } });
        }
      }
      if (S.W !== prevW) {
        if (S.W) { panel.style.removeProperty('clip-path'); panel.style.removeProperty('visibility'); lastClip = null; }
        else if (er) { panel.style.visibility = 'visible'; panel.style.clipPath = 'inset(0px 0 0 0)'; lastClip = 0; }       // adaptación: cajón abierto al pasar a móvil
      }
      prevEE = ee; prevER = er; prevW = S.W;
    };

    const render = () => {
      const K = S.query.trim(), show = S.focused && K.length >= 2 && S.sugs.length > 0;      // Y
      const detail = S.store ? byId.get(S.store) : null, ee = !!detail, er = S.open && !ee;
      flag(root, 'data-detail-open', ee); flag(root, 'data-panel-open', er);
      flag(panel, 'data-open', er); flag(panel, 'data-store-finder-drawer', er ? 'open' : 'closed'); flag(panel, 'data-detail-open', ee);
      if (input.value !== S.query) input.value = S.query;
      input.setAttribute('value', S.query); flag(input, 'aria-expanded', show);
      if (show && S.sugIdx >= 0) input.setAttribute('aria-activedescendant', `store-search-suggestion-${S.sugIdx}`); else input.removeAttribute('aria-activedescendant');
      const icon = S.query ? 'clear' : 'geolocate';
      if (iconBtn.dataset.dmIcon !== icon) { const n = tpl(`icon-${icon}`); if (n) iconBtn.replaceChildren(n); iconBtn.dataset.dmIcon = icon; iconBtn.setAttribute('aria-label', (S.query ? L.clear : L.geolocate) || ''); }
      renderSuggestions(show); renderPanel(); renderDetail(detail); effects(ee, er); syncMap();
    };

    // ── acciones ──
    const select = id => {                                        // onSelectStore («q» de StoreFinder)
      if (!S.results.some(r => r.s.id === id)) return;
      const push = !S.store; S.active = id; S.store = id; writeUrl(push);
      window.scrollTo({ top: 0, behavior: reduced() ? 'auto' : 'smooth' });
      render();
      const back = detailEl && $('.es-search-section__detailBackButton', detailEl); if (back) back.focus({ preventScroll: true });
    };
    const closeDetail = () => {                                   // onCloseDetail
      const id = S.store; if (!id) return;
      S.store = null; writeUrl(false); render();
      const b = panel.querySelector(`[data-dm-store="${CSS.escape(id)}"]`); if (b && b.offsetParent !== null) b.focus({ preventScroll: true });
    };
    const pick = sg => { setQuery(sg.description ? `${sg.label}, ${sg.description}` : sg.label); S.open = true; S.focused = false; S.sugs = []; S.sugIdx = -1; render(); };   // «J»
    const geolocate = () => {                                     // onGeolocate
      if (!navigator.geolocation) return;
      navigator.geolocation.getCurrentPosition(pos => {
        if (!alive()) return;
        const r5 = v => Math.round(1e5 * v) / 1e5;
        clearTimeout(tq); S.query = ''; S.dq = ''; S.near = { lat: r5(pos.coords.latitude), lng: r5(pos.coords.longitude) }; S.store = null; writeUrl(false); search(); render();
      });
    };

    on(input, 'focus', () => { S.open = true; S.focused = true; suggest(); render(); });
    on(input, 'blur', () => { S.focused = false; suggest(); render(); });
    on(input, 'input', () => { setQuery(input.value); S.open = true; S.sugIdx = -1; render(); });
    on(input, 'keydown', e => {
      const show = S.focused && S.query.trim().length >= 2 && S.sugs.length > 0, n = S.sugs.length;
      if (e.key === 'Escape') { if (!show) return; e.preventDefault(); e.stopPropagation(); S.focused = false; S.sugIdx = -1; suggest(); render(); return; }
      if (e.key === 'ArrowDown') { if (!n) return; e.preventDefault(); S.sugIdx = S.sugIdx >= n - 1 ? 0 : S.sugIdx + 1; render(); return; }
      if (e.key === 'ArrowUp') { if (!n) return; e.preventDefault(); S.sugIdx = S.sugIdx <= 0 ? n - 1 : S.sugIdx - 1; render(); return; }
      if (e.key === 'Enter') { e.preventDefault(); if (S.sugIdx >= 0 && S.sugs[S.sugIdx]) { pick(S.sugs[S.sugIdx]); return; } S.open = true; render(); }
    });
    on(iconBtn, 'click', () => {
      if (S.query) { S.sugs = []; S.sugIdx = -1; setQuery(''); render(); }
      else { geolocate(); S.open = true; render(); }
    });
    on(window, 'keydown', e => {                                  // Escape: cierra la ficha o, si no hay, el cajón
      if (!alive() || e.key !== 'Escape' || document.querySelector('dialog[open]')) return;      // con un panel del sitio abierto, Escape es para ese panel
      if (S.store) closeDetail(); else if (S.open) { S.open = false; render(); }
    });
    on(window, 'popstate', () => { if (!alive()) return; const u = readUrl(); clearTimeout(tq); clearTimeout(ts); S.query = u.q; S.dq = u.q; S.z = u.q.trim(); S.near = u.near; S.store = u.store; if (u.store) S.active = u.store; search(); suggest(); render(); });
    const mql = window.matchMedia(DESKTOP);
    on(mql, 'change', () => { if (!alive()) return; S.W = mql.matches; render(); });
    // botón del cajón: clic lo cierra; arrastrarlo hacia abajo lo acompaña y lo cierra pasado un 25 % de su alto
    let dragY = null, dragD = 0;
    on(closeBtn, 'pointerdown', e => { dragY = e.clientY; dragD = 0; try { closeBtn.setPointerCapture(e.pointerId); } catch (x) {} });
    on(closeBtn, 'pointermove', e => { if (dragY === null) return; dragD = Math.max(0, e.clientY - dragY); panel.style.transform = `translateY(${dragD}px)`; });
    const dragEnd = () => {
      if (dragY === null) return; dragY = null;
      if (dragD > 0.25 * panel.offsetHeight) { lastClip = dragD; panel.style.removeProperty('transform'); S.open = false; render(); return; }
      if (dragD > 0 && panel.animate && !reduced()) panel.animate([{ transform: `translateY(${dragD}px)` }, { transform: 'translateY(0px)' }], { duration: 200, easing: 'cubic-bezier(0.215, 0.61, 0.355, 1)' });
      panel.style.removeProperty('transform');
    };
    on(closeBtn, 'pointerup', dragEnd); on(closeBtn, 'pointercancel', dragEnd);
    on(closeBtn, 'click', () => { if (dragD < 8 && S.open) { S.open = false; render(); } });
    // editor de temas: al elegir un bloque «Tienda» se abre su ficha
    const sec = root.closest('.shopify-section');
    if (sec) on(sec, 'shopify:block:select', e => { const id = e.detail && e.detail.blockId; if (byId.has(id)) { S.active = id; S.store = id; render(); } });

    // ── mapa (StoreFinderMap) ──
    let M = null, mapLoading = false, camKey = null;
    const visible = () => { const r = M.holder.getBoundingClientRect(); return r.width > 0 && r.height > 0; };
    const fit = (list, animate) => {
      const lng = list.map(r => r.s.lng), lat = list.map(r => r.s.lat);
      M.map.fitBounds([[Math.min(...lng), Math.min(...lat)], [Math.max(...lng), Math.max(...lat)]], { ...FIT, duration: animate ? FIT.duration : 0 });
    };
    function syncMap() {
      if (!M) return;
      const list = S.results.filter(r => r.s.lat !== null), ids = new Set(list.map(r => r.s.id));
      for (const [id, m] of M.markers) if (!ids.has(id)) { m.marker.remove(); M.markers.delete(id); }
      for (const { s } of list) {
        let m = M.markers.get(s.id);
        if (!m) {
          const el = document.createElement('div'), btn = tpl('pin'); if (!btn) continue;
          btn.setAttribute('aria-label', s.name); el.append(btn);
          btn.addEventListener('click', () => select(s.id));
          btn.addEventListener('mouseenter', () => { S.hovered = s.id; syncMap(); });
          btn.addEventListener('mouseleave', () => { if (S.hovered === s.id) { S.hovered = undefined; syncMap(); } });
          m = { btn, icon: 'pin', marker: new M.ml.Marker({ element: el, anchor: 'bottom' }).setLngLat([s.lng, s.lat]).addTo(M.map) }; M.markers.set(s.id, m);
        }
        const active = s.id === S.active, hovered = s.id === S.hovered, icon = active || hovered ? 'pin-filled' : 'pin';
        flag(m.btn, 'data-active', active); flag(m.btn, 'data-hovered', hovered);
        if (m.icon !== icon) { const n = tpl(`icon-${icon}`); if (n) m.btn.replaceChildren(n); m.icon = icon; }
      }
      // cámara: efecto [tienda activa, tiendas, texto buscado, zoom, mapa cargado]
      const key = `${S.active || ''}|${list.map(r => r.s.id).join(',')}|${S.dq}|${M.ready}`;
      if (key === camKey) return; camKey = key;
      if (!M.ready) return;
      const first = M.first; M.first = false;                    // el primer encuadre ya viene hecho desde el constructor (initialCamera): sin vuelo
      if (!list.length) return;
      const shown = visible(), animate = shown && !reduced() && !first;
      const go = (s, zoom) => (animate ? M.map.flyTo({ center: [s.lng, s.lat], zoom }) : M.map.jumpTo({ center: [s.lng, s.lat], zoom }));
      const act = S.active ? list.find(r => r.s.id === S.active) : undefined;
      M.pending = false;
      if (act) { go(act.s, STORE_ZOOM); return; }
      const fk = `${S.dq}:${STORE_ZOOM}`;
      if (fk === M.fitKey) return; M.fitKey = fk;
      if (list.length === 1) { go(list[0].s, STORE_ZOOM); return; }
      if (!shown) { M.pending = true; return; }                   // adaptación: sin tamaño no se puede encuadrar; se hace al mostrarse
      fit(list, animate);
    }
    // adaptación: si al crear el mapa ya hay tiendas a la vista (modo lista, ?q= ?near= ?store=), el mapa parte encuadrado en ellas en vez de en la
    // vista del país (allá el estado inicial no trae resultados, así que su primer encuadre siempre sigue a una búsqueda y va animado)
    const initialCamera = () => {
      const list = S.results.filter(r => r.s.lat !== null), act = S.active ? list.find(r => r.s.id === S.active) : undefined, one = act || (list.length === 1 ? list[0] : null);
      if (one) return { center: [one.s.lng, one.s.lat], zoom: STORE_ZOOM };
      if (list.length > 1) {
        const lng = list.map(r => r.s.lng), lat = list.map(r => r.s.lat);
        return { bounds: [[Math.min(...lng), Math.min(...lat)], [Math.max(...lng), Math.max(...lat)]], fitBoundsOptions: { padding: FIT.padding, maxZoom: FIT.maxZoom } };
      }
      return { center: cfg.map.center, zoom: cfg.map.zoom };
    };
    const loadMap = async () => {
      if (M || mapLoading) return; mapLoading = true;
      const abs = u => new URL(u, location.href).href;
      let el = null;
      try {
        await stylesheet(abs(cfg.map.css));
        const ml = await import(abs(cfg.map.js));
        ml.setWorkerUrl(abs(cfg.map.worker));
        const r = await fetch(OFM_STYLE); if (!r.ok) throw new Error(`estilo del mapa ${r.status}`);
        let style = labelsEs(await r.json());
        if (cfg.map.style !== 'liberty') style = soften(style);
        if (!alive()) return;
        el = tpl('map'); const holder = el.firstElementChild, zoom = el.querySelectorAll('.es-store-finder-map__zoomButton');
        mapSection.replaceChildren(el);
        const map = new ml.Map({ container: holder, style, ...initialCamera(), dragRotate: false, attributionControl: false });
        map.addControl(new ml.AttributionControl({ compact: true }), 'bottom-left');
        const kids = document.createElement('div'); kids.setAttribute('mapboxgl-children', ''); kids.style.height = '100%'; holder.append(kids);    // como react-map-gl
        M = { ml, map, holder, markers: new Map(), ready: false, first: true, fitKey: undefined, pending: false };
        const ready = () => { if (!M || M.ready) return; M.ready = true; syncMap(); };
        map.once('load', ready); setTimeout(ready, 4000);         // si una tesela falla, «load» puede no llegar: igual se mueve la cámara
        map.on('error', () => {});
        map.on('resize', () => { if (!M || !M.pending || !visible()) return; M.pending = false; const list = S.results.filter(r => r.s.lat !== null); if (list.length > 1 && !S.active) fit(list, false); });
        const z = d => () => map.zoomTo(map.getZoom() + d, reduced() ? { duration: 0 } : undefined);
        if (zoom[0]) zoom[0].addEventListener('click', z(1)); if (zoom[1]) zoom[1].addEventListener('click', z(-1));
        new IntersectionObserver(([e]) => { if (e) flag(el, 'data-stuck', e.boundingClientRect.top <= 0); }, { threshold: [0, 1] }).observe(el);
        syncMap();
      } catch (e) {
        console.warn('[dm-es] mapa de tiendas no disponible:', e && e.message ? e.message : e);
        if (M && M.map) { try { M.map.remove(); } catch (x) {} } M = null;
        const fb = document.createElement('div'); fb.className = 'es-store-finder__mapFallback'; if (alive()) mapSection.replaceChildren(fb);
      }
    };
    if (cfg.map && cfg.map.style !== 'off' && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(es => { if (es.some(e => e.isIntersecting)) { io.disconnect(); loadMap(); } }, { rootMargin: '300px' });
      io.observe(mapSection);
    }

    root.__dmStoreFinder = { state: S, map: () => (M ? M.map : null) };      // para depurar y para qa/stores_func.py; no lo usa nadie más

    // ── arranque: estado desde la URL; sin animación (como el primer render de React) ──
    const u = readUrl(); S.query = u.q; S.dq = u.q; S.z = u.q.trim(); S.near = u.near; S.store = u.store; if (u.store) S.active = u.store;
    search();
    prevEE = !!S.store; prevER = S.open && !prevEE;
    if (S.W) { panel.style.removeProperty('clip-path'); panel.style.removeProperty('visibility'); }
    else if (prevER) { panel.style.visibility = 'visible'; panel.style.clipPath = 'inset(0px 0 0 0)'; lastClip = 0; }
    else { panel.style.removeProperty('clip-path'); panel.style.removeProperty('visibility'); }
    render();
  });
}

/* ═══ 31-cta-list.js ═══ */
/* ───────── «Compra por categoría» (BlockCtaList de España · js_legible/0ccohg_h7ygc3.js, módulo 274242) ─────────
   Estado único = categoría activa (`h` en su código: índice o null). NO depende del scroll. Lo mueven, igual que allá:
     · pointermove sobre la <ul> con MOUSE → índice del [data-index] bajo el puntero (los huecos entre filas no cambian nada)
     · pointerleave de la <ul> con MOUSE  → null
     · foco dentro de un <li>             → su índice (no hay «blur»: queda activa)
     · pointerdown TÁCTIL sobre un <li>   → su índice (no hay «soltar»: en móvil queda activa)
   Cada cambio deja en el DOM lo mismo que su render, y en el mismo orden de su commit (hijos antes que el padre; efectos al final):
     · li[data-active]                         true solo en la activa (el CSS le cambia el color)
     · assetSlide[data-active|data-shown]      activa / ya se mostró alguna vez (queda debajo, quieta)
     · assetSlide style z-index                orden de activación (hook `o`: contador por cuadro; «default» = 1, la primera activa = 2…)
     · assetWrapper[data-has-active]           true si la activa tiene foto en ese cuadro (o hay foto por defecto)
     · efecto de layout de `o` sobre la foto recién activada: salta sin transición a translateY(100%) —cuadro «category»— o
       translateY(-100%) —cuadro «decorative»—, se fuerza el reflow y se sueltan transition/transform: entra con la transición del
       CSS (transform · --dur-panel .42s · --ease-regular). Al quedar sin activa, el CSS retira todas las fotos del cuadro.
   Marcado: dm-cta-list.liquid (assetSlide[data-dm-key] = índice de su categoría; «default» = foto por defecto, si la hubiera). */
{
  const put = (el, k, v) => { if (el.dataset[k] !== v) el.dataset[k] = v; };
  DMES.on('.es-block-cta-list__container', root => {
    const list = $('.es-block-cta-list__ctaList', root);
    if (!list) return;
    const items = $$('.es-block-cta-list__ctaItem', list);
    // un «hook o(slot, clave)» por cuadro de fotos: render(h) deja los atributos y devuelve su efecto de layout (o null)
    const slots = $$('.es-block-cta-list__assetWrapper', root).map(wrapper => {
      const slides = $$('.es-block-cta-list__assetSlide', wrapper);
      const byKey = new Map(slides.map(el => [el.dataset.dmKey, el]));
      const from = slides[0] && slides[0].dataset.slot === 'category' ? '100%' : '-100%';
      const shown = new Set(['default']), order = new Map([['default', 1]]);
      let count = 1, last = 'default';
      return h => {
        const key = h !== null && byKey.has(String(h)) ? String(h) : 'default';
        const changed = last !== key;
        shown.add(key);
        if (changed) { count += 1; order.set(key, count); last = key; }
        byKey.forEach((el, k) => {
          put(el, 'active', String(k === key));
          put(el, 'shown', String(shown.has(k)));
          if (order.has(k) && el.style.zIndex !== String(order.get(k))) el.style.zIndex = String(order.get(k));
        });
        put(wrapper, 'hasActive', String(key !== 'default' || byKey.has('default')));
        const el = changed ? byKey.get(key) : null;
        return el ? () => {
          Object.assign(el.style, { transition: 'none', transform: `translateY(${from})` });
          void el.offsetHeight;   // reflow: fija el punto de partida antes de soltar la transición
          Object.assign(el.style, { transition: '', transform: '' });
        } : null;
      };
    });
    let active = null;
    const set = h => {
      if (h === active) return;
      active = h;
      items.forEach(li => put(li, 'active', String(Number(li.dataset.index) === h)));
      slots.map(render => render(h)).forEach(effect => effect && effect());
    };
    list.addEventListener('pointermove', e => {
      if (e.pointerType !== 'mouse') return;
      const t = e.target.closest('[data-index]');
      if (!t || t.dataset.index === undefined) return;
      set(Number(t.dataset.index));
    });
    list.addEventListener('pointerleave', e => { if (e.pointerType === 'mouse') set(null); });
    items.forEach(li => {
      const i = Number(li.dataset.index);
      li.addEventListener('focusin', () => set(i));
      li.addEventListener('pointerdown', e => { if (e.pointerType === 'touch') set(i); });
    });
  });
}

/* ═══ 32-dms-world.js ═══ */
/* ───────── El universo DM's: barra de categorías y carrusel destacado ─────────
   Los dos componentes viven en las 5 portadas (la barra) y en la portada general + los 27 artículos (el carrusel); el resto de los módulos de
   las portadas (page-intro, article-highlight, article-grid/card/thumbnail, category-label, tab-appearance) es solo CSS en España.

   1) DmsWorldNav (js_legible/3_ufcvkz30f42.js · módulo 56761 + useHorizontalScroll 816354)
      · al montar: window.scrollTo({top: 0}) suave, o instantáneo con «reducir movimiento» (allá corre en cada cambio de ruta: acá cada
        categoría es una página, así que corre al cargar)
      · data-visible = (el centinela <div aria-hidden> que va justo antes de la barra ya salió de pantalla) && !(el <footer> entró en la mitad
        superior de la ventana · IntersectionObserver rootMargin «0px 0px -50% 0px»). El desvanecido y el `top` que sigue a la barra principal
        son CSS (--dynamic-nav-height).
      · flechas: solo existen en el DOM si la lista no cabe (scrollWidth > clientWidth + 1); «anterior» deshabilitada al inicio
        (scrollLeft <= 0), «siguiente» al final (scrollLeft + clientWidth >= scrollWidth - 1); cada clic desplaza 0,8 × el ancho visible, suave.
        Se recalcula al montar, al hacer scroll en la lista y cuando cambia su tamaño. El CSS solo las muestra con mouse (hover + puntero fino).
      Textos de las flechas: data-dm-prev / data-dm-next (aria-label) y data-dm-prev-title / data-dm-next-title (<title> del ícono), que pone
      es/pages/handlers_dwidx.py; el dibujo se copia del sprite global (#_RI-arrow-left / -right), igual al SVG «inline» de España.

   2) DmsWorldFeaturedCarousel (js_legible/0ccohg_h7ygc3.js · módulo 462395) sobre Carousel / CarouselControl (0qdg9j73_qrip.js · 553360 / 221860)
      Scroll nativo: el marcado ya trae los estilos en línea que pone React (overflow, scroll-snap-type:none, scroll-behavior:smooth). Acá el estado:
      · progreso = round(scrollLeft / (scrollWidth - offsetWidth), 3) (1 si no hay scroll) · habilitado = scrollWidth > offsetWidth (ResizeObserver)
      · índice aproximado al hacer scroll = getItemIndexAtScroll con peso .5; con las flechas manda el índice destino hasta que el scroll queda
        quieto (200 ms sin eventos; se mide a lo más cada 50 ms)
      · flecha → next()/previous(): scrollTo({left: offsetLeft del ítem destino, behavior: 'smooth'}); tocar, rueda o puntero sobre el carrusel
        cancela la navegación en curso
      · cada grupo de flechas (.nav de escritorio y de móvil): data-hidden = !habilitado; «anterior» disabled si progreso <= 0, «siguiente» si
        progreso >= 1, y ambas si no se puede avanzar en ese sentido (primer / último ítem activo)
      A diferencia de la galería del PDP, este carrusel NO se arrastra con el mouse en España (no usa useCarouselPointerDrag): por eso lleva su
      propio estado y no DMES.carousel. Teclado: la raíz es enfocable (tabindex=0) y las flechas del teclado la desplazan de forma nativa. */
{
  const SVGNS = 'http://www.w3.org/2000/svg';
  /* <svg viewBox="0 0 20 20" xml:space="preserve"><title>…</title><g>…dibujo…</g></svg> = componente Svg de España con type="inline" */
  const inlineIcon = (name, title) => {
    const svg = document.createElementNS(SVGNS, 'svg');
    svg.setAttribute('viewBox', '0 0 20 20');
    svg.setAttributeNS('http://www.w3.org/XML/1998/namespace', 'xml:space', 'preserve');
    const t = document.createElementNS(SVGNS, 'title'); t.textContent = title;
    const g = document.createElementNS(SVGNS, 'g'), src = document.getElementById(`_RI-${name}`);
    if (src) for (const c of src.childNodes) g.append(c.cloneNode(true));
    svg.append(t, g);
    return svg;
  };

  /* ── barra de categorías ── */
  DMES.on('.es-dms-world-nav__nav', nav => {
    const list = $('.es-dms-world-nav__list', nav);
    window.scrollTo({ top: 0, behavior: reduced() ? 'auto' : 'smooth' });

    let past = false, atFooter = false;
    const show = () => nav.setAttribute('data-visible', String(past && !atFooter));
    const sentinel = nav.previousElementSibling;
    if (sentinel && sentinel.matches('div[aria-hidden="true"]')) {
      new IntersectionObserver(en => { en.forEach(e => { past = !e.isIntersecting; }); show(); }).observe(sentinel);
    }
    const footer = $('footer');
    if (footer) new IntersectionObserver(en => { en.forEach(e => { atFooter = e.isIntersecting; }); show(); }, { rootMargin: '0px 0px -50% 0px' }).observe(footer);

    if (!list) return;
    const d = nav.dataset;
    const arrow = (dir, label, icon, title) => {
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'es-dms-world-nav__arrow';
      b.setAttribute('data-direction', dir); b.setAttribute('aria-label', label);
      b.append(inlineIcon(icon, title));
      b.addEventListener('click', () => list.scrollBy({ left: (dir === 'prev' ? -1 : 1) * list.clientWidth * 0.8, behavior: 'smooth' }));
      return b;
    };
    let prev = null, next = null;
    const edges = () => {
      const atStart = list.scrollLeft <= 0, atEnd = list.scrollLeft + list.clientWidth >= list.scrollWidth - 1;
      if (list.scrollWidth > list.clientWidth + 1) {
        if (!prev) {
          prev = arrow('prev', d.dmPrev || 'Anterior', 'arrow-left', d.dmPrevTitle || 'Previous');
          next = arrow('next', d.dmNext || 'Siguiente', 'arrow-right', d.dmNextTitle || 'Next');
        }
        if (!prev.isConnected) list.before(prev);
        if (!next.isConnected) list.after(next);
        prev.disabled = atStart; next.disabled = atEnd;
      } else if (prev) { prev.remove(); next.remove(); }
    };
    edges();
    new ResizeObserver(edges).observe(list);
    list.addEventListener('scroll', edges, { passive: true });
  });

  /* ── carrusel destacado ── */
  DMES.on('.es-dms-world-featured-carousel__container', sec => {
    const root = $('.es-dms-world-featured-carousel__slider', sec);
    if (!root) return;
    const items = () => [...root.children].filter(e => e.classList.contains('es-dms-world-featured-carousel__item'));
    const S = { progress: 0, enabled: true, approx: 0, nav: -1, behavior: 'smooth' };
    let base = 0, acc = 0;      // `d` y `u` del store de España: índice de partida y pasos acumulados mientras dura una navegación

    const indexAt = (direction, weight = 1) => {
      const p = root.scrollLeft;
      return items().findIndex(it => {
        const w = it.offsetWidth, l = it.offsetLeft;
        return typeof direction === 'number'
          ? Math.floor(l + (w - 10) * ((direction + 1) / 2) * weight) > Math.floor(p + direction)
          : Math.floor(l) > Math.floor(p);
      });
    };
    const posAt = it => it.offsetLeft - (parseFloat(getComputedStyle(it).getPropertyValue('scroll-margin-inline-start')) || 0);
    const progress = () => {
      const n = root.scrollWidth - root.offsetWidth;
      if (n <= 0) return 1;
      return Math.min(Math.max(Math.round((root.scrollLeft / n + Number.EPSILON) * 1000) / 1000, 0), 1);
    };
    const clamp = i => Math.min(Math.max(i, 0), items().length - 1);

    const navs = $$('.es-dms-world-featured-carousel__nav', sec).map(n => ({ el: n, btns: $$('.es-dms-world-featured-carousel__navButton', n) }));
    const render = () => {
      const last = Math.max(items().length - 1, 0), active = S.nav !== -1 ? S.nav : S.approx;
      let l = S.progress; if (active === 0) l = 0; else if (active === last) l = 1;
      const can = dir => S.enabled && !(l === 0 && dir === 'previous') && !(l === 1 && dir === 'next');
      for (const { el, btns: [bPrev, bNext] } of navs) {
        el.setAttribute('data-hidden', String(!S.enabled));
        if (bPrev) bPrev.disabled = S.progress <= 0 || !can('previous');
        if (bNext) bNext.disabled = S.progress >= 1 || !can('next');
      }
    };
    const setNav = i => {
      if (S.nav === i) return;
      S.nav = i;
      const it = i === -1 ? null : items()[i];
      if (it) { root.scrollTo({ left: posAt(it), behavior: S.behavior }); S.behavior = 'smooth'; }
      render();
    };
    const moveBy = delta => {
      if (S.nav === -1) base = indexAt(Math.sign(delta));
      const t = clamp(S.nav === -1 ? base + acc + delta : S.nav + delta);
      acc = t - base; S.behavior = 'smooth'; setNav(t);
    };
    for (const { btns: [bPrev, bNext] } of navs) {
      if (bPrev) bPrev.addEventListener('click', e => { if (!e.defaultPrevented) moveBy(-1); });
      if (bNext) bNext.addEventListener('click', e => { if (!e.defaultPrevented) moveBy(1); });
    }

    let lastP = progress(), idle = 0, busy = false;
    const measure = state => {
      const o = progress(), dlt = o - lastP; lastP = o;
      const i = indexAt(dlt, 0.5);
      if (i !== -1) S.approx = i;
      S.progress = o;
      if (state === 'idle') { S.nav = -1; acc = 0; }
      render();
    };
    root.addEventListener('scroll', () => {
      clearTimeout(idle); idle = setTimeout(() => requestAnimationFrame(() => measure('idle')), 200);
      if (!busy) { busy = true; requestAnimationFrame(() => measure('scrolling')); setTimeout(() => { busy = false; }, 50); }
    }, { passive: true });
    const cancel = () => setNav(-1);
    root.addEventListener('touchstart', cancel, { passive: true });
    root.addEventListener('wheel', cancel, { passive: true });
    root.addEventListener('pointerdown', cancel, { passive: true });
    new ResizeObserver(() => { S.progress = progress(); S.enabled = root.scrollWidth > root.offsetWidth; render(); }).observe(root);
  });
}

/* ═══ 35-justified-text.js ═══ */
/* ───────── texto justificado «cosido» (JustifiedText de España · js_legible/3zzrxjqtzihb-.js, módulo 94158) ─────────
   Marcado (tal cual el de España): div.es-justified-text__wrapper[translate=no] > p.es-justified-text__inner.notranslate > span.es-justified-text__word…
   Lo usan el hero de los artículos (hero-editorial «split») y block-statement, siempre con animate="stitch" y trigger="on-view":
     · al montar, todas las palabras quedan en opacity:0 (gsap.set)
     · cuando el bloque entra en pantalla (ScrollTrigger start «top 90%»; si ya está a la vista, al cargar) corre un ciclo sin fin:
       las palabras aparecen de a una, en orden AL AZAR (se sortea una vez), cada 60 ms; quedan 6 s; se van en el orden inverso, cada 60 ms;
       medio segundo en blanco y vuelve a empezar (timeline repeat:-1, repeatDelay:.5; visible(i) ⇔ .06·i ≤ t < .06·n + 6 + .06·(n-1-i))
     · con «reducir movimiento» no hace nada: el texto queda fijo y visible
   Lo único que se mueve es style="opacity: 0|1" de cada palabra, igual que allá. Sin bucle por cuadro: un temporizador por cambio.
   El del diálogo de newsletter lo anima es/js/50-footer.js (solo mientras está abierto): acá se salta.
   Los otros modos del componente (scatter, scatter-x, on-scroll) no se usan en ninguna página capturada: no se portan. */
{
  const STEP = 0.06, HOLD = 6, GAP = 0.5;
  DMES.on('.es-justified-text__wrapper', el => {
    if (el.closest('.es-newsletter-pop-up__stitchedText')) return;
    const words = $$('.es-justified-text__word', el);
    if (!words.length || reduced()) return;
    words.forEach(w => { w.style.opacity = '0'; });
    const order = [...words];
    for (let i = order.length - 1; i > 0; i--) { const r = Math.floor(Math.random() * (i + 1)); [order[i], order[r]] = [order[r], order[i]]; }
    const n = order.length, out = STEP * n + HOLD, cycle = out + STEP * (n - 1) + GAP;
    let t0 = null, timer = 0;
    const paint = () => {
      const t = ((performance.now() - t0) / 1000) % cycle;
      let next = cycle;
      order.forEach((w, i) => {
        const a = STEP * i, b = out + STEP * (n - 1 - i), o = t >= a && t < b ? '1' : '0';
        if (w.style.opacity !== o) w.style.opacity = o;
        if (a > t && a < next) next = a;
        if (b > t && b < next) next = b;
      });
      timer = setTimeout(paint, Math.max(8, (next - t) * 1000 + 1));
    };
    const enter = () => {
      if (t0 !== null || el.getBoundingClientRect().top > window.innerHeight * 0.9) return;
      window.removeEventListener('scroll', enter); window.removeEventListener('resize', enter);
      t0 = performance.now(); paint();
    };
    window.addEventListener('scroll', enter, { passive: true }); window.addEventListener('resize', enter, { passive: true });
    enter();
    // al volver a la pestaña el reloj siguió corriendo: repintar de una vez en vez de esperar al temporizador (que el navegador pudo frenar)
    document.addEventListener('visibilitychange', () => { if (t0 !== null && !document.hidden) { clearTimeout(timer); paint(); } });
  });
}

/* ═══ 36-hero-editorial.js ═══ */
/* ───────── cabecera de artículo (HeroEditorial de España · js_legible/3xwywgmm5w79-.js, módulo 173880) ─────────
   El marcado llega completo del conversor (es/pages/transpile.py); lo que España agrega al hidratar es el TIEMPO DE LECTURA, como primer nodo
   de .es-hero-editorial__articleInfo (antes del autor): «N min de lectura» (i18n dmwReadTime).
   España: N = max(1, ceil(palabras / 225)), palabras = texto de todos los «p, h1…h6, li, blockquote» del <article> al montar. Ese conteo
   incluye el texto de sus tarjetas de producto tal como viene del servidor, así que con las tarjetas locales daría otro número: el
   conversor deja en data-dm-minutes el que muestra España (es/pages/handlers_dw.py → read_time) y se usa ese. Sin el dato, se calcula igual
   que allá (en <main>: en el encabezado puede haber <article> de tarjetas).
   El resto del hero no lleva lógica propia: el titular es «headline» (20-headline.js), el texto cosido «justified-text» (35-justified-text.js)
   y el video «asset» (10-video.js). */
{
  const WPM = 225, LABEL = '{n} min de lectura';
  DMES.on('.es-hero-editorial__articleInfo', info => {
    if (info.dataset.dmRead) return;
    let minutes = Number.parseInt(info.dataset.dmMinutes, 10);
    if (!(minutes > 0)) {
      const scope = info.closest('main') || document, article = scope.querySelector('article');
      const text = article ? [...article.querySelectorAll('p, h1, h2, h3, h4, h5, h6, li, blockquote')].map(e => e.textContent || '').join(' ') : '';
      minutes = article ? Math.max(1, Math.ceil(text.trim().split(/\s+/).filter(Boolean).length / WPM)) : 1;
    }
    info.dataset.dmRead = String(minutes);
    info.prepend(document.createTextNode(LABEL.replace('{n}', String(minutes))));
  });
}

/* ═══ 37-shop-panel.js ═══ */
/* ───────── panel «comprar el look» de las fotos editoriales (EditorialAssetShopCta + ProductShopPanel de España · js_legible/1s_6-rdlpveo0.js,
   módulos 284881 y 998702) ─────────
   Marcado: snippets/dm-es-shop-panel.liquid (botón sobre la foto + <dialog class="es-panel__container es-product-shop-panel__panel">) con las
   tarjetas de snippets/dm-es-shop-cards.liquid. Casi todo el comportamiento es de componentes que ya están portados:
     · abrir / cerrar / animar / clic afuera / expandirse en móvil   Panel + DialogTrigger + DialogDismiss  → es/js/05-panel.js (commandfor / command)
     · tarjeta (pase de fotos, colores) y botón de agregar rápido     ProductCard con quickAddAlwaysVisible  → es/js/61-product-card.js (data-quick-add-visible es solo CSS)
     · elegir talla y agregar                                         QuickAddPanel, que abre ENCIMA de este → es/js/62-quick-add.js
   Lo único propio: en España, al agregar un producto se cierran TODOS los diálogos abiertos (closeAllDialogs, js_legible/1jm4nhu_syg-5.js) y
   recién entonces aparece «Añadido al carrito». El panel de agregar rápido solo se cierra a sí mismo, así que este panel se cierra acá, con el
   mismo aviso que usa el resto del theme («cart:update» con source product-form-component; lo emite 62-quick-add.js antes de que
   81-upsell-panel.js abra el suyo). */
{
  document.addEventListener('cart:update', e => {
    const d = (e.detail && e.detail.data) || {};
    if (d.source !== 'product-form-component' || !DMES.dialog) return;
    $$('dialog.es-product-shop-panel__panel[open]').forEach(p => DMES.dialog.requestClose(p));
  });
}

/* ═══ 40-scale-carousel.js ═══ */
/* ───────── carrusel escalado (ScaleCarousel de España + su motor «vce») ─────────
   Port de js_legible/0ccohg_h7ygc3.js, módulo 679663 (clases _ = gesto de arrastre, k = rueda, b = slide, j = motor, P = ScaleCarousel).
   Reutilizable: cualquier `ul.es-scale-carousel__root[data-slot="vce-root"]` con el marcado de España
     li[data-slot=item] > (div[data-slot=header])? + div[data-slot=vce-slide] > div[data-slot=mask] + (div[data-slot=footer])?
     li[data-slot=controls][data-drag-exempt] > div > button (anterior) + button (siguiente)
   `data-variant` del HTML = alineación pedida (center | start; España la pasa como prop `align`). Hasta 1024 px de ventana rige «narrow».
   Deja en el DOM lo mismo que React + GSAP: --offset y data-variant en la raíz; opacity en cada li; translate/rotate/scale:none + transform
   en slide y máscara; opacity + z-index en header/footer; data-hidden en la flecha «anterior».
   No hay clones: el bucle sale de envolver la posición de cada slide en ±pista/2 (positionAt).
   API: DMES.scaleCarousel(ul) → { next(), prev() } (también queda en ul.dmScaleCarousel). */
{
  /* utilidades de España (módulo 56334) y de GSAP (utils.interpolate con lista) */
  const clamp = (e, [t, a]) => Math.min(Math.max(e, t), a);
  const mapRange = (e, [r, o], [n, i]) => n + ((e - r) / (o - r)) * (i - n);                      // «transform»
  const wrap = (e, [t, a]) => { const r = a - t + 1; return ((((e - t) % r) + r) % r) + t; };       // el rango es inclusivo: período = a − t + 1
  const shortest = (e, t, s) => { let i = t - e; if (Math.abs(i) > s / 2) i > 0 ? (i -= s) : (i += s); return i; };
  const interp = (arr, p) => { const t = p * (arr.length - 1), i = Math.min(arr.length - 2, ~~t), f = t - i; return (1 - f) * arr[i] + f * arr[i + 1]; };
  const r4 = v => Math.round(v * 10000) / 10000;                                                    // GSAP escribe con 4 decimales

  /* curva «regular» de España (CustomEase .45,.02,.09,.98) y tweens sobre un único requestAnimationFrame, en orden de creación (como el ticker de GSAP) */
  const bezier = (x1, y1, x2, y2) => {
    const cx = 3 * x1, bx = 3 * (x2 - x1) - cx, ax = 1 - cx - bx, cy = 3 * y1, by = 3 * (y2 - y1) - cy, ay = 1 - cy - by;
    const fx = t => ((ax * t + bx) * t + cx) * t, fy = t => ((ay * t + by) * t + cy) * t, dx = t => (3 * ax * t + 2 * bx) * t + cx;
    return x => {
      if (x <= 0) return 0; if (x >= 1) return 1;
      let t = x;
      for (let i = 0; i < 8; i++) { const e = fx(t) - x; if (Math.abs(e) < 1e-6) return fy(t); const d = dx(t); if (Math.abs(d) < 1e-6) break; t -= e / d; }
      let lo = 0, hi = 1; t = x;
      for (let i = 0; i < 40 && hi - lo > 1e-7; i++) { const e = fx(t); if (Math.abs(e - x) < 1e-6) break; if (x > e) lo = t; else hi = t; t = (hi + lo) / 2; }
      return fy(t);
    };
  };
  const REGULAR = bezier(0.45, 0.02, 0.09, 0.98);
  const DUR = { base: 0.3, panel: 0.42, expressive: 0.6 };                                         // DURATIONS_S (módulo 721773)
  const live = new Set(); let raf = 0;
  const run = now => { raf = 0; for (const t of [...live]) if (!t.killed) t.step(now); if (live.size) raf = requestAnimationFrame(run); };
  /* from puede ser función: se lee al arrancar (tras el retardo), igual que GSAP lee el valor inicial en el primer render */
  const tween = ({ from, to, duration, delay = 0, onUpdate, onComplete }) => {
    const t0 = performance.now() + delay * 1000; let a = null;
    const tw = { killed: false, kill() { tw.killed = true; live.delete(tw); } };
    tw.step = now => {
      const el = now - t0; if (el < 0) return;
      if (a === null) a = typeof from === 'function' ? from() : from;
      const p = duration > 0 ? Math.min(1, el / (duration * 1000)) : 1;
      onUpdate(a + (to - a) * REGULAR(p));
      if (p >= 1 && !tw.killed) { live.delete(tw); onComplete && onComplete(); }
    };
    live.add(tw); if (!raf) raf = requestAnimationFrame(run);
    return tw;
  };

  /* gesto de arrastre (clase «_»): ratón y táctil, umbral 5 px, delta por evento; el clic posterior a un arrastre se anula en captura */
  const dragGesture = emit => {
    const st = { xy: [0, 0], delta: [0, 0], total: { distance: [0, 0] }, gesture: { startxy: [undefined, undefined], distance: [0, 0], endxy: [undefined, undefined] } };
    let dragging = false, el = null;
    const fire = (type, ev) => emit(type, { ...st, originalEvent: ev });
    const exempt = ev => !!(ev && ev.target instanceof Element && ev.target.closest('[data-drag-exempt]'));
    const onClick = e => { if (!dragging || exempt(e)) return; e.preventDefault(); e.stopPropagation(); };
    const onDragStart = e => { e.preventDefault(); return false; };
    const WIN = () => [['mousemove', mm], ['mouseup', mu], ['touchmove', tm, { passive: false }], ['touchend', te, { passive: false }], ['touchcancel', te, { passive: false }], ['contextmenu', mu]];
    const start = ({ x, y }, ev) => {
      if (exempt(ev)) return;
      if (el) { el.addEventListener('click', onClick, { capture: true }); WIN().forEach(([n, f, o]) => window.addEventListener(n, f, o)); }
      st.gesture.endxy[0] = undefined; st.gesture.endxy[1] = undefined; st.gesture.startxy[0] = x; st.gesture.startxy[1] = y;
      dragging = false; st.xy[0] = x; st.xy[1] = y;
    };
    const move = ({ x, y }, ev) => {
      const i = x - st.xy[0], a = y - st.xy[1];
      st.xy[0] = x; st.xy[1] = y; st.delta[0] = i; st.delta[1] = a; st.total.distance[0] += i; st.total.distance[1] += a;
      st.gesture.distance[0] = x - st.gesture.startxy[0]; st.gesture.distance[1] = y - st.gesture.startxy[1];
      if (!dragging) {
        if (Math.abs(st.gesture.distance[0]) > 5 || Math.abs(st.gesture.distance[1]) > 5) { fire('drag:start', ev); dragging = true; }
        return;
      }
      fire('drag:move', ev);
    };
    const end = ({ x, y }, ev) => {
      WIN().forEach(([n, f]) => window.removeEventListener(n, f));
      st.gesture.endxy[0] = x; st.gesture.endxy[1] = y;
      setTimeout(() => { dragging = false; fire('drag:end', ev); }, 0);       // después del clic: así el clic de un arrastre llega con dragging = true
    };
    const touch = fn => t => { const s = t.touches[0] || t.changedTouches[0]; s && fn({ x: s.clientX, y: s.clientY }, t); };
    const mouse = fn => t => fn({ x: t.clientX, y: t.clientY }, t);
    const md = mouse(start), ts = touch(start), mm = mouse(move), tm = touch(move), mu = mouse(end), te = touch(end);
    return {
      attach(node) {
        el = node; if (!el) return;
        el.addEventListener('click', onClick, { capture: true }); el.addEventListener('dragstart', onDragStart, { capture: true });
        el.addEventListener('mousedown', md); el.addEventListener('touchstart', ts, { passive: true });   // España: passive:false; acá nunca se cancela el touchstart (solo el touchmove), así que va pasivo
      },
      detach() {
        if (el) {
          el.removeEventListener('click', onClick, { capture: true }); el.removeEventListener('dragstart', onDragStart, { capture: true });
          el.removeEventListener('mousedown', md); el.removeEventListener('touchstart', ts);
          WIN().forEach(([n, f]) => window.removeEventListener(n, f));
        }
        el = null;
      },
    };
  };

  /* rueda / trackpad (clase «k»): el primer evento abre el gesto, los siguientes mueven, 50 ms sin eventos lo cierran */
  const wheelGesture = emit => {
    const st = { delta: [0, 0], total: { distance: [0, 0] }, gesture: { distance: [0, 0] } };
    let wheeling = false, el = null, timer = null;
    const fire = (type, ev) => emit(type, { ...st, originalEvent: ev });
    const onWheel = e => {
      if (!el) return;
      const t = -1 * e.deltaX, s = -1 * e.deltaY;
      if (wheeling) {
        st.delta[0] = t; st.delta[1] = s; st.total.distance[0] += t; st.total.distance[1] += s; st.gesture.distance[0] += t; st.gesture.distance[1] += s;
        fire('wheel:move', e);
        if (timer !== null) clearTimeout(timer);
        timer = setTimeout(() => { wheeling = false; fire('wheel:end', e); }, 50);
      } else { st.gesture.distance[0] = 0; st.gesture.distance[1] = 0; wheeling = true; fire('wheel:start', e); }
    };
    return {
      attach(node) { el = node; el && el.addEventListener('wheel', onWheel, { passive: false }); },
      detach() { el && el.removeEventListener('wheel', onWheel); el = null; },
    };
  };

  /* motor (clase «j» + slide «b»): mide, guarda la posición y la mueve con los gestos; no pinta nada.
     on(tipo, detalle): 'position:change' {position, direction, type: start|move|end} · 'resize' · 'ready' */
  const RECIPE = {
    alignStart: (e = 0) => ({ trackSize: (t, s) => s.reduce((t, s) => t + s + e, 0), setupSlide: (t, s) => ({ gap: e, trackBounds: [-t.size, s.track - t.size] }) }),
    alignCenter: (e = 0) => ({ trackSize: (t, s) => s.reduce((t, s) => t + s + e, 0), setupSlide: (t, s) => ({ gap: e, trackBounds: [-s.track / 2, s.track / 2] }) }),
  };
  const vce = on => {
    const E = { slides: [], sizes: { root: 0, track: 0 }, readyState: 'not-ready' };
    let root = null, ro = null, bounds = [-Infinity, Infinity], pos = 0, dir = 0, canceled = false;
    let opts = { axis: 'x', bounds: () => [-Infinity, Infinity], ...RECIPE.alignStart() };
    const mkSlide = node => {
      const s = { node, index: 0, size: 0, gap: 0, snap: 0, tb: [0, 0] };
      s.update = (e, prev) => { s.index = e.index ?? s.index; s.size = e.size ?? s.size; s.gap = e.gap ?? s.gap; s.tb = e.trackBounds ?? s.tb; s.snap = prev ? prev.snap + prev.size + prev.gap : 0; };
      s.distanceFrom = e => -1 * shortest(wrap(-1 * e, [0, E.sizes.track]), s.snap, E.sizes.track);
      s.positionAt = e => wrap(e + s.snap, s.tb);
      return s;
    };
    const measure = () => {
      const k = opts.axis === 'x' ? 'width' : 'height', t = E.slides.map(s => s.node.getBoundingClientRect()[k]);
      E.sizes.root = root ? root.getBoundingClientRect()[k] : 0;
      E.sizes.track = Math.floor(opts.trackSize(E.sizes, t));
      const set = [];
      for (let e = 0; e < E.slides.length; e++) {
        const i = { index: e, size: t[e] ?? 0 }, a = opts.setupSlide(i, E.sizes);
        set[e] = { ...i, ...a, trackBounds: [Math.floor(a.trackBounds[0]), Math.floor(a.trackBounds[1])] };
      }
      E.slides.forEach((s, i) => s.update(set[i], E.slides[i - 1]));
      bounds = opts.bounds(E.sizes, set);
      on('resize');
      if (E.readyState !== 'ready') { on('ready'); E.readyState = 'ready'; }
    };
    const change = (e, t, type) => { dir = t; const a = Math.round(clamp(e, bounds)); on('position:change', { position: a, direction: t, type }); pos = a; dir = 0; };
    /* bloqueo de eje: un gesto más vertical que horizontal se cancela (la página se desplaza); si cambia a mitad de gesto se reabre o se cierra */
    const axisLock = (type, d) => {
      let t = type.split(':')[1]; const s = t === 'start' ? 1 : 2;
      const i = opts.axis === 'x' ? Math.abs(d.delta[0]) < Math.abs(d.delta[1]) * s : Math.abs(d.delta[1]) < Math.abs(d.delta[0]) * s;
      switch (t) {
        case 'start': canceled = i; break;
        case 'move': if (canceled !== i) { canceled = i; t = i ? 'end' : 'start'; } break;
        case 'end': if (canceled) canceled = false;
      }
      return { type: t, canceled };
    };
    const gesture = (type, d) => {
      const t = axisLock(type, d); if (t.canceled) return;
      d.originalEvent && d.originalEvent.cancelable && d.originalEvent.preventDefault();
      const delta = d.delta[+(opts.axis !== 'x')], sg = Math.sign(delta);
      change(pos + delta, sg !== 0 ? sg : dir, t.type);
    };
    const drag = dragGesture(gesture), wheel = wheelGesture(gesture);
    E.cleanup = () => { root = null; E.slides = []; ro && ro.disconnect(); ro = null; drag.detach(); wheel.detach(); };
    E.update = (node, o) => {
      E.cleanup(); root = node || null;
      if (root) root.dataset.slot = 'vce-root';
      if (o) opts = { ...opts, ...o };
      /* = `[data-slot=vce-slide]:not(:scope [data-slot=vce-root] [data-slot=vce-slide])`: los slides propios, no los de un carrusel anidado */
      E.slides = root ? [...root.querySelectorAll('[data-slot="vce-slide"]')].filter(n => n.parentElement.closest('[data-slot="vce-root"]') === root).map(mkSlide) : [];
      if (root) { ro = new ResizeObserver(() => measure()); ro.observe(root); E.slides.forEach(s => ro.observe(s.node)); }
      drag.attach(root); wheel.attach(root);
    };
    E.getPosition = () => pos;
    E.syncPosition = e => { pos = clamp(e, bounds); };
    E.getSlideAtPosition = e => E.slides.reduce((t, s) => { const i = Math.abs(s.positionAt(e)); return i < t.distance ? { slide: s, distance: i } : t; }, { slide: null, distance: Infinity }).slide;
    E.roundPositionToSnap = e => {
      const t = wrap(-1 * e, [0, E.sizes.track]), s = E.slides.map(x => x.snap), all = [...s, E.sizes.track];
      let a = all[0]; for (const i of all) if (Math.abs(i - t) < Math.abs(a - t)) a = i;
      if (a === E.sizes.track) a = s[0];
      return e + -1 * shortest(t, a ?? 0, E.sizes.track);
    };
    return E;
  };

  /* tablas de ScaleCarousel: escala por posición relativa, corrimiento que cierra los huecos de las fotos achicadas y alineación */
  const displacement = (e, t, s) => {
    const i = []; let a = 0;
    const l = (k, sign) => { const o = (1 - (t[k] ?? 1)) * e; i[k] = sign * (o / 2 + a); a += o; };
    let o = s - 1; for (; o >= 0;) { l(o, 1); o--; }
    for (o = s + 1, a = 0; o < t.length;) { l(o, -1); o++; }
    i[s] = 0; return i;
  };
  const table = (scale, mid) => { let ks = null, kv = null; return { scale, displacement: s => (s === ks ? kv : (kv = displacement((ks = s), scale, mid))) }; };
  const ANIM = {
    narrow: { progress: e => [-(2 * e), 2 * e], ...table([0.6, 0.6, 1, 0.6, 0.6], 2) },
    start: { progress: e => [-(2 * e), 5 * e], ...table([0.6, 0.6, 1, 0.5, 0.8, 0.6, 0.9, 1], 2) },
    center: { progress: e => [-(4 * e), 4 * e], ...table([1, 1, 0.85, 0.6, 1, 0.6, 0.85, 1, 1], 4) },
  };
  const LAYOUT = {
    narrow: RECIPE.alignCenter(), center: RECIPE.alignCenter(),
    start: { ...RECIPE.alignStart(), setupSlide: (e, t) => ({ ...RECIPE.alignStart().setupSlide(e, t), trackBounds: [-e.size - 32, t.track - e.size - 32] }) },
  };
  const OFFSET = { start: 16, center: 0, narrow: 0 };
  const INERTIA_S = 1.25 * DUR.expressive;

  /* escrituras como las de gsap.set: translate/rotate/scale:none la primera vez; transform «translate(xpx, 0px)» o «scale(s, s)» */
  const prep = el => { if (el.__dmTf) return; el.__dmTf = 1; el.style.translate = 'none'; el.style.rotate = 'none'; el.style.scale = 'none'; };
  const setX = (el, x) => { prep(el); const v = r4(x); el.style.transform = v ? `translate(${v}px, 0px)` : 'translate(0px, 0px)'; };
  const setMask = (el, scale, opacity) => { prep(el); el.style.opacity = r4(opacity); const s = r4(scale); el.style.transform = s !== 1 ? `scale(${s}, ${s})` : 'translate(0px, 0px)'; };
  /* header/footer: GSAP redondea z-index a entero solo si ya había uno en línea; la primera vez lo pasa tal cual (el navegador descarta los fraccionarios) */
  const setSlot = (el, z, opacity) => {
    el.style.opacity = r4(opacity);
    const cur = el.style.zIndex;
    if (cur && cur !== 'auto') el.style.zIndex = Math.round(z) + 0; else if (z === 0) el.style.zIndex = '0'; else el.style.zIndex = z;
  };

  DMES.scaleCarousel = root => {
    if (root.dmScaleCarousel) return root.dmScaleCarousel;
    const align = root.dataset.variant === 'start' ? 'start' : 'center';
    const NARROW = window.matchMedia('(max-width: 1024px)');                    // useBreakpoint('lg', 'max')
    const prevBtn = root.querySelector(':scope > [data-slot="controls"] button'), nextBtn = prevBtn && root.querySelectorAll(':scope > [data-slot="controls"] button')[1];
    let variant, offset, cfg;
    let visible = false, interrupted = false, stepTw = null, last = 0, revealed = null, warmed = false;
    const applyVariant = () => {
      variant = NARROW.matches ? 'narrow' : align; offset = OFFSET[variant]; cfg = ANIM[variant];
      if (root.dataset.variant !== variant) root.dataset.variant = variant;
      if (root.style.getPropertyValue('--offset').trim() !== offset + 'px') root.style.setProperty('--offset', offset + 'px');
    };

    /* pinta la posición e (función «I»): por slide, su posición envuelta → progreso → corrimiento + escala; header/footer solo bajo el slide centrado */
    const render = e => {
      const list = E.slides, rm = reduced();
      list.forEach(s => {
        const a = s.positionAt(e), l = clamp(mapRange(a, cfg.progress(s.size), [0, 1]), [0, 1]);
        setX(s.node, rm ? a : a + interp(cfg.displacement(s.size), l) + offset);
        const mask = s.node.querySelector('[data-slot="mask"]');
        const c = variant === 'start' ? (revealed === 1 ? 1 : clamp(mapRange(a, [-1 * s.size, -1 * (s.size - offset)], [0, 1]), [0, 1])) : 1;
        if (s.index === list.length - 1 && c === 1) revealed = c;
        mask && setMask(mask, rm ? 1 : interp(cfg.scale, l), c);
        const item = s.node.parentNode, head = item && item.querySelector('[data-slot="header"]'), foot = item && item.querySelector('[data-slot="footer"]');
        const h = clamp(mapRange(a, [-s.size / 2, s.size / 2], [0, 1]), [0, 1]), z = interp([-1, 0, -1], h), op = interp([0, 1, 1, 1, 0], h);
        head && setSlot(head, z, op); foot && setSlot(foot, z, op);
      });
      if (prevBtn) revealed !== 1 ? prevBtn.setAttribute('data-hidden', 'true') : prevBtn.removeAttribute('data-hidden');   // España escribe data-hidden="true"
    };
    /* «R»: los li aparecen en cascada (50 ms entre uno y otro, 300 ms, curva regular) */
    const fadeIn = () => $$('[data-slot="item"]', root).forEach((li, i) => tween({
      delay: i * 0.05, duration: DUR.base, to: 1, from: () => parseFloat(li.style.opacity || getComputedStyle(li).opacity) || 0, onUpdate: v => { li.style.opacity = r4(v); },
    }));
    /* «G»: al soltar, sigue hasta el snap más cercano a posición + ⅓ de slide en el sentido del último movimiento (750 ms); sin esto con «reducir movimiento» */
    const inertia = (e, t) => {
      if (reduced()) return;
      const a = E.getSlideAtPosition(e), l = E.roundPositionToSnap(e + Math.sign(t) * (a ? a.size : 200) * 0.333);
      const tw = tween({ from: e, to: l, duration: INERTIA_S, onUpdate: v => { if (interrupted) tw.kill(); else { E.syncPosition(v); render(v); } } });
    };
    /* «q»: ir a una posición (flechas y clic en una foto): 420 ms, curva regular */
    const animateTo = e => {
      stepTw && stepTw.kill(); interrupted = true;
      if (reduced()) { E.syncPosition(e); render(e); return; }
      stepTw = tween({ from: E.getPosition(), to: e, duration: DUR.panel, onUpdate: v => { E.syncPosition(v); render(v); }, onComplete: () => { stepTw = null; } });
    };
    /* «D»: un slide adelante (1) o atrás (−1) desde donde esté, redondeado al snap */
    const step = e => { const t = E.getPosition(), s = E.getSlideAtPosition(t); animateTo(E.roundPositionToSnap(t - e * (s ? s.size : 0))); };
    /* al medir (primera vez y cada cambio de tamaño): la posición 0 pasa a 1, se pinta y se lanza la cascada */
    const settle = () => { let e = E.getPosition(); if (e === 0) e = 1; E.syncPosition(e); render(e); fadeIn(); };

    const E = vce((type, d) => {
      if (type !== 'position:change') { settle(); return; }
      render(d.position);
      switch (d.type) {
        case 'move': interrupted = true; stepTw && stepTw.kill(); stepTw = null; break;
        case 'end': {
          if (!visible || stepTw) return;
          interrupted = false;
          inertia(d.position, d.position - last);
        }
      }
      last = d.position;
    });

    root.addEventListener('click', ev => {
      const t = ev.target; if (!(t instanceof Element) || t.closest('[data-recenter-exempt]')) return;
      const m = t.closest('[data-slot="mask"]'), sl = m && m.closest('[data-slot="vce-slide"]');
      if (sl) { const e = E.getPosition(), s = E.slides.find(x => x.node === sl); s && animateTo(E.roundPositionToSnap(e + s.distanceFrom(e))); }
    });
    /* teclado: al enfocar (con foco visible) algo dentro de un ítem, ese ítem se pinta al centro; como en España, no mueve la posición interna */
    root.addEventListener('focus', ev => {
      const t = ev.target; if (!(t instanceof Element) || !t.matches(':focus-visible')) return;
      const item = t.closest('[data-slot="item"]'), sl = item && item.querySelector('[data-slot="vce-slide"]'); if (!sl) return;
      const a = E.slides.findIndex(x => x.node === sl); if (a === -1) return;
      render(E.roundPositionToSnap(E.getPosition() + E.slides[a].distanceFrom(E.getPosition())));
    }, true);
    prevBtn && prevBtn.addEventListener('click', () => step(-1));
    nextBtn && nextBtn.addEventListener('click', () => step(1));

    /* fuera de pantalla vuelve al primer slide; la inercia solo corre si está en pantalla */
    const io = new IntersectionObserver(es => es.forEach(e => {
      visible = e.isIntersecting;
      if (!e.isIntersecting) { revealed = null; render(0); E.syncPosition(0); }
      /* NUESTRO (España carga todas las fotos de entrada, sin lazy): las fotos van con loading="lazy" y, al asomar el carrusel, se piden todas
         para que no aparezcan a medio cargar al girar */
      else if (!warmed) { warmed = true; $$('[data-slot="vce-slide"] img[loading="lazy"]', root).forEach(i => { i.loading = 'eager'; }); }
    }));
    const onBreakpoint = () => {
      if (!root.isConnected) { NARROW.removeEventListener('change', onBreakpoint); E.cleanup(); io.disconnect(); return; }
      applyVariant(); last = E.getPosition();
      E.update(root, LAYOUT[variant]);                                           // vuelve a medir → 'resize' → settle()
    };
    NARROW.addEventListener('change', onBreakpoint);
    applyVariant();
    E.update(root, LAYOUT[variant]);
    io.observe(root);
    return (root.dmScaleCarousel = { next: () => step(1), prev: () => step(-1) });
  };
  DMES.on('.es-scale-carousel__root', root => { DMES.scaleCarousel(root); });
}

/* ═══ 50-footer.js ═══ */
/* ───────── footer (FooterDesktop · FooterMobile · LocalizationPanel · Dropdown · NewsletterPopUp de España) ─────────
   Marcado: sections/dm-footer.liquid. Cada bloque dice de qué componente/función de España sale (referencia_global/live/js_legible):
     1 «Ver más» de las columnas           ← 2gd49b61todti.js · componente `v` de LinkGroupsInlineLayout
     2 acordeones del footer móvil         ← 2gd49b61todti.js · useDetailsClipAnimation + `f`/`g` de FooterMobile (uno abierto a la vez)
     3 desplegable                         ← 0jrg4k82j6xzh.js · Dropdown
     4 panel de país                       ← 0jrg4k82j6xzh.js · LocalizationPanel + LocalizationPanelForm · 2gd49b61todti.js · LocalizationPanelTrigger
     5 diálogo de newsletter               ← 0q4ogydaqhugq.js · NewsletterPopUp · 2gd49b61todti.js · Input, DateInput, Calendar · 3zzrxjqtzihb-.js · JustifiedText («stitch»)
   Abrir/cerrar los <dialog> lo hace 05-panel.js (commandfor/command). Plantillas: <template data-dm-footer-tpl="…"> al final de la sección. */
{
  const tplEl = n => document.querySelector(`template[data-dm-footer-tpl="${n}"]`);
  const tplNode = n => { const t = tplEl(n); return t ? t.content.firstElementChild.cloneNode(true) : document.createTextNode(''); };
  const tplHtml = n => { const t = tplEl(n); return t ? t.innerHTML : ''; };
  const chunk = h => Math.max(20, Math.ceil(h / 5));
  const flag = (el, name, on) => { on ? el.setAttribute(name, 'true') : el.removeAttribute(name); };

  /* 1 · «Ver más»: la fila extra (li.extraRows) pasa de height 0 a su alto en pasos de una línea (moveMs 10 · pauseMs 80) y al terminar queda en auto */
  DMES.on('.es-link-groups-inline-layout__expandableList', box => {
    const row = $('.es-link-groups-inline-layout__extraRows', box), list = row && $('.es-link-groups-inline-layout__extraList', row), btn = $(':scope > button', box);
    if (!row || !list || !btn) return;
    const label = $('span', btn); let open = false, tl = null;
    btn.addEventListener('click', () => {
      open = !open;
      btn.setAttribute('aria-expanded', String(open));
      open ? row.removeAttribute('inert') : row.setAttribute('inert', '');
      if (label) label.textContent = open ? btn.dataset.dmLabelLess : btn.dataset.dmLabelMore;
      if (tl) tl.kill();
      const end = open ? list.scrollHeight : 0, start = row.getBoundingClientRect().height;
      const first = list.children[0], gap = parseFloat(getComputedStyle(list).rowGap) || 0;
      const step = first ? first.getBoundingClientRect().height + gap : Math.abs(end - start);
      if (reduced() || !step) { row.style.height = open ? 'auto' : '0px'; return; }
      const isOpen = open;
      tl = DMES.stepped({ el: row, start, end, stepPx: step, moveMs: 10, pauseMs: 80, vars: v => ({ height: `${v}px` }), onComplete: () => { if (isOpen) row.style.height = 'auto'; } });
    });
  });

  /* 2 · Acordeones (<details>): al abrir, el contenido se descubre con clip-path + height en ~5 tramos (moveMs 10 · pauseMs 50);
     al cerrar se anima primero y recién después se quita `open`. Abrir un grupo cierra (animado) el que estaba abierto. */
  DMES.on('.es-footer-mobile__container > nav', nav => {
    let current = null;
    $$(':scope > details', nav).forEach(d => {
      const summary = $(':scope > summary', d), content = $(':scope > div > div', d);
      if (!summary || !content) return;
      let isOpen = d.open, closing = false, tl = null;
      const clear = () => { ['clip-path', 'height', 'overflow'].forEach(p => content.style.removeProperty(p)); };
      const vars = t => v => ({ clipPath: `inset(0 0 ${v}px 0)`, height: `${t - v}px` });
      const closeAnimated = done => {
        if (!isOpen || closing) return;
        if (tl) tl.kill();
        closing = true;
        if (reduced()) { closing = false; done(); return; }
        const t = content.offsetHeight;
        content.style.overflow = 'hidden';
        tl = DMES.stepped({ el: content, start: 0, end: t, stepPx: chunk(t), moveMs: 10, pauseMs: 50, vars: vars(t), onComplete: () => { closing = false; done(); } });
      };
      const me = { close: () => closeAnimated(() => { d.open = false; }) };
      const onOpenChange = open => {
        if (open) { if (current && current !== me) current.close(); current = me; } else if (current === me) current = null;
        isOpen = open;
        if (tl) tl.kill();
        tl = null;
        if (!open || reduced()) { closing = false; clear(); return; }
        const t = content.offsetHeight;
        Object.assign(content.style, { height: '0px', overflow: 'hidden', clipPath: `inset(0 0 ${t}px 0)` });
        tl = DMES.stepped({ el: content, start: t, end: 0, stepPx: chunk(t), moveMs: 10, pauseMs: 50, vars: vars(t), onComplete: clear });
      };
      d.addEventListener('toggle', () => { if (d.open !== isOpen) onOpenChange(d.open); });
      summary.addEventListener('click', e => { if (!isOpen) return; e.preventDefault(); if (!closing) closeAnimated(() => { d.open = false; }); });
    });
  });

  /* 3 · Desplegable (botón + listbox + <select> oculto). La lista se descubre con clip-path escalonado; teclado y búsqueda por letras como en España.
     Estados que mueve: aria-expanded / data-is-open / data-has-value (botón) · aria-hidden (lista) · data-selected / data-active / aria-selected / tabindex (opciones) */
  const dropdown = (w, onChange) => {
    const trigger = $('.es-dropdown__trigger', w), list = $('.es-dropdown__optionsList', w), native = $('.es-dropdown__hiddenSelect', w), iconBox = $('.es-dropdown__icon', w);
    if (!trigger || !list || !native) return;
    const opts = $$('.es-dropdown__option', list), labels = [...native.options].map(o => o.textContent.trim().toLowerCase()), last = opts.length - 1;
    let open = false, active = -1, tl = null, typed = '', typedT = 0;
    const setActive = i => {
      active = i;
      opts.forEach((o, k) => { o.tabIndex = k === i ? 0 : -1; flag(o, 'data-active', k === i); });
      if (open && i >= 0 && opts[i]) { opts[i].focus(); opts[i].scrollIntoView({ block: 'nearest', behavior: 'instant' }); }
    };
    const setOpen = v => {
      if (open === v) return;
      open = v;
      trigger.setAttribute('aria-expanded', String(v));
      flag(trigger, 'data-is-open', v);
      v ? list.removeAttribute('aria-hidden') : list.setAttribute('aria-hidden', 'true');
      if (iconBox) iconBox.replaceChildren(tplNode(v ? 'chevron-up' : 'chevron'));
      if (tl) tl.kill();
      const h = list.offsetHeight, clip = x => ({ clipPath: `inset(0 0 ${x}px 0)` });
      if (v) { if (reduced()) list.style.clipPath = 'inset(0 0 0px 0)'; else tl = DMES.stepped({ el: list, start: h, end: 0, stepPx: chunk(h), moveMs: 10, pauseMs: 50, vars: clip }); }
      else if (reduced() || h === 0) list.style.clipPath = 'inset(0 0 100% 0)';
      else tl = DMES.stepped({ el: list, start: 0, end: h, stepPx: chunk(h), moveMs: 10, pauseMs: 50, vars: clip });
    };
    const show = () => { setOpen(true); setActive(native.selectedIndex >= 0 ? native.selectedIndex : 0); };
    const hide = focus => { setOpen(false); setActive(-1); if (focus) trigger.focus(); };
    const select = i => {
      native.selectedIndex = i;
      opts.forEach((o, k) => { o.setAttribute('aria-selected', String(k === i)); flag(o, 'data-selected', k === i); });
      const node = $('.es-dropdown__optionLabel', opts[i]);
      if (node) trigger.replaceChildren(...[...node.childNodes].map(n => n.cloneNode(true)));
      trigger.setAttribute('data-has-value', 'true');
      if (onChange) onChange(native.value);
      hide(true);
    };
    const typeahead = e => {
      if (!(e.key.length === 1 && !e.altKey && !e.ctrlKey && !e.metaKey) || (e.key === ' ' && !typed)) return false;
      e.preventDefault();
      clearTimeout(typedT); typedT = setTimeout(() => { typed = ''; }, 1000);
      const t = (typed += e.key.toLowerCase()), same = t.length > 1 && [...t].every(c => c === t[0]), s = same ? t.slice(0, 1) : t;
      const from = (active >= 0 ? active : native.selectedIndex) + (t.length === 1 || same ? 1 : 0);
      for (let k = 0; k < labels.length; k++) { const i = (from + k + labels.length) % labels.length; if (labels[i].startsWith(s)) { setOpen(true); setActive(i); break; } }
      return true;
    };
    trigger.addEventListener('click', () => (open ? hide(true) : show()));
    trigger.addEventListener('keydown', e => { if (!typeahead(e) && ['ArrowDown', 'ArrowUp', 'Enter', ' '].includes(e.key)) { e.preventDefault(); show(); } });
    list.addEventListener('keydown', e => {
      if (typeahead(e)) return;
      switch (e.key) {
        case 'ArrowDown': e.preventDefault(); setActive(Math.min(active + 1, last)); break;
        case 'ArrowUp': e.preventDefault(); setActive(Math.max(active - 1, 0)); break;
        case 'Home': e.preventDefault(); setActive(0); break;
        case 'End': e.preventDefault(); setActive(last); break;
        case 'Enter': case ' ': e.preventDefault(); if (active >= 0 && opts[active]) select(active); break;
        case 'Escape': hide(true); break;
        case 'Tab': hide(false); break;
      }
    });
    opts.forEach((o, i) => {
      o.addEventListener('mousedown', e => e.preventDefault());
      o.addEventListener('click', () => select(i));
      o.addEventListener('mousemove', () => { if (active !== i) setActive(i); });
    });
    document.addEventListener('mousedown', e => { if (open && !w.contains(e.target)) hide(false); });
    return { hide, value: () => native.value };
  };

  /* 4 · Panel de país. El botón que lo abre decide el lado y si lleva «atrás» (España: footer → end sin atrás; menú móvil → start con atrás):
     data-dm-alignment="start|end" · data-dm-back="true" en el botón (por defecto, los del header —.es-menu__localizationTrigger y .es-navigation-items__localizationTrigger— = start + atrás).
     «Confirmar» lleva a la tienda del país elegido (data-dm-url de la <option>); si es la tienda actual solo cierra. */
  DMES.on('#localization-panel', d => {
    const form = $('form', d), content = $('[data-panel-appearance]', d), header = $('.es-panel-header__container', d), controls = $('.es-panel-controls__controls', d);
    const native = form && $('select', form), pay = $('.es-localization-panel__payments', d);
    if (!form || !native) return;
    const home = native.value, payNodes = pay ? [...pay.children] : [];
    // España muestra los medios de pago del mercado elegido; de las otras tiendas no los conocemos: solo se listan los de la tienda actual
    const dd = dropdown($('.es-dropdown__wrapper', d), v => { if (pay) pay.replaceChildren(...(v === home ? payNodes : [])); });
    form.addEventListener('submit', e => {
      e.preventDefault();
      const o = native.selectedOptions[0], url = o && o.dataset.dmUrl;
      if (!url || native.value === home) { DMES.dialog.requestClose(d); return; }
      window.location.assign(url);
    });
    const setBack = on => {
      const b = $('[data-control="back"]', controls);
      if (on && !b) controls.prepend(tplNode('back')); else if (!on && b) b.remove();
      if (header) header.dataset.hasBackButton = String(on);
    };
    document.addEventListener('click', e => {
      const b = e.target.closest && e.target.closest('[commandfor="localization-panel"][command="show-modal"]');
      if (!b) return;
      const back = b.dataset.dmBack ? b.dataset.dmBack === 'true' : b.matches('.es-menu__localizationTrigger, .es-navigation-items__localizationTrigger');
      if (content) content.dataset.alignment = b.dataset.dmAlignment || (back ? 'start' : 'end');
      setBack(back);
    }, true);
    d.addEventListener('dm:dialog', e => { if (e.target === d && !e.detail.open) { setBack(false); if (dd) dd.hide(false); } });
  });

  /* 5 · Diálogo de newsletter. Validaciones y estados como NewsletterPopUp; el envío es el formulario «customer» de Shopify (POST nativo a /contact,
     igual que el footer anterior: así actúa la protección anti-bots de Shopify). Al volver (?customer_posted=true) se abre en estado «enviado». */
  DMES.on('#newsletter-dialog', d => {
    const form = $('form.es-newsletter-pop-up__form', d);
    if (!form) return;
    const txt = d.dataset, closeBtn = $('.es-newsletter-pop-up__closeIcon', d);
    const email = $('#newsletter-email', form), name = $('#newsletter-first-name', form), dobIn = $('#newsletter-dob', form), dobHidden = $('[data-dm-dob]', form);
    const dateWrap = dobIn && dobIn.closest('.es-input__dateWrapper'), dobBtn = dateWrap && $('.es-input__icon', dateWrap);
    const hear = $('.es-newsletter-pop-up__hearAbout', form), radios = $$('.es-radio__input', form), submit = $('.es-newsletter-pop-up__submitButton', form);
    const ext = n => document.querySelector(`input[form="${form.id}"][name="${n}"]`), tags = ext('contact[tags]'), note = ext('contact[note]');

    // Input: error = aria-invalid + pista visible con role="alert"
    const setError = (input, msg) => {
      const wrap = input && input.closest('.es-input__wrapper'), hw = wrap && $('.es-input__hintWrapper', wrap), hint = hw && $('.es-input__hint', hw);
      if (!hint) return;
      flag(input, 'aria-invalid', !!msg); flag(hw, 'data-visible', !!msg);
      msg ? hint.setAttribute('role', 'alert') : hint.removeAttribute('role');
      hint.textContent = msg || '';
    };
    const alertP = (cls, msg, place) => {
      let p = $(`.${cls}`, form);
      if (!msg) { if (p) p.remove(); return; }
      if (!p) { p = document.createElement('p'); p.className = cls; p.setAttribute('role', 'alert'); place(p); }
      p.textContent = msg;
    };
    const genderError = msg => alertP('es-newsletter-pop-up__genderError', msg, p => hear.append(p));
    const formError = msg => alertP('es-newsletter-pop-up__error', msg, p => submit.after(p));

    // nombre (validateName de España)
    const NAME_OK = /^[\p{L}\p{M}' \-.]{1,50}$/u, NAME_URL = /(https?|ftp):\/\/|www\.[a-z0-9-]+\.[a-z]{2,}|\b[a-z0-9-]+\.[a-z]{2,}\b/i, NAME_HTML = /<[^>]*>/;
    const nameError = v => { const i = v.trim(); return !i ? '' : i.length > 50 ? txt.dmTNameLong : NAME_URL.test(i) || NAME_HTML.test(i) || !NAME_OK.test(i) ? txt.dmTName : ''; };
    if (name) { name.addEventListener('input', () => setError(name, '')); name.addEventListener('blur', () => setError(name, nameError(name.value))); }

    // fecha de nacimiento (DateInput): máscara DD/MM/AAAA, año de 2 dígitos al salir, mayores de 18
    let dob = null, dobText = false, localErr = '', submitErr = '', pop = null, view = null, picker = false;
    const maxDob = new Date(); maxDob.setFullYear(maxDob.getFullYear() - 18);
    const p2 = n => String(n).padStart(2, '0');
    const fmt = x => `${p2(x.getDate())}/${p2(x.getMonth() + 1)}/${x.getFullYear()}`, iso = x => (x ? `${x.getFullYear()}-${p2(x.getMonth() + 1)}-${p2(x.getDate())}` : '');
    const dobError = () => setError(dobIn, submitErr || localErr);
    const setDob = (x, has) => { dob = x; dobText = has; if (dobHidden) dobHidden.value = iso(x); if (x || !has) submitErr = ''; dobError(); };
    const checkDate = s => {
      const m = s.match(/^(\d{2})\/(\d{2})\/(\d{4})$/); let x = null;
      if (m) { const dd = +m[1], mm = +m[2], yy = +m[3]; x = new Date(yy, mm - 1, dd); if (x.getFullYear() !== yy || x.getMonth() !== mm - 1 || x.getDate() !== dd) x = null; }
      localErr = !x ? txt.dmTDate : x > new Date() ? txt.dmTDateFuture : x > maxDob ? txt.dmTDateNa : '';
      setDob(localErr ? null : x, true);
    };
    const closePop = () => { if (!pop) return; pop.remove(); pop = null; picker = false; dateWrap.removeAttribute('data-open'); dobBtn.setAttribute('aria-expanded', 'false'); };
    if (dobIn && dateWrap && dobBtn) {
      dobIn.addEventListener('input', () => {
        const t = dobIn.value.replace(/\D/g, '').slice(0, 8), a = t.length <= 2 ? t : t.length <= 4 ? `${t.slice(0, 2)}/${t.slice(2)}` : `${t.slice(0, 2)}/${t.slice(2, 4)}/${t.slice(4)}`;
        dobIn.value = a;
        if (a.length < 10) { localErr = ''; setDob(null, a.length > 0); return; }
        checkDate(a);
      });
      dobIn.addEventListener('blur', () => {
        const a = dobIn.value;
        if (!a || a.length === 10) return;
        const m = a.match(/^(\d{2}\/\d{2}\/)(\d{2})$/), e = m ? `${m[1]}${(+m[2] > new Date().getFullYear() % 100 ? 1900 : 2000) + +m[2]}` : a;
        if (e.length === 10) { dobIn.value = e; checkDate(e); } else { localErr = txt.dmTDate; dobError(); }
      });
      // Calendar: mes a la vista + selector de año/mes; días posteriores a «hoy − 18 años» deshabilitados
      const MONTHS = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'], DAYS = ['Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá', 'Do'];
      const CAP = new Intl.DateTimeFormat('es', { month: 'long', year: 'numeric' }), sameMonth = (a, b) => a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth();
      const draw = () => {
        const now = new Date(), Y = now.getFullYear(), M = now.getMonth(), id = 'newsletter-dob-calendar', vy = view.getFullYear(), po = picker ? ' data-picker-open="true"' : '';
        let h = `<div class="es-calendar__wrapper"><input type="hidden" id="${id}" value="${iso(dob)}" aria-invalid="false" aria-describedby="${id}-description"><div class="es-calendar__calendar es-newsletter-pop-up__birthdayCalendar"${po}><div class="es-calendar__caption"${po}>`;
        if (!picker) h += `<button type="button" class="es-calendar__navButton" data-direction="previous" aria-label="Mes anterior">${tplHtml('arrow-left')}</button>`;
        h += `<button type="button" class="es-calendar__monthYearTrigger" aria-label="Elegir mes y año" aria-expanded="${picker}" aria-controls="${id}-month-year-picker"${picker ? ' data-is-open="true"' : ''}><span>${CAP.format(view).toUpperCase()}</span><span class="es-calendar__monthYearIcon" aria-hidden="true">${tplHtml(picker ? 'chevron-up' : 'chevron')}</span></button>`;
        if (!picker) h += `<button type="button" class="es-calendar__navButton" data-direction="next" aria-label="Mes siguiente"${sameMonth(view, now) ? ' disabled' : ''}>${tplHtml('arrow-right')}</button>`;
        h += '</div>';
        if (picker) {
          h += `<div id="${id}-month-year-picker" class="es-calendar__monthYearPicker">`;
          for (let y = maxDob.getFullYear(); y >= Y - 120; y--) {
            h += `<div class="es-calendar__yearItem"><details name="${id}-year"${y === vy ? ' open' : ''}><summary><span class="es-details-summary-appearance__container es-calendar__yearSummary" data-variant="inline">${y}<span class="es-details-summary-appearance__icon">${tplHtml('chevron-use')}</span></span></summary><div><div class="es-calendar__monthGrid" role="group" aria-label="${y}">`;
            MONTHS.forEach((mn, i) => { h += `<button type="button" class="es-calendar__monthButton" data-dm-ym="${y}-${i}"${y === vy && i === view.getMonth() ? ' data-selected="true"' : ''}${y > Y || (y === Y && i > M) ? ' disabled' : ''}>${mn}</button>`; });
            h += '</div></div></details></div>';
          }
          h += '</div>';
        } else {
          const first = new Date(vy, view.getMonth(), 1), off = (first.getDay() + 6) % 7;
          h += `<table class="es-calendar__table"><thead><tr>${DAYS.map(x => `<th scope="col" class="es-calendar__weekday">${x}</th>`).join('')}</tr></thead><tbody>`;
          for (let r = 0; r < 6; r++) {
            const days = Array.from({ length: 7 }, (_, c) => new Date(vy, view.getMonth(), 1 - off + r * 7 + c));
            if (r >= 4 && !days.some(x => sameMonth(x, view))) continue;
            h += `<tr>${days.map(x => { const sel = !!dob && iso(x) === iso(dob); return `<td class="es-calendar__dayCell"><button type="button" class="es-calendar__day" data-outside="${!sameMonth(x, view)}" data-selected="${sel}"${x > maxDob ? ' disabled' : ''} aria-pressed="${sel}"${sel ? ' aria-current="date"' : ''} data-dm-day="${iso(x)}">${x.getDate()}</button></td>`; }).join('')}</tr>`;
          }
          h += '</tbody></table>';
        }
        pop.innerHTML = `${h}</div><p id="${id}-description" class="es-calendar__hint"></p></div>`;
      };
      const onPop = e => {
        const b = e.target.closest('button');
        if (!b || b.disabled) return;
        if (b.dataset.direction) { view = new Date(view.getFullYear(), view.getMonth() + (b.dataset.direction === 'next' ? 1 : -1), 1); draw(); }
        else if (b.matches('.es-calendar__monthYearTrigger')) { picker = !picker; draw(); }
        else if (b.dataset.dmYm) { const [y, m] = b.dataset.dmYm.split('-').map(Number); view = new Date(y, m, 1); picker = false; draw(); }
        else if (b.dataset.dmDay) { const [y, m, dd] = b.dataset.dmDay.split('-').map(Number), x = new Date(y, m - 1, dd); dobIn.value = fmt(x); localErr = ''; setDob(x, true); closePop(); }
      };
      dobBtn.addEventListener('click', () => {
        if (pop) { closePop(); return; }
        view = dob ? new Date(dob.getFullYear(), dob.getMonth(), 1) : new Date(); picker = false;
        pop = document.createElement('div'); pop.className = 'es-input__datePopover'; pop.addEventListener('click', onPop);
        dateWrap.append(pop); dateWrap.setAttribute('data-open', 'true'); dobBtn.setAttribute('aria-expanded', 'true');
        draw();
      });
      document.addEventListener('mousedown', e => { if (pop && !dateWrap.contains(e.target)) closePop(); });
    }
    radios.forEach(r => r.addEventListener('change', () => genderError('')));

    // estado «enviado»: el formulario se reemplaza por la confirmación (data-submitted="true"); al cerrar el diálogo todo vuelve a cero
    const setSubmitted = v => {
      d.dataset.submitted = String(v);
      if (v && form.isConnected) { const t = tplEl('done'); if (t) form.replaceWith(t.content.cloneNode(true)); }
      if (!v && !form.isConnected) { $$('[data-dm-done]', d).forEach(n => n.remove()); closeBtn.after(form); }
    };
    const reset = () => {
      setSubmitted(false); form.reset(); closePop();
      localErr = submitErr = ''; setDob(null, false);
      [email, name].forEach(i => setError(i, '')); genderError(''); formError('');
      if (submit) submit.disabled = false;
    };

    form.addEventListener('submit', e => {
      const stop = () => { e.preventDefault(); e.stopImmediatePropagation(); };
      if (!dob && dobText) { stop(); submitErr = txt.dmTDate; dobError(); dobIn.focus(); return; }
      const ne = name ? nameError(name.value) : '';
      if (ne) { stop(); setError(name, ne); return; }
      const g = (radios.find(r => r.checked) || {}).value;
      if (radios.length && !g) { stop(); genderError(txt.dmTGender); return; }
      formError('');
      if (tags && g) tags.value = `${tags.defaultValue},newsletter-${g.toLowerCase()}`;
      if (note) { note.disabled = !dob; note.value = dob ? `Newsletter (footer) · Fecha de nacimiento: ${iso(dob)}${g ? ` · Preferencia: ${g}` : ''}` : ''; }
      setTimeout(() => { if (submit) submit.disabled = true; }, 0);
    }, true);
    window.addEventListener('pageshow', e => { if (e.persisted && submit) submit.disabled = false; });

    // JustifiedText «stitch»: las palabras aparecen en orden al azar cada 60 ms, quedan 6 s, se van en orden inverso y, tras 0,5 s, se repite.
    // España arranca el ciclo con el primer scroll y lo deja correr siempre; acá el reloj es el mismo pero solo se pinta mientras el diálogo está abierto.
    const words = $$('.es-justified-text__word', d);
    let t0 = null, tick = 0;
    if (words.length && !reduced()) {
      words.forEach(w => { w.style.opacity = '0'; });
      const order = [...words];
      for (let i = order.length - 1; i > 0; i--) { const r = Math.floor(Math.random() * (i + 1)); [order[i], order[r]] = [order[r], order[i]]; }
      const n = order.length, hold = 0.06 * n + 6, cycle = hold + 0.06 * (n - 1) + 0.5;
      const paint = () => { const t = ((performance.now() - t0) / 1000) % cycle; order.forEach((w, i) => { const o = t >= 0.06 * i && t < hold + 0.06 * (n - 1 - i) ? '1' : '0'; if (w.style.opacity !== o) w.style.opacity = o; }); };
      const start = () => { if (t0 === null) t0 = performance.now(); };
      if (window.scrollY > 0) start(); else window.addEventListener('scroll', start, { once: true, passive: true });
      d.addEventListener('dm:dialog', e => { if (e.target !== d) return; clearInterval(tick); if (e.detail.open) { start(); paint(); tick = setInterval(paint, 20); } });
    }
    d.addEventListener('dm:dialog', e => { if (e.target === d && !e.detail.open) reset(); });

    // resultado del envío (marca del servidor o parámetros con que Shopify vuelve de /contact)
    const mark = document.querySelector('[data-dm-newsletter-result]'), q = new URLSearchParams(window.location.search);
    const result = (mark && mark.value) || (q.get('customer_posted') === 'true' ? 'success' : q.get('form_type') === 'customer' ? 'error' : '');
    if (result) {
      if (result === 'success') setSubmitted(true); else { formError(txt.dmTError); if (email && q.get('contact[email]')) email.value = q.get('contact[email]'); }
      try {
        const u = new URL(window.location.href);
        [...u.searchParams.keys()].forEach(k => { if (k === 'customer_posted' || k === 'form_type' || k === 'utf8' || k.startsWith('contact[')) u.searchParams.delete(k); });
        if (u.hash === `#${d.id}`) u.hash = '';
        window.history.replaceState(window.history.state, '', u);
      } catch (err) { /* sin History API: queda la URL tal cual */ }
      DMES.dialog.show(d);
    }
  });
}

/* ═══ 55-legal.js ═══ */
/* ───────── páginas legales y de texto (sections/dm-page.liquid) ─────────
   El hero, el texto y el acordeón de España no llevan JS (el titular lo ajusta 20-headline.js; el acordeón son <details name> nativos).
   Lo único con comportamiento es el alta al newsletter desde la página /pages/newsletter-sign-up: el botón abre el MISMO diálogo del footer
   (#newsletter-dialog; validaciones y estados en 50-footer.js, que no se toca). Acá solo se conserva lo que la página vieja de cada tienda
   hacía distinto del footer, leyendo los data-dm-* del botón (ajustes del bloque «Alta al newsletter»):
     1 · etiqueta de origen (Chile y México): la página marcaba al cliente con su propia etiqueta además de «newsletter». Se suma al campo
         contact[tags] del formulario del diálogo mientras se esté en esta página.
     2 · envío por Klaviyo (Argentina): allá el alta por el formulario «customer» de Shopify NO entrega el cupón (cae en una lista cuyo flow
         solo escribe a quien empezó un checkout), por eso la página vieja suscribía directo a la lista del popup con la API cliente de Klaviyo.
         Se mantiene ese circuito: cuando el diálogo ya validó, en vez del POST a Shopify va el POST a Klaviyo (misma lista, mismo origen) y
         se vuelve a la página con los mismos parámetros con que vuelve Shopify (?customer_posted=true → el diálogo se abre en «enviado»;
         ?form_type=customer → el diálogo se abre con su mensaje de error). Así el diálogo no necesita saber nada de esto. */
{
  DMES.on('[data-dm-newsletter-cta]', btn => {
    const d = document.getElementById(btn.getAttribute('commandfor') || 'newsletter-dialog');
    if (!d) return;
    // El <form> del diálogo puede estar fuera del documento al arrancar: si la página vuelve de un alta exitosa, 50-footer.js (que corre antes)
    // lo reemplaza por el mensaje «enviado» y lo vuelve a poner al cerrar. Por eso no se guarda el formulario: se escucha el envío en el diálogo.
    const formId = (d.querySelector('form.es-newsletter-pop-up__form') || {}).id || 'newsletter-form';
    const cfg = btn.dataset;
    const tags = document.querySelector(`input[form="${formId}"][name="contact[tags]"]`);
    if (tags && cfg.dmNewsletterTag && !tags.defaultValue.split(',').includes(cfg.dmNewsletterTag)) tags.defaultValue = `${tags.defaultValue},${cfg.dmNewsletterTag}`;
    if (!cfg.dmKlaviyoCompany || !cfg.dmKlaviyoList) return;
    const back = params => { const u = new URL(window.location.href); u.hash = ''; Object.keys(params).forEach(k => u.searchParams.set(k, params[k])); window.location.assign(u); };
    // El envío sube del formulario al diálogo solo si 50-footer.js no lo frenó (cuando una validación falla, corta la propagación).
    d.addEventListener('submit', e => {
      const form = e.target;
      if (!(form instanceof HTMLFormElement) || !form.classList.contains('es-newsletter-pop-up__form') || e.defaultPrevented) return;
      e.preventDefault();
      const field = n => form.querySelector(`[name="${n}"]`);
      const email = ((field('contact[email]') || {}).value || '').trim(), name = ((field('contact[first_name]') || {}).value || '').trim();
      if (!email) return;
      const pref = (form.querySelector('.es-radio__input:checked') || {}).value, dob = (form.querySelector('[data-dm-dob]') || {}).value;
      const properties = { dm_signup_source: cfg.dmKlaviyoSource || 'newsletter-page' };
      if (pref) properties.dm_newsletter_preference = pref;
      if (dob) properties.dm_birthdate = dob;
      const profile = { email, properties };
      if (name) profile.first_name = name;
      fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(cfg.dmKlaviyoCompany)}`, {
        method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', revision: '2025-10-15' },
        body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: cfg.dmKlaviyoLabel || 'Pagina newsletter-sign-up', profile: { data: { type: 'profile', attributes: profile } } },
          relationships: { list: { data: { type: 'list', id: cfg.dmKlaviyoList } } } } }),
      }).then(res => {
        if (!res.ok) throw new Error(`klaviyo ${res.status}`);
        try { const who = { email }; if (name) who.first_name = name; if (window.klaviyo && typeof window.klaviyo.identify === 'function') window.klaviyo.identify(who); } catch (err) { /* sin el script de Klaviyo en la página: no pasa nada */ }
        back({ customer_posted: 'true' });
      }).catch(() => back({ form_type: 'customer' }));
    });
  });
}

/* ═══ 60-plp.js ═══ */
/* ───────── página de colección (PLP) · componentes de España: js_legible/0ieumxz84jo3k.js (PlpHeader · PlpFixedButtons · FilterSortPanel ·
   FacetGroup · SizeFacetGroup · FilterSortTrigger · Pagination) y 2gd49b61todti.js (ProductListingGrid · useProductListingHrefUpdate ·
   useProductListingData · useDetailsClipAnimation) ─────────
   Marcado: sections/dm-collection-header.liquid ([data-dm-plp-header]) y sections/dm-collection.liquid (.es[data-dm-plp]).
   La página de resultados de búsqueda (sections/dm-search.liquid, .es[data-dm-plp][data-dm-search-page]) usa este mismo listado: allá son los
   mismos componentes (FilterSortPanel, ProductListingGrid, Pagination). Lo propio de la búsqueda está en es/js/63-search-page.js, que se
   apoya en root.__dmListing (load · cancel · viewList · shown · cached) y en el evento «dm:listing» que se emite después de cada carga parcial.
   Cabecera (PlpHeader + useHorizontalScroll)
     · flechas de la fila de categorías: existen solo si la fila desborda (scrollWidth > clientWidth + 1); disabled en cada extremo;
       cada clic avanza el 80 % del ancho visible con scroll suave
     · texto en móvil: tocarlo alterna data-expanded="true" / aria-expanded
   Botones fijos (PlpFixedButtons)
     · .es-plp-page__fixedFilter[data-visible] = la grilla ocupa toda la pantalla (top ≤ 0 y bottom ≥ alto de ventana)
     · «Volver arriba»: data-mobile-logo-visible = logo móvil visible · data-scrolled-to-top = scrollY < 5 (ScrollBehaviorProvider; se lee
       de DMES.nav.state, que es el mismo estado del header) · clic → scroll suave a 0
   Filtros y orden (FilterSortPanel)  — allá cada cambio actualiza la URL al instante (history.replaceState) y los datos llegan 500 ms después
     (useDebouncedValue; sin espera si ya están en caché); el botón «Mostrar N resultados» solo cierra el panel. Acá es igual, pero los
     datos son la MISMA sección pedida a Shopify con la URL nueva (?section_id=…): se reemplazan grilla, paginación, contadores y opciones
     · al marcar: data-selected del selector, contador del grupo (selectedCount), chips del encabezado (último elegido primero) y contador
       del botón se actualizan en el acto; lo demás, cuando responde el servidor
     · grupos <details>: abrir/cerrar con recorte escalonado (useDetailsClipAnimation: 5 tramos, 10 ms de avance + 50 ms de pausa);
       «Guía de tallas» / «Índice de materiales» aparecen en el título solo con el grupo abierto
     · precio: Shopify filtra por rango (gte/lte); los tramos marcados se convierten en el rango que los envuelve
   Grilla (ProductListingGrid)
     · mientras carga: data-loading="true" · al cambiar la lista: cada <li> data-pop="true" + --pop-delay (misma fórmula seudoaleatoria,
       hasta 450 ms) y, si la grilla quedó más arriba que el borde útil, scrollIntoView instantáneo
   Paginación (Pagination): clic → scroll arriba + history.pushState + carga sin recargar; «atrás» del navegador vuelve a pedir la sección
     y repone el scroll guardado (el theme usa history.scrollRestoration = 'manual')
   Analítica: complementa snippets/rr-datalayer-plp.liquid (que solo conoce la primera carga): view_item_list después de cada recarga
     parcial y select_item para lo que ese snippet no cubre (sin duplicar). */
{
  const flag = (e, k, v) => { const s = v ? 'true' : 'false'; if (e && e.getAttribute(k) !== s) e.setAttribute(k, s); };
  const path = () => window.location.pathname + window.location.search;

  /* —— cabecera —— */
  DMES.on('[data-dm-plp-header]', header => {
    const wrap = $('.es-plp-header__subcategoriesWrap', header), nav = wrap && $('.es-plp-header__subcategories', wrap);
    if (nav) {
      const prev = $('.es-plp-header__arrow[data-direction="prev"]', wrap), next = $('.es-plp-header__arrow[data-direction="next"]', wrap);
      const update = () => {
        const can = nav.scrollWidth > nav.clientWidth + 1;
        if (can) { if (!prev.isConnected) nav.before(prev); if (!next.isConnected) nav.after(next); } else { prev.remove(); next.remove(); }
        prev.disabled = nav.scrollLeft <= 0;
        next.disabled = nav.scrollLeft + nav.clientWidth >= nav.scrollWidth - 1;
      };
      nav.addEventListener('scroll', update, { passive: true });
      new ResizeObserver(update).observe(nav);
      prev.addEventListener('click', () => nav.scrollBy({ left: -nav.clientWidth * 0.8, behavior: 'smooth' }));
      next.addEventListener('click', () => nav.scrollBy({ left: nav.clientWidth * 0.8, behavior: 'smooth' }));
      update();
    }
    const desc = $('.es-plp-header__descriptionMobile', header);
    if (desc) desc.addEventListener('click', () => {
      const open = desc.getAttribute('aria-expanded') !== 'true';
      open ? desc.setAttribute('data-expanded', 'true') : desc.removeAttribute('data-expanded');
      desc.setAttribute('aria-expanded', String(open));
    });
  });

  /* —— <details> con recorte escalonado (useDetailsClipAnimation) —— */
  const clipDetails = d => {
    if (d.__dmClip) return; d.__dmClip = true;
    const summary = $('summary', d), ref = () => d.children[1] && d.children[1].firstElementChild;
    let tl = null, closing = false;
    const clear = el => { ['clip-path', 'height', 'overflow'].forEach(p => el.style.removeProperty(p)); };
    const link = open => {
      const html = d.dataset.dmOpenLink, icon = $('.es-details-summary-appearance__icon', summary);
      const cur = icon && icon.previousElementSibling && icon.previousElementSibling.matches('a') ? icon.previousElementSibling : null;
      if (open && html && !cur && icon) icon.insertAdjacentHTML('beforebegin', html);
      else if (!open && cur) cur.remove();
    };
    d.addEventListener('toggle', () => {
      const el = ref(); link(d.open);
      if (!el) return;
      if (tl) tl.kill(); tl = null;
      if (!d.open || reduced()) { clear(el); return; }
      const h = el.offsetHeight;
      Object.assign(el.style, { height: '0px', overflow: 'hidden', clipPath: `inset(0 0 ${h}px 0)` });
      tl = DMES.stepped({ el, start: h, end: 0, stepPx: Math.max(20, Math.ceil(h / 5)), moveMs: 10, pauseMs: 50, vars: v => ({ clipPath: `inset(0 0 ${v}px 0)`, height: `${h - v}px` }), onComplete: () => clear(el) });
    });
    summary.addEventListener('click', e => {
      if (e.target.closest('a')) { e.stopPropagation(); return; }      // el enlace del título navega, no pliega
      if (!d.open) return;                                            // abrir: nativo (la animación la dispara «toggle»)
      e.preventDefault();
      const el = ref();
      if (closing || !el) { if (!el) d.open = false; return; }
      if (tl) tl.kill();
      if (reduced()) { d.open = false; return; }
      closing = true;
      const h = el.offsetHeight; el.style.overflow = 'hidden';
      tl = DMES.stepped({ el, start: 0, end: h, stepPx: Math.max(20, Math.ceil(h / 5)), moveMs: 10, pauseMs: 50, vars: v => ({ clipPath: `inset(0 0 ${v}px 0)`, height: `${h - v}px` }), onComplete: () => { closing = false; d.open = false; } });
    });
  };

  /* —— página —— */
  DMES.on('[data-dm-plp]', root => {
    const sectionId = root.dataset.dmSectionId, q = sel => $(sel, root);
    const dialog = q('#filter-sort-panel'), toTop = q('.es-plp-page__backToTop'), isSearch = root.hasAttribute('data-dm-search-page');
    const fixed = () => q('.es-plp-page__fixedFilter, .es-search-page-results__fixedFilter');    // búsqueda: el botón mismo lleva data-visible (SearchPageResults)
    const gridWrap = () => q('[data-dm-r="grid"]'), outer = () => q('.es-product-listing-grid__outer'), form = () => q('form[data-dm-filters]');
    if (!sectionId || !dialog || !(gridWrap() || isSearch)) return;      // la búsqueda puede partir sin grilla (sin resultados / menos de 3 caracteres)

    /* botones fijos */
    const own = { last: window.scrollY, down: false };
    const syncTop = () => {
      const S = DMES.nav && DMES.nav.state;
      const hidden = S && 'scrolledDown' in S ? !!(S.scrolledDown || S.idleHidden) : own.down;
      flag(toTop, 'data-mobile-logo-visible', !hidden);
      flag(toTop, 'data-scrolled-to-top', window.scrollY < 5);
    };
    let raf = 0;
    const onScroll = () => {
      const y = window.scrollY, t = own.last;            // misma regla de ScrollBehaviorProvider, por si el header no está
      if (y > t + 5 && y > 0) own.down = Math.abs(y - t) >= 50 ? y > 5 : true; else if (y < t - 5) own.down = false;
      own.last = y;
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const g = gridWrap(); if (!g) return;
        const r = g.getBoundingClientRect();
        flag(fixed(), 'data-visible', r.top <= 0 && r.bottom >= window.innerHeight);
        syncTop();
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    setInterval(syncTop, 500);                           // el logo también se esconde solo tras unos segundos sin scroll
    onScroll();
    if (toTop) toTop.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));

    /* panel: grupos, colores claros, chips */
    const setup = () => {
      $$('details[data-dm-facet]', dialog).forEach(clipDetails);
      $$('.es-selector__swatch[data-dm-color]', dialog).forEach(sw => { if (DMES.isLightColor && DMES.isLightColor(sw.dataset.dmColor)) sw.setAttribute('data-light-color', 'true'); });
      const tags = $('.es-filter-sort-panel__tags', dialog);
      if (tags && DMES.carousel) DMES.carousel(tags);
    };
    const keyOf = i => `${i.name}\u0001${i.value}`;
    const labelOf = i => { const l = i.closest('label'), t = l && $('[data-text]', l); return t ? t.dataset.text : i.value; };
    const badge = d => {
      if (!d || d.dataset.dmFacet === 'sort_by') return;
      const lab = $('summary [class$="__label"]', d); if (!lab) return;
      const n = $$('input:checked', d).length, cls = lab.className.replace('__label', '__selectedCount');
      let b = lab.querySelector(`.${cls}`);
      if (!n) { if (b) b.remove(); return; }
      if (!b) { b = document.createElement('span'); b.className = cls; lab.append(b); }
      b.textContent = String(n);
    };
    const selected = () => {
      const items = []; let range = null;
      for (const i of $$('input:checked', form())) {
        if (i.name === 'sort_by') continue;
        if (i.hasAttribute('data-dm-range')) {
          const [lo, hi] = labelOf(i).split(' - '), [a, b] = i.value.split('-').map(Number);
          if (!range) { range = { name: i.name, range: true, lo, hi, min: a, max: b }; items.push(range); }
          else { if (a < range.min) { range.min = a; range.lo = lo; } if (b > range.max) { range.max = b; range.hi = hi; } }
          continue;
        }
        items.push({ name: i.name, value: i.value, label: labelOf(i) });
      }
      if (range) range.label = `${range.lo} - ${range.hi}`;
      return items;
    };
    const tpl = n => { const t = q(`template[data-dm-tpl="${n}"]`); return t ? t.content.firstElementChild.cloneNode(true) : null; };
    const optimistic = () => {
      const items = selected(), head = q('.es-filter-sort-panel__header');
      const acts = $('.es-filter-sort-panel__headerActions', head), had = acts ? $$('.es-filter-sort-panel__filterTag', acts).length : 0;
      if (!items.length) { if (acts) acts.remove(); }
      else {
        const fresh = tpl('chips'), box = fresh && $('.es-filter-sort-panel__tags', fresh);
        if (box) {
          items.slice().reverse().forEach(it => {
            const c = tpl('chip'), b = $('button', c);
            $('.es-filter-sort-panel__filterTagLabel', c).textContent = it.label;
            b.setAttribute('aria-label', `Eliminar filtro ${it.label}`); b.dataset.dmRemove = it.name;
            if (it.range) b.setAttribute('data-dm-range', ''); else b.dataset.dmValue = it.value;
            box.append(c);
          });
          acts ? acts.replaceWith(fresh) : head.append(fresh);
          if (DMES.carousel) DMES.carousel(box);
          if (items.length > had) box.scrollTo({ left: 0, behavior: 'smooth' });
        }
      }
      $$('[data-dm-r="trigger"]', root).forEach(t => {
        let c = $('.es-filter-sort-trigger__count', t);
        if (!items.length) { if (c) c.remove(); return; }
        if (!c) { c = document.createElement('span'); c.className = 'es-filter-sort-trigger__count'; t.prepend(c); }
        c.textContent = String(items.length);
      });
    };

    /* URL = prepareProductListingUrl: filtros ordenados por clave y valor, orden solo si no es el recomendado, página solo si > 1 */
    const buildUrl = () => {
      const u = new URL(window.location.href), f = form(), facets = {}; let rname = null, min = Infinity, max = -Infinity;
      [...new Set(u.searchParams.keys())].forEach(k => { if (k.startsWith('filter.') || k === 'sort_by' || k === 'page') u.searchParams.delete(k); });
      for (const i of $$('input:checked', f)) {
        if (i.name === 'sort_by') continue;
        if (i.hasAttribute('data-dm-range')) { const [a, b] = i.value.split('-').map(Number); rname = i.name; min = Math.min(min, a); max = Math.max(max, b); continue; }
        (facets[i.name] = facets[i.name] || []).push(i.value);
      }
      if (rname) { facets[`${rname}.gte`] = [String(min)]; facets[`${rname}.lte`] = [String(max)]; }
      Object.keys(facets).sort((a, b) => a.localeCompare(b)).forEach(k => [...facets[k]].sort().forEach(v => u.searchParams.append(k, v)));
      const sort = $('input[name="sort_by"]:checked', f);
      if (sort && sort.value !== root.dataset.dmSortDefault) u.searchParams.set('sort_by', sort.value);
      return u.pathname + u.search;
    };

    /* datos = la sección renderizada por Shopify para esa URL */
    const cache = new Map(); let wanted = null, shown = path(), timer = 0, gen = 0;
    const fetchSection = url => {
      if (cache.has(url)) return Promise.resolve(cache.get(url));
      const u = new URL(url, window.location.origin); u.searchParams.set('section_id', sectionId);
      const once = () => fetch(u.pathname + u.search, { headers: { Accept: 'text/html' }, credentials: 'same-origin' })
        .then(r => { if (!r.ok) throw new Error(String(r.status)); return r.text(); });
      return once().catch(() => new Promise(ok => setTimeout(ok, 1200)).then(once))       // un reintento antes de caer a la recarga completa
        .then(t => { cache.set(url, t); if (cache.size > 12) cache.delete(cache.keys().next().value); return t; });
    };
    const load = (url, o = {}) => {
      wanted = url; clearTimeout(timer);
      const g = outer(); if (g) g.setAttribute('data-loading', 'true');
      const run = () => fetchSection(url).then(html => { if (wanted === url) render(html, url, o); }).catch(() => { if (wanted === url) window.location.assign(url); });
      if (o.debounce && !cache.has(url)) timer = setTimeout(run, 500); else run();
    };
    const rnd = e => { const t = 43758.5453 * Math.sin(12.9898 * e); return t - Math.floor(t); };
    const idsOf = el => $$('[data-dm-card]', el).map(c => c.id).join('|');
    const mergeFacets = (f, nf) => {
      const olds = new Map($$('details[data-dm-facet]', f).map(d => [d.dataset.dmFacet, d])), seen = new Set(); let prev = null;
      for (const nd of $$('details[data-dm-facet]', nf)) {
        const k = nd.dataset.dmFacet, od = olds.get(k); seen.add(k);
        if (!od) { const box = nd.parentElement; prev ? prev.after(box) : f.prepend(box); prev = box; continue; }
        const oc = od.children[1] && od.children[1].firstElementChild, nc = nd.children[1] && nd.children[1].firstElementChild;
        if (oc && nc) {
          const a = $$('input', oc).map(keyOf), b = $$('input', nc).map(keyOf);
          if (a.length !== b.length || a.some((x, i) => x !== b[i])) {          // cambió el conjunto de opciones: se reemplaza y se repone el foco
            const focus = oc.contains(document.activeElement) && document.activeElement.matches('input') ? keyOf(document.activeElement) : null;
            oc.innerHTML = nc.innerHTML;
            if (focus) { const i = $$('input', oc).find(x => keyOf(x) === focus); if (i) i.focus({ preventScroll: true }); }
          } else {
            const want = new Map($$('input', nc).map(i => [keyOf(i), i.hasAttribute('checked')]));
            $$('input', oc).forEach(i => { const w = want.get(keyOf(i)); if (w !== undefined && i.checked !== w) i.checked = w; });
          }
          $$('.es-selector__selector', oc).forEach(l => { const i = $('input', l); if (i) l.dataset.selected = String(i.checked); });
        }
        badge(od); prev = od.parentElement;
      }
      olds.forEach((od, k) => { if (!seen.has(k)) od.parentElement.remove(); });
    };
    const render = (html, url, o) => {
      const fresh = $('[data-dm-plp]', new DOMParser().parseFromString(html, 'text/html'));
      if (!fresh) { window.location.assign(url); return; }
      let gw = gridWrap(); const ngw = $('[data-dm-r="grid"]', fresh), before = gw ? idsOf(gw) : '', after = ngw ? idsOf(ngw) : '';
      if (isSearch && (!gw || !ngw || $$('[data-dm-r="trigger"]', root).length !== $$('[data-dm-r="trigger"]', fresh).length)) {
        // búsqueda: el bloque de resultados cambia de forma (resultados ↔ sin resultados ↔ nada · con o sin botón de filtros): se reemplaza entero
        const part = q('[data-dm-r="listing"]'), npart = $('[data-dm-r="listing"]', fresh);
        if (part && npart) part.replaceWith(npart); else if (part) part.remove(); else if (npart) dialog.before(npart);
        gw = gridWrap();
      } else gw.replaceChildren(...ngw.childNodes);
      const g = outer();
      if (before !== '' && after !== '' && before !== after) {
        gen++; const l = rnd(gen) * Math.PI * 2;
        $$('.es-product-listing-grid__popItem', gw).forEach((li, t) => {
          li.setAttribute('data-pop', 'true');
          li.style.setProperty('--pop-delay', `${450 * Math.min(1, Math.max(0, 0.5 + 0.5 * Math.sin(0.7 * t + l) + (rnd(131 * gen + t) - 0.5) * 0.25))}ms`);
        });
        if (g && o.restore == null) { const m = parseFloat(getComputedStyle(g).scrollMarginTop) || 0; if (g.getBoundingClientRect().top < m) g.scrollIntoView({ behavior: 'instant', block: 'start' }); }
      }
      const swap = sel => { const a = q(sel), b = $(sel, fresh); if (a && b) a.replaceWith(b); };
      swap('[data-dm-r="pagination"]'); swap('[data-dm-r="panel-header"]');
      const nt = $$('[data-dm-r="trigger"]', fresh);
      $$('[data-dm-r="trigger"]', root).forEach((t, i) => { if (nt[i]) t.innerHTML = nt[i].innerHTML; });
      const res = q('[data-dm-r="results"]'), nres = $('[data-dm-r="results"]', fresh);
      if (res && nres) res.innerHTML = nres.innerHTML;
      mergeFacets(form(), $('form[data-dm-filters]', fresh));
      shown = url; wanted = null; setup(); DMES.init(root);
      if (o.restore != null) window.scrollTo(0, o.restore);
      onScroll(); viewList();
      root.dispatchEvent(new CustomEvent('dm:listing', { detail: { url } }));
    };
    const apply = () => {
      const url = buildUrl();
      window.history.replaceState(window.history.state, '', url);
      load(url, { debounce: true });
    };

    /* eventos */
    dialog.addEventListener('change', e => {
      const i = e.target;
      if (!(i instanceof HTMLInputElement) || !i.closest('form[data-dm-filters]')) return;
      const l = i.closest('.es-selector__selector'); if (l) l.dataset.selected = String(i.checked);
      badge(i.closest('details')); optimistic(); apply();
    });
    dialog.addEventListener('click', e => {
      const rm = e.target.closest('.es-filter-sort-panel__filterTagRemove'), all = !rm && e.target.closest('[data-dm-clear]');
      if (!rm && !all) return;
      $$('input:checked', form()).forEach(i => {
        if (i.name === 'sort_by') return;
        if (rm && !(i.name === rm.dataset.dmRemove && (rm.hasAttribute('data-dm-range') ? i.hasAttribute('data-dm-range') : i.value === rm.dataset.dmValue))) return;
        i.checked = false;
        const l = i.closest('.es-selector__selector'); if (l) l.dataset.selected = 'false';
      });
      $$('details[data-dm-facet]', dialog).forEach(badge); optimistic(); apply();
    });
    root.addEventListener('click', e => {
      const a = e.target.closest('.es-pagination__container a[href]');
      if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault();
      const url = a.pathname + a.search;
      window.history.replaceState({ ...(window.history.state || {}), dmY: window.scrollY }, '');
      window.scrollTo(0, 0); window.history.pushState({}, '', url);
      load(url);
    });
    window.addEventListener('popstate', e => {
      if (!root.isConnected) return;
      const url = path();
      if (url === shown && wanted === null) return;
      load(url, { restore: (e.state && e.state.dmY) || 0 });
    });

    /* analítica (mismo formato que snippets/rr-datalayer-plp.liquid) */
    const list = () => q('[data-dm-list-id]');
    const item = (card, ul) => {
      let it = {}; try { it = JSON.parse(card.dataset.dmItem || '{}'); } catch (e) { /* sin datos */ }
      const cards = $$('[data-dm-card]', ul);
      return { ...it, index: cards.indexOf(card) + 1, item_list_id: ul.dataset.dmListId, item_list_name: ul.dataset.dmListName };
    };
    const push = (event, ul, items) => {
      const dl = (window.dataLayer = window.dataLayer || []);
      dl.push({ ecommerce: null });
      dl.push({ event, ecommerce: { currency: ul.dataset.dmCurrency, item_list_id: ul.dataset.dmListId, item_list_name: ul.dataset.dmListName, items } });
    };
    const viewList = () => { const ul = list(); if (!ul) return; const cards = $$('[data-dm-card]', ul); if (cards.length) push('view_item_list', ul, cards.map(c => item(c, ul))); };
    document.addEventListener('click', e => {
      const a = e.target.closest && e.target.closest('a[href*="/products/"]'), card = a && a.closest('[data-dm-card]'), ul = card && card.closest('[data-dm-list-id]');
      if (!ul || !root.contains(ul)) return;
      const it = item(card, ul), dl = window.dataLayer || [], last = dl[dl.length - 1];
      const done = last && last.event === 'select_item' && last.ecommerce && last.ecommerce.items && last.ecommerce.items[0] && String(last.ecommerce.items[0].item_id) === String(it.item_id);
      if (!done) push('select_item', ul, [it]);
    }, true);

    setup();
    root.__dmListing = { load, cancel: () => { wanted = null; clearTimeout(timer); }, viewList, shown: () => shown, cached: url => cache.has(url) };
  });
}

/* ═══ 61-product-card.js ═══ */
/* ───────── tarjeta de producto (ProductCard · swatches · useCarouselNudge de España: js_legible/0qdg9j73_qrip.js) ─────────
   Marcado: snippets/dm-es-product-card.liquid → div.es-product-card__container[data-dm-card]. Mueve lo mismo que React:
     pase de fotos   Carousel de España (DMES.carousel, es/js/70-pdp-carousel.js; snap «mandatory», arrastre con mouse). Al hacer scroll:
                     data-carousel-interacted="true" + índice = round(scrollLeft / ancho) → flechas (disabled en los extremos) y barra (ancho (i+1)/n)
     arrastre        mientras dura, el clic no navega (preventDefault en captura, como onDragStart/onDragEnd de ProductCard)
     «asomo»         solo la tarjeta con data-dm-nudge y solo en táctil: a los 2 s corre el pase un 15 % (.2 s, curva regular), espera .6 s y vuelve
                     (.2 s, curva de salida); repite una vez a los 3,5 s. Se corta al tocar la foto o al cambiar de color
     colores         pasar el mouse / foco sobre un cuadrito (en táctil, tocarlo) cambia la tarjeta a ese color: fotos, etiquetas, precio, enlaces,
                     disponibilidad (los datos van en data-dm-opt de cada cuadrito). Con 6 o más se muestran 4 y «+N» (al tocarlo: data-expanded="true")
                     Los cuadritos claros llevan data-light="true" (isLightColor: luminancia > .7)
     agregar rápido  el botón dispara el evento «quick-add:open» ({ handle, url, title }) igual que openQuickAdd; si nadie lo atiende, va a la ficha
   Analítica de listas (ViewItemList / useSelectItemEvent): ver es/js/60-plp.js. */
{
  const FINE = '(hover: hover) and (pointer: fine)', TOUCH = '(hover: none) and (pointer: coarse)';
  const WIDTHS = [256, 640, 1080, 2048];
  const esc = s => String(s == null ? '' : s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  // isLightColor (módulo 399003)
  const HEX = /^#[0-9a-f]{6}$/i, LIGHT = /\b(airwair|white|cream|ivory|ecru|bone|chalk|pearl|snow|eggshell|alabaster|vanilla|natural|milk|oat|beige)\b/;
  const lin = e => (e <= 0.03928 ? e / 12.92 : Math.pow((e + 0.055) / 1.055, 2.4));
  const lum = c => {
    if (!HEX.test(c)) return null;
    const a = c.replace('#', '');
    return 0.2126 * lin(parseInt(a.slice(0, 2), 16) / 255) + 0.7152 * lin(parseInt(a.slice(2, 4), 16) / 255) + 0.0722 * lin(parseInt(a.slice(4, 6), 16) / 255);
  };
  DMES.isLightColor = c => { if (!c) return false; const t = lum(c); return t !== null ? t > 0.7 : LIGHT.test(c.trim().toLowerCase()); };

  const srcset = src => WIDTHS.map(w => `${src.replace(/([?&])width=\d+/, `$1width=${w}`)} ${w}w`).join(', ');
  const priceHTML = o => `<span class="es-product-card-summary__price" data-sale="${o.was ? 'true' : 'false'}"><span class="es-dynamic-formatted-price__container"><span data-price-label="current"><span>${o.price}</span></span></span></span>`;
  const discountHTML = o => (o.was ? `<div class="es-discounted-price__container es-product-card-summary__discountedPrice"><div class="es-discounted-price__label"><span data-price-label="original">Original</span><span class="es-discounted-price__discount"><s><span>${o.was}</span></s> ${o.pct > 0 ? `<span>-${o.pct}%</span>` : ''}</span></div></div>` : '');

  DMES.on('[data-dm-card]', card => {
    const wrap = $('.es-product-card__imageWrapper', card), visual = $('.es-product-card__visual', card), overlay = $('.es-product-card__overlay', card);
    const car = $('.es-product-card__carousel', card), ctrl = $('.es-product-card__carouselControl', card), bag = $('.es-product-card__bagButton', card);
    const priceBox = $('.es-product-card-summary__priceContainer', card), options = $('.es-product-card-swatches__options', card);
    if (!car || !ctrl) return;
    const [bPrev, bNext] = $$('.es-product-card__carouselButton', ctrl);
    const sizes = (($('img', car) || {}).sizes) || '(min-width: 1400px) 25vw, (min-width: 1024px) 33vw, 50vw';
    const C = DMES.carousel ? DMES.carousel(car) : null;
    let index = 0, nudging = false, nudgeT = null, nudgeTw = null;
    const count = () => car.children.length;

    const render = () => {
      const n = count();
      bPrev.disabled = index === 0 || (C ? !C.canMove('previous') : false);
      bNext.disabled = index >= n - 1 || (C ? !C.canMove('next') : false);
      const ind = $('.es-product-card__indicator', wrap);
      if (ind) ind.style.width = `${((index + 1) / n) * 100}%`;
    };
    car.addEventListener('scroll', () => {
      if (nudging) return;
      card.setAttribute('data-carousel-interacted', 'true');
      const t = Math.round(car.scrollLeft / car.offsetWidth);
      if (t !== index) index = t;
      render();
    }, { passive: true });
    if (C) C.subscribe(render);
    const step = d => {
      if (C) { d > 0 ? C.next() : C.previous(); return; }
      const t = Math.max(0, Math.min(count() - 1, index + d));
      car.scrollTo({ left: t * car.offsetWidth, behavior: 'smooth' });
    };
    bPrev.addEventListener('click', () => step(-1));
    bNext.addEventListener('click', () => step(1));

    // arrastre con mouse: el clic que lo cierra no debe abrir el producto
    const noClick = e => e.preventDefault();
    new MutationObserver(() => {
      if (car.getAttribute('data-drag-state') === 'dragging') window.addEventListener('click', noClick, true);
      else window.removeEventListener('click', noClick, true);
    }).observe(car, { attributes: true, attributeFilter: ['data-drag-state'] });

    // «asomo» (useCarouselNudge)
    const stopNudge = () => {
      clearTimeout(nudgeT);
      if (!nudging) return;
      nudging = false;
      if (nudgeTw) nudgeTw.kill();
      car.scrollLeft = 0; car.style.scrollSnapType = '';
    };
    if (card.hasAttribute('data-dm-nudge') && count() > 1 && mq(TOUCH) && DMES.tween) {
      let runs = 0;
      const go = () => {
        runs++; nudging = true; car.style.scrollSnapType = 'none';
        const set = v => { car.scrollLeft = v; };
        nudgeTw = DMES.tween({ from: car.scrollLeft, to: 0.15 * car.offsetWidth, ms: 200, ease: DMES.ease.regular, onUpdate: set, onComplete: () => {
          nudgeT = setTimeout(() => {
            nudgeTw = DMES.tween({ from: car.scrollLeft, to: 0, ms: 200, ease: DMES.ease.exit, onUpdate: set, onComplete: () => {
              car.style.scrollSnapType = ''; nudging = false;
              if (runs < 2) nudgeT = setTimeout(go, 3500);
            } });
          }, 600);
        } });
      };
      nudgeT = setTimeout(go, 2000);
      visual.addEventListener('touchstart', stopNudge, { passive: true });
    }

    // colores
    const light = () => $$('.es-product-card-swatches__option', card).forEach(a => {
      const sw = a.firstElementChild;
      if (sw && DMES.isLightColor(a.dataset.dmColor)) sw.setAttribute('data-light', 'true');
    });
    light();
    if (options) {
      const own = {
        own: true, url: visual.getAttribute('href'), av: card.dataset.available === 'true', handle: card.dataset.dmHandle, item: card.dataset.dmItem,
        carousel: car.innerHTML, n: count(), price: $('.es-product-card-summary__price', priceBox).outerHTML,
        discount: ($('.es-discounted-price__container', priceBox) || { outerHTML: '' }).outerHTML,
        net: ($('[data-dm-net]', priceBox) || { textContent: '' }).textContent,   // solo Argentina: «Precio sin imp. nacionales» (bloque local de la tarjeta)
      };
      let active = $('.es-product-card-swatches__option[data-active="true"]', options);
      const optionOf = a => {
        if (!a.dataset.dmOpt) return own;
        if (a.__dmOpt) return a.__dmOpt;
        let o; try { o = JSON.parse(a.dataset.dmOpt); } catch (e) { return own; }
        const tags = o.tags || [];
        return (a.__dmOpt = {
          url: o.url, av: !!o.av, handle: o.handle, item: JSON.stringify(o.item || {}), n: (o.imgs || []).length || 1,
          carousel: (o.imgs && o.imgs.length ? o.imgs : [null]).map((im, i) => `<div class="es-product-card__imageContainer"${im && im.t ? ' data-transparent="true"' : ''} style="scroll-snap-align:start;scroll-snap-stop:normal;flex-shrink:0">${im ? `<img alt="${esc(im.alt)}" class="es-product-card__image" data-nimg="1" decoding="async" draggable="false" width="${im.w}" height="${im.h}" loading="lazy" sizes="${esc(sizes)}" srcset="${esc(srcset(im.src))}" src="${esc(im.src)}" style="color:transparent">` : ''}${i === 0 && tags.length ? `<ul class="es-product-card__tags">${tags.map(t => `<li class="es-product-card__tag">${esc(t)}</li>`).join('')}</ul>` : ''}</div>`).join(''),
          price: priceHTML(o), discount: discountHTML(o), net: o.net || '',
        });
      };
      const setActive = a => {
        if (!a || a === active) return;
        const o = optionOf(a);
        if (active) active.setAttribute('data-active', 'false');
        a.setAttribute('data-active', 'true'); active = a;
        card.dataset.available = String(o.av); card.dataset.singleImage = String(o.n <= 1);
        card.dataset.dmHandle = o.handle; card.dataset.dmItem = o.item;
        visual.setAttribute('href', o.url); overlay.setAttribute('href', o.url);
        stopNudge(); car.innerHTML = o.carousel; car.scrollTo({ left: 0, behavior: 'instant' });
        index = 0; ctrl.dataset.hidden = String(o.n <= 1);
        let foot = $('.es-product-card__carouselFooter', wrap);
        if (o.n > 1 && !foot) ctrl.insertAdjacentHTML('afterend', '<div class="es-product-card__carouselFooter"><span class="es-product-card__indicator" style="width:50%"></span></div>');
        else if (o.n <= 1 && foot) foot.remove();
        if (bag) bag.disabled = !o.av;
        $('.es-product-card-summary__price', priceBox).outerHTML = o.price;
        const dis = $('.es-discounted-price__container', priceBox);
        if (dis) dis.remove();
        if (o.discount) priceBox.insertAdjacentHTML('beforeend', o.discount);
        const net = $('[data-dm-net]', priceBox); if (net && o.net) net.textContent = o.net;
        render();
      };
      const sw = e => e.target.closest && e.target.closest('.es-product-card-swatches__option');
      options.addEventListener('mouseover', e => { const a = sw(e); if (a) setActive(a); });
      options.addEventListener('focusin', e => { const a = sw(e); if (a) setActive(a); });
      options.addEventListener('click', e => {
        const more = e.target.closest('.es-product-card-swatches__overflow');
        if (more) {
          more.insertAdjacentHTML('beforebegin', more.dataset.dmMore || ''); more.remove();
          options.setAttribute('data-expanded', 'true'); light();
          return;
        }
        const a = sw(e);
        if (a && mq(TOUCH)) { e.preventDefault(); setActive(a); }
      });
    }

    // agregar rápido (openQuickAdd): evento global; sin panel que lo atienda, abre la ficha
    if (bag) bag.addEventListener('click', () => {
      const detail = { styleId: card.dataset.dmHandle, handle: card.dataset.dmHandle, url: visual.getAttribute('href'), title: (card.closest('article') || card).getAttribute('aria-label') || '', card };
      const free = window.dispatchEvent(new CustomEvent('quick-add:open', { detail, cancelable: true }));
      if (free) window.location.href = detail.url;
    });
    render();
  });
}

/* ═══ 62-quick-add.js ═══ */
/* ───────── agregar rápido (QuickAddPanel de España: js_legible/41rvnxj5yzquj.js; su contenido es SizeSelectorPanelContent, el mismo panel
   de tallas del PDP) ─────────
   Como allá, es UN panel global: dialog#quick-add-dialog.es-panel__container.es-quick-add-panel__panel al final del <body> (acá con id dm-quick-add-dialog). Lo crea este
   archivo la primera vez que se usa (así sirve en cualquier página que tenga tarjetas, sin tocar el layout).
   Flujo (igual que España):
     · la tarjeta dispara «quick-add:open» ({ handle, url, title }) → el panel abre al tiro con el esqueleto de carga (PanelLoadingState)
     · llega el producto (/products/<handle>.js):
         – una sola talla (o sin tallas) y con stock → se agrega directo, sin elegir (shouldDirectAdd)
         – varias tallas → grilla de 5 columnas (Selector «size»: data-selected, data-unavailable + campana, bordes data-first-… y data-has-available-…)
           y botón «Añadir al carrito»; sin talla elegida muestra «Selecciona una talla»
     · al agregar: botón data-loading="true" → POST /cart/add.js → cierra el panel y avisa al theme con el MISMO evento que su formulario
       de producto («cart:update» con source product-form-component): se actualiza el contador y se abre el panel «Añadido al carrito» (81-upsell-panel.js)
   Diferencias con España (sin dato o sin estado capturado): no hay «los clientes dicen…» (reseñas de talla) ni selector de color dentro del
   panel (el color se elige en la tarjeta); una talla agotada lleva a la ficha, donde está el «Avísame». */
{
  const ID = 'dm-quick-add-dialog';      // España usa «quick-add-dialog»; ese id ya lo ocupa el modal de compra rápida de Horizon (snippets/quick-add-modal.liquid)
  const L = { title: 'Añadir rápido', add: 'Añadir al carrito', adding: 'Añadiendo al carrito...', size: 'Selecciona una talla', guide: 'Guía de tallas',
    error: 'No se pudo agregar el artículo al carrito. Inténtalo de nuevo.', load: 'No se pudo cargar el producto. Inténtalo de nuevo más tarde.' };
  const esc = s => String(s == null ? '' : s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const use = (n, t) => `<svg aria-hidden="true" viewBox="0 0 20 20" xml:space="preserve"><title>${t}</title><use x="0" y="0" href="#_RI-${n}"></use></svg>`;
  const inline = (n, t, cls) => { const g = document.getElementById(`_RI-${n}`); return `<svg class="${cls}" aria-hidden="true" viewBox="0 0 20 20" xml:space="preserve"><title>${t}</title><g>${g ? g.innerHTML : ''}</g></svg>`; };
  const controls = () => `<div class="es-panel-controls__container"><div class="es-panel-controls__controls"><button type="button" class="es-dialog-dismiss__dismiss es-panel-controls__control" aria-label="Cerrar" command="request-close" commandfor="${ID}" data-control="close">${use('close', 'Close')}</button></div></div>`;
  const header = (t, extra = '') => `<header class="es-panel-header__container${extra}" data-has-back-button="false" data-variant="default"><div class="es-panel-header__headerGroup"><h2 class="es-panel-header__title" tabindex="-1" autofocus>${esc(t)}</h2></div></header>`;
  const pending = () => `<div>${controls()}<div class="es-panel-loading-state__container" data-loading="true" inert><header class="es-panel-loading-state__header" data-variant="default"><p class="es-panel-loading-state__title">Cargando</p></header><div class="es-panel-loading-state__box" data-skeleton-block="true"></div></div></div>`;
  const failed = (title, msg) => `<div>${controls()}${header(title, ' es-quick-add-panel__panelTitle')}<div class="es-panel-content__content" data-variant="default"><p class="es-quick-add-panel__error" role="alert">${esc(msg)}</p></div></div>`;

  // textos adaptables por país: <script type="application/json" data-dm-quick-add-labels> (lo emite sections/dm-collection.liquid)
  const labels = () => { const e = document.querySelector('script[data-dm-quick-add-labels]'); if (e) { try { Object.assign(L, JSON.parse(e.textContent)); } catch (err) { /* quedan los textos por defecto */ } } };
  let dialog = null, content = null, token = 0;
  const products = new Map();
  const ensure = () => {
    if (dialog && dialog.isConnected) return;
    labels();
    const host = document.createElement('div'); host.className = 'es';
    host.innerHTML = `<dialog id="${ID}" closedby="any" class="es-panel__container es-quick-add-panel__panel" aria-label="${L.title}"><div class="es-panel__content" data-panel-appearance="true" data-alignment="end" data-size="default" data-expanded="false"></div></dialog>`;
    document.body.append(host); dialog = host.firstElementChild; content = dialog.firstElementChild;
    DMES.init(host);
  };
  const product = handle => {
    if (!products.has(handle)) products.set(handle, fetch(`/products/${encodeURIComponent(handle)}.js`, { headers: { Accept: 'application/json' } }).then(r => { if (!r.ok) throw new Error(String(r.status)); return r.json(); }).catch(e => { products.delete(handle); throw e; }));
    return products.get(handle);
  };
  // tallas del producto (buildSizeOptions): una celda por valor de la opción de talla, con su variante
  const sizesOf = p => {
    const oi = (p.options || []).findIndex(o => /talla|talle|size/i.test(o.name));
    if (oi < 0) return [];
    const by = new Map();
    for (const v of p.variants) { const k = v.options[oi], cur = by.get(k); if (!cur || (!cur.available && v.available)) by.set(k, v); }
    return p.options[oi].values.filter(k => by.has(k)).map(k => ({ label: k, variant: by.get(k), available: !!by.get(k).available }));
  };
  const add = (p, variant) => fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] }) })
    .then(r => r.json().then(j => { if (!r.ok) throw new Error(j.description || j.message || L.error); return j; }))
    .then(() => {
      DMES.dialog.requestClose(dialog);
      // mismo aviso que assets/product-form.js de Horizon (CartAddEvent): contador del header + panel «Añadido al carrito» + sincronías que cuelgan de «cart:update»
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: {}, sourceId: String(variant.id), data: { source: 'product-form-component', itemCount: 1, productId: String(p.id) } } }));
      window.dispatchEvent(new CustomEvent('add-to-cart:success', { detail: { styleId: p.handle } }));
    });

  // detail.skipPanel (openQuickAdd de España con skipPanel: lo usa el panel «Añadido al carrito», 81-upsell-panel.js): el panel no se abre
  // de entrada; solo si hay que elegir talla o mostrar un error
  const reveal = detail => { if (detail.skipPanel && !dialog.open) DMES.dialog.show(dialog); };
  const show = (p, detail) => {
    const sizes = sizesOf(p), url = detail.url || p.url || `/products/${p.handle}`;
    const single = sizes.length <= 1, only = single ? (sizes[0] ? sizes[0].variant : p.variants[0]) : null;
    if (single && only && only.available) {                 // shouldDirectAdd
      add(p, only).catch(e => { content.innerHTML = failed(p.title, e.message || L.error); reveal(detail); });
      return;
    }
    if (single) { window.location.href = url; return; }      // agotado y sin tallas que elegir: a la ficha
    reveal(detail);
    const guide = (document.querySelector('.es[data-dm-size-guide]') || { dataset: {} }).dataset.dmSizeGuide;   // dentro de .es: en Argentina el <body> lleva un data-dm-size-guide de la capa anterior (texto, no URL)
    const n = sizes.length;
    const cells = sizes.map((s, i) => {
      const col = i % 5, right = col < 4 && i + 1 < n && sizes[i + 1].available !== false, below = i + 5 < n && sizes[i + 5].available !== false;
      return `<label class="es-selector__selector" data-variant="size" data-selection-mode="multiple" data-grouped="true" data-selected="false" data-disabled="false" aria-disabled="false" data-unavailable="${s.available ? 'false' : 'true'}" data-low-stock="false"${col === 0 ? ' data-first-column="true"' : ''}${i < 5 ? ' data-first-row="true"' : ''}${right ? ' data-has-available-right="true"' : ''}${below ? ' data-has-available-bottom="true"' : ''}><input class="es-sr-only__container" type="checkbox" value="${i}">${s.available ? '' : inline('bell', 'Notify me', 'es-selector__cellIcon')}<span class="es-selector__textWrapper"><span class="es-selector__label" data-text="${esc(s.label)}">${esc(s.label)}</span></span></label>`;
    }).join('');
    content.innerHTML = `<form id="quick-add-form" class="es-quick-add-panel__form">${controls()}${header(L.title)}<div class="es-panel-content__content" data-variant="default">${guide ? `<div class="es-size-selector-panel__sizeInfo"><a class="es-action__action es-size-selector-panel__sizeGuideLink" href="${esc(guide)}"><span class="es-underline-appearance__container" data-size="small" data-theme="dark">${L.guide}</span></a></div>` : ''}<div class="es-selector__sizeGroupGrid" style="grid-template-columns:repeat(5, 1fr)">${cells}</div></div><footer class="es-panel-footer__footer" data-theme="solid" data-variant="default"><div class="es-size-selector-panel__footerActions"><button type="submit" class="es-add-to-cart-submit-button__button es-size-selector-panel__addToCart" data-loading="false"><span class="es-box-appearance__button es-add-to-cart-submit-button__appearance" data-theme="primary" data-variant="text">${L.add}</span></button></div></footer><input type="hidden" name="size" value="" required></form>`;
    const form = content.firstElementChild, fa = $('.es-size-selector-panel__footerActions', form), btn = $('button[type="submit"]', form), label = btn.firstElementChild, hidden = $('input[name="size"]', form);
    let chosen = null, busy = false;
    const note = (cls, msg) => { $$('p[role="alert"]', fa).forEach(e => e.remove()); if (msg) fa.insertAdjacentHTML('beforeend', `<p class="${cls}" role="alert">${esc(msg)}</p>`); };
    form.addEventListener('change', e => {
      const i = e.target; if (!i.matches('.es-selector__selector input')) return;
      const s = sizes[Number(i.value)];
      if (!s.available) { window.location.href = `${url}${url.includes('?') ? '&' : '?'}variant=${s.variant.id}`; return; }
      chosen = i.checked ? s : null;
      $$('.es-selector__selector', form).forEach(l => { const x = $('input', l), on = x === i && i.checked; x.checked = on; l.dataset.selected = String(on); });
      hidden.value = chosen ? chosen.label : ''; note('', '');
    });
    form.addEventListener('submit', e => {
      e.preventDefault();
      if (busy) return;
      if (!chosen) { note('es-size-selector-panel__sizeRequiredError', L.size); return; }
      busy = true; note('', ''); btn.dataset.loading = 'true'; label.textContent = L.adding;
      add(p, chosen.variant).catch(err => { busy = false; btn.dataset.loading = 'false'; label.textContent = L.add; note('es-size-selector-panel__addToCartError', err.message || L.error); });
    });
  };

  window.addEventListener('quick-add:open', e => {
    const d = e.detail || {};
    if (!d.handle || !DMES.dialog) return;                   // sin datos: la tarjeta abre la ficha
    e.preventDefault();
    ensure();
    const my = ++token;
    content.innerHTML = pending();
    if (!d.skipPanel) DMES.dialog.show(dialog);
    product(d.handle).then(p => { if (my === token) show(p, d); }).catch(() => { if (my === token) { content.innerHTML = failed(d.title || L.title, L.load); reveal(d); } });
  });
}

/* ═══ 63-search-page.js ═══ */
/* ───────── página de resultados de búsqueda · componentes de España: js_legible/3nks8wu-_63p0.js (SearchPageBar · SearchInput ·
   SearchPageResults) y 2gd49b61todti.js (useSuggestions · AutoGrow · SearchHighlightedText · useProductListingData ·
   ProductListingGridSkeleton · isValidSearchQuery / SEARCH_INPUT_MIN_CHARACTERS = 3) ─────────
   Marcado: sections/dm-search.liquid (.es[data-dm-plp][data-dm-search-page]). El listado (filtros, orden, paginación, botón fijo, «atrás»,
   view_item_list / select_item) es el de la colección: es/js/60-plp.js. Acá va lo propio de la búsqueda, igual que allá:
     campo        escribir cambia la búsqueda sin recargar: los resultados llegan 500 ms después de la última tecla (useDebouncedValue; sin
                  espera si ya se pidieron) y la URL queda con la búsqueda nueva (history.replaceState; vuelve a la página 1 y conserva
                  filtros y orden). No hay formulario: Enter solo adelanta esa carga. Si la página abre sin búsqueda, el campo toma el
                  foco. La lupa del header, en esta página, lleva el foco al campo (es/js/15-nav.js)
     sugerencias  con 3 o más caracteres (sin los espacios de los extremos) se piden las del término (hasta 4); mientras llegan, la lista
                  anterior sigue a la vista con data-loading="true"; lo escrito va resaltado palabra a palabra, por prefijo; elegir una
                  la pone en el campo. El contenedor (es-auto-grow__container) lleva en línea el alto de su contenido (ResizeObserver);
                  que la lista se vea solo con el foco en el campo lo decide el CSS de España
     resultados   menos de 3 caracteres → nada · 0 resultados → estado «sin resultados» · cargando sin resultados a la vista → grilla
                  esqueleto de 8 · cargando con resultados a la vista → la grilla sigue ahí con data-loading="true" (keepPreviousData)
     analítica    view_search_results { search_term, search_results, section_location: 'search results page' }, una vez por término
                  cargado (con sinónimo se agrega search_term_original = lo escrito); view_item_list de la primera carga (en la
                  colección lo empuja snippets/rr-datalayer-plp.liquid)
   Propio de la tienda (se conserva de la búsqueda anterior):
     · solo productos y agotados al final: toda URL que se arma acá lleva type=product y options[unavailable_products]=last. Si la página
       llegó sin ellos se vuelve a pedir la sección con ellos y la URL se completa con la primera interacción (ver «al entrar»)
     · sinónimos (assets/rr-search-synonyms.js: «mary jane» → «merceditas»…): ese archivo redirige al llegar a /search y remapea las
       consultas de la búsqueda predictiva. Al escribir acá, el término que la búsqueda predictiva dice haber buscado (data-dm-terms de
       sections/dm-predictive-search.liquid) es el que se usa para los resultados; lo escrito queda en rr_from, igual que en esa redirección
   Distinto de España:
     · la URL cambia UNA vez por búsqueda, junto con la carga (allá, en cada tecla): Clarity reinicia la grabación con cada cambio de URL
       y las herramientas que escuchan el historial lo cuentan como página vista; una tecla no es una página
     · por el origen de los datos: las sugerencias salen 150 ms después de la última tecla (allá, al instante; Shopify limita las
       solicitudes de la búsqueda predictiva) y la primera vez que se escribe un término los resultados esperan esa respuesta (hasta
       1,2 s más) para saber si tiene sinónimo. */
{
  const MIN = 3, DEBOUNCE_MS = 500, REQUEST_WAIT_MS = 150, GRACE_MS = 1200;
  const loadingAttr = (e, on) => { if (!e) return; if (on) { if (e.getAttribute('data-loading') !== 'true') e.setAttribute('data-loading', 'true'); } else if (e.hasAttribute('data-loading')) e.removeAttribute('data-loading'); };
  // SearchHighlightedText: parte el texto en palabras (\w+) y resalta el comienzo de cada una que calza con un término escrito
  // (mismo algoritmo que el panel de búsqueda, es/js/16-search.js; cambia la clase)
  const highlight = (text, sub) => {
    const f = document.createDocumentFragment();
    if (!sub) { f.append(text); return f; }
    const terms = sub.toLowerCase().split(/\s+/).filter(Boolean);
    for (const tok of text.split(/(\w+)/)) {
      const r = tok.toLowerCase(), hit = terms.find(t => r.startsWith(t) || t.startsWith(r));
      if (!hit) { if (tok) f.append(tok); continue; }
      const n = Math.min(tok.length, hit.length), st = document.createElement('strong');
      st.className = 'es-search-page-bar__highlightedText'; st.textContent = tok.slice(0, n); f.append(st);
      if (tok.length > n) f.append(tok.slice(n));
    }
    return f;
  };
  // misma normalización que rr-search-synonyms.js: sirve para saber si la búsqueda predictiva usó otro término
  const norm = s => String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/\s+/g, ' ').trim();

  DMES.on('[data-dm-search-page]', root => {
    const L = root.__dmListing, input = $('#search-page-input', root), outer = $('.es-search-page-bar__suggestionsOuter', root), dialog = $('#filter-sort-panel', root);
    const inner = outer && outer.firstElementChild;
    if (!L || !input || !inner || !dialog) return;
    const searchUrl = root.dataset.dmBase || '/search', suggestUrl = root.dataset.dmSuggestUrl || '/search/suggest';
    const tpl = k => { const t = $(`template[data-dm-tpl="${k}"]`, root); return t ? t.content.firstElementChild.cloneNode(true) : null; };
    const valid = v => typeof v === 'string' && v.length >= MIN && v.trim().length > 0;          // isValidSearchQuery
    const here = () => window.location.pathname + window.location.search;
    const param = k => new URL(window.location.href).searchParams.get(k);
    const part = () => $('[data-dm-r="listing"]', root);
    const gridOf = p => p && $('[data-dm-r="grid"] .es-product-listing-grid__outer', p);
    const cache = new Map();                                     // término → { done, list, mapped }
    let q = input.value, sug = null, failed = null;              // sug: última lista cargada (se conserva mientras llega la nueva)
    let reqT = 0, debT = 0, graceT = 0, pending = null, kept = null, typed = false, lastSent;

    /* URL = searchHrefSchema.stringify({ ...estado, query, page: 1 }): conserva filtros y orden y vuelve a la página 1 */
    const withStoreParams = u => { u.searchParams.set('type', 'product'); u.searchParams.set('options[unavailable_products]', 'last'); return u.pathname + u.search; };
    const urlFor = (query, mapped) => {
      const u = new URL(window.location.href), p = u.searchParams, term = mapped || query;
      p.delete('page'); p.delete('rr_from');
      if (term) p.set('q', term); else p.delete('q');
      if (mapped) p.set('rr_from', query.trim());
      return withStoreParams(u);
    };
    const replace = url => { if (url !== here()) { try { window.history.replaceState(window.history.state, '', url); } catch (e) { /* Safari limita los cambios de URL por minuto */ } } };

    /* —— sugerencias (useSuggestions + AutoGrow) —— */
    const done = s => { const e = cache.get(s); return e && e.done ? e : null; };
    const settled = s => !!done(s) || failed === s;
    const request = s => {
      if (cache.has(s)) return;
      const e = { done: false, list: [], mapped: null }; cache.set(s, e); if (failed === s) failed = null;
      const u = new URL(suggestUrl, window.location.origin);
      u.searchParams.set('q', s); u.searchParams.set('resources[type]', 'query'); u.searchParams.set('resources[limit]', '4'); u.searchParams.set('section_id', 'dm-predictive-search');
      fetch(u.toString(), { headers: { Accept: 'text/html' } })
        .then(r => { if (!r.ok) throw new Error(`sugerencias ${r.status}`); return r.text(); })
        .then(html => {
          const box = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-dm-predictive]');
          if (!box) throw new Error('sugerencias: respuesta sin datos');
          let list = []; try { list = JSON.parse($('script[data-dm-part="suggestions"]', box).textContent) || []; } catch (x) { list = []; }
          e.list = list.filter(x => typeof x === 'string' && x).slice(0, 4);
          const used = (box.dataset.dmTerms || '').trim();
          e.mapped = used && norm(used) !== norm(s) ? used : null;      // rr-search-synonyms.js cambió el término: hay sinónimo
          e.done = true;
        })
        .catch(() => { cache.delete(s); failed = s; })
        .then(() => {
          if (s !== q.trim()) return;
          if (done(s)) sug = e.list;
          renderSug();
          if (pending) { go(); return; }
          // la respuesta llegó después del plazo de gracia y el término escrito tiene sinónimo: se corrige la búsqueda
          if (typed && e.done && e.mapped && valid(q) && norm(param('q')) !== norm(e.mapped)) { const url = urlFor(q, e.mapped); replace(url); waiting(); start(url); }
        });
    };
    const hrefFor = label => `${searchUrl}?q=${encodeURIComponent(label)}&type=product&options%5Bunavailable_products%5D=last`;
    const renderSug = () => {
      const s = q.trim(), loading = s.length >= MIN && !settled(s);
      let ul = $(':scope > ul.es-search-page-bar__suggestions', inner);
      if (!sug || !sug.length) { if (ul) ul.remove(); return; }
      if (!ul) { ul = document.createElement('ul'); ul.className = 'es-search-page-bar__suggestions'; inner.append(ul); }
      loadingAttr(ul, loading);
      const old = new Map([...ul.children].map(li => [li.dataset.dmKey, li]));       // se reutiliza la fila de cada texto (como las «key» de React)
      const rows = sug.map(label => {
        let li = old.get(label); if (li) old.delete(label); else { li = tpl('suggestion'); li.dataset.dmKey = label; $('a', li).setAttribute('href', hrefFor(label)); }
        const sig = `${label}\u0001${q}`;
        if (li.dataset.dmSig !== sig) { li.dataset.dmSig = sig; $('a > div', li).replaceChildren(highlight(label, q)); }
        return li;
      });
      old.forEach(li => li.remove());
      rows.forEach((li, i) => { if (ul.children[i] !== li) ul.insertBefore(li, ul.children[i] || null); });
    };

    /* —— resultados (SearchPageResults + useProductListingData) —— */
    // mientras se espera: la grilla que había queda «cargando»; sin grilla a la vista, el esqueleto
    const waiting = () => {
      let p = part();
      if (!p && kept) { dialog.before(kept); p = kept; }
      kept = null;
      const g = gridOf(p);
      if (g) { loadingAttr(g, true); return; }
      if (p && p.hasAttribute('data-dm-skeleton')) return;
      const sk = tpl('skeleton'); if (!sk) return;
      sk.setAttribute('data-dm-skeleton', '');
      if (p) p.replaceWith(sk); else dialog.before(sk);
    };
    const start = url => {
      L.load(url);
      const p = part(); if (p && p.hasAttribute('data-dm-skeleton')) p.removeAttribute('data-loading');      // el esqueleto no lleva data-loading en la grilla
    };
    // carga: pasada la espera y sabiendo si el término tiene sinónimo (o agotado el plazo de gracia). La URL cambia acá, una vez por búsqueda
    const go = force => {
      if (!pending || !pending.due) return;
      const s = pending.q.trim();
      if (!force && !settled(s)) return;
      const e = done(s), url = urlFor(pending.q, e ? e.mapped : null);
      pending = null; clearTimeout(graceT);
      replace(url); start(url);
    };
    const fire = () => {
      if (!pending || pending.due) return;
      const s = pending.q.trim();
      pending.due = true; clearTimeout(debT);
      if (!cache.has(s)) { clearTimeout(reqT); request(s); }
      go();
      if (pending) graceT = setTimeout(() => go(true), GRACE_MS);
    };
    const setQuery = (v, fromInput) => {
      q = v; typed = true; if (!fromInput && input.value !== v) input.value = v;
      const s = q.trim();
      clearTimeout(reqT); clearTimeout(debT); clearTimeout(graceT); pending = null;
      if (s.length >= MIN && !cache.has(s)) reqT = setTimeout(() => request(s), REQUEST_WAIT_MS);
      if (done(s)) sug = done(s).list;
      renderSug();
      if (!valid(q)) {                                            // menos de 3 caracteres: sin resultados a la vista
        L.cancel();
        const p = part(); if (p) { kept = p.hasAttribute('data-dm-skeleton') ? null : p; p.remove(); }
        debT = setTimeout(() => replace(urlFor(q, null)), DEBOUNCE_MS);
        return;
      }
      waiting();
      if (settled(s)) {                                           // ya se sabe si tiene sinónimo
        const e = done(s), url = urlFor(q, e ? e.mapped : null);
        if (url === L.shown() && gridOf(part())) { L.cancel(); loadingAttr(gridOf(part()), false); replace(url); return; }      // es lo que ya está a la vista
        if (L.cached(url)) { replace(url); start(url); return; }                                                               // ya se pidió: sin espera
      }
      pending = { q, due: false }; debT = setTimeout(fire, DEBOUNCE_MS);
    };

    input.addEventListener('input', () => setQuery(input.value, true));
    input.addEventListener('keydown', e => {
      if (e.key !== 'Enter' || e.isComposing) return;
      e.preventDefault(); fire();
    });
    inner.addEventListener('click', e => {
      const a = e.target.closest('a.es-search-page-bar__suggestionItem'), li = a && a.parentElement;
      if (!li || !li.dataset.dmKey) return;
      e.preventDefault(); setQuery(li.dataset.dmKey);
    });
    new ResizeObserver(es => { const x = es[es.length - 1]; if (x) outer.style.height = `${x.contentRect.height}px`; }).observe(inner);

    /* —— analítica —— */
    const total = () => { const c = $('[data-dm-r="results"] .es-filter-sort-panel__showResultsCount', dialog); return c ? Number(c.textContent.replace(/[^0-9]/g, '')) || 0 : 0; };
    const sendView = () => {
      const term = param('q') || '';
      if (!valid(term) || lastSent === term) return;
      lastSent = term;
      const ev = { search_term: term, search_results: total(), section_location: 'search results page', event: 'view_search_results' };
      const from = param('rr_from'); if (from) ev.search_term_original = from;          // con sinónimo: lo que la persona escribió (demanda real)
      (window.dataLayer = window.dataLayer || []).push(ev);
    };
    root.addEventListener('dm:listing', () => { kept = null; sendView(); });
    // «atrás» / «adelante»: el listado vuelve a pedir la sección; acá el campo vuelve a mostrar la búsqueda de esa URL
    window.addEventListener('popstate', () => {
      if (!root.isConnected) return;
      const v = param('q') || '';
      if (v === q) return;
      clearTimeout(reqT); clearTimeout(debT); clearTimeout(graceT); pending = null;
      q = v; input.value = v;
      const s = v.trim(); if (s.length >= MIN && !cache.has(s)) request(s);
      if (done(s)) sug = done(s).list;
      renderSug();
    });

    /* —— al entrar —— */
    const sp = new URL(window.location.href).searchParams;
    if (valid(q) && (sp.get('type') !== 'product' || sp.get('options[unavailable_products]') !== 'last')) {
      // llegó sin los parámetros de la tienda: se vuelve a pedir la sección con ellos (si no hay resultados, pedir solo productos no agrega nada).
      // La URL se completa con la primera interacción —antes de que la persona pueda filtrar, paginar o salir a un producto— y no durante
      // la carga: así no se cambia el historial mientras arrancan las herramientas de medición (Clarity se reinicia con cada cambio de URL)
      if (gridOf(part())) { waiting(); start(withStoreParams(new URL(window.location.href))); } else { sendView(); L.viewList(); }
      const complete = () => {
        ['pointerdown', 'touchstart', 'keydown'].forEach(t => window.removeEventListener(t, complete, true));
        const u = new URL(window.location.href);
        if (valid(u.searchParams.get('q') || '')) replace(withStoreParams(u));
      };
      ['pointerdown', 'touchstart', 'keydown'].forEach(t => window.addEventListener(t, complete, { capture: true, passive: true }));
    } else { sendView(); L.viewList(); }
    if (q.trim().length >= MIN) request(q.trim());
    if (!q) input.focus();
  });
}

/* ═══ 70-pdp-carousel.js ═══ */
/* ───────── carrusel de scroll nativo (Carousel · CarouselItem · CarouselControl · useCarouselPointerDrag de España; módulos 553360/221860/454292) ─────────
   Lo usan la galería del PDP, su popup, el selector de colores y los tiles de material. El marcado ya trae los estilos en línea que pone React
   (overflow, scroll-snap-type, scroll-behavior en la raíz; scroll-snap-align en cada ítem): acá va solo el estado.
   DMES.carousel(root) → { items(), next(), previous(), goTo(i, behavior), activeIndex, progress, enabled, canMove('next'|'previous'), subscribe(fn) }
   Igual que allá:
     · índice aproximado al hacer scroll = getItemIndexAtScroll (peso .5); al navegar con flechas manda el índice destino hasta que el scroll queda quieto (200 ms)
     · tocar / rueda / puntero sobre la raíz cancela la navegación en curso
     · flecha deshabilitada si no hay scroll posible o si ya está en ese extremo
     · con mouse (hover + puntero fino) se arrastra: >5 px empieza, desactiva el snap mientras dura y al soltar va al ítem que corresponde; el clic que cierra el arrastre no pasa */
{
  const indexAt = (root, items, direction, weight = 1) => {
    const p = root.scrollLeft;
    return items.findIndex(it => {
      const w = it.offsetWidth, l = it.offsetLeft;
      return typeof direction === 'number'
        ? Math.floor(l + (w - 10) * ((direction + 1) / 2) * weight) > Math.floor(p + direction)
        : Math.floor(l) > Math.floor(p);
    });
  };
  const posAt = it => it.offsetLeft - (parseFloat(getComputedStyle(it).scrollMarginInlineStart) || 0);

  DMES.carousel = root => {
    if (root.__dmCarousel) return root.__dmCarousel;
    const snap = root.dataset.dmCarousel || 'none';
    const items = () => [...root.children].filter(e => e.tagName !== 'TEMPLATE');
    const S = { approx: 0, nav: -1, progress: 0, enabled: true, base: 0, acc: 0, behavior: 'smooth' };
    const subs = new Set();
    const progress = () => { const n = root.scrollWidth - root.offsetWidth; return n <= 0 ? 1 : Math.min(1, Math.max(0, Math.round((root.scrollLeft / n) * 1000) / 1000)); };
    const clamp = i => Math.min(Math.max(i, 0), Math.max(items().length - 1, 0));
    const emit = () => subs.forEach(f => { try { f(api); } catch (e) { console.error('[dm-es] carousel', e); } });
    const navTo = i => {
      S.nav = i; emit();
      const it = items()[i]; if (!it) return;
      root.scrollTo({ left: posAt(it), behavior: S.behavior }); S.behavior = 'smooth';
    };
    const moveBy = d => {
      if (S.nav === -1) S.base = indexAt(root, items(), Math.sign(d));
      const t = clamp(S.nav === -1 ? S.base + S.acc + d : S.nav + d);
      S.acc = t - S.base; navTo(t);
    };
    const api = (root.__dmCarousel = {
      root, items,
      next() { moveBy(1); }, previous() { moveBy(-1); },
      goTo(i, behavior = 'smooth') { S.behavior = behavior; if (S.nav === -1) S.base = S.approx; const t = clamp(i); S.acc = t - S.base; navTo(t); },
      get activeIndex() { return S.nav !== -1 ? S.nav : S.approx; },
      get progress() { return S.progress; },
      get enabled() { return S.enabled; },
      canMove(dir) {
        const last = Math.max(items().length - 1, 0), a = api.activeIndex;
        let l = S.progress; if (a === 0) l = 0; else if (a === last) l = 1;
        return S.enabled && !(l === 0 && dir === 'previous') && !(l === 1 && dir === 'next');
      },
      subscribe(fn) { subs.add(fn); fn(api); return () => subs.delete(fn); },
    });
    let last = progress(), idle, busy = false;
    const measure = state => {
      const o = progress(), d = o - last; last = o;
      const l = indexAt(root, items(), d, 0.5);
      if (l !== -1) S.approx = l;
      S.progress = o;
      if (state === 'idle') { S.nav = -1; S.acc = 0; }
      emit();
    };
    root.addEventListener('scroll', () => {
      clearTimeout(idle); idle = setTimeout(() => requestAnimationFrame(() => measure('idle')), 200);
      if (!busy) { busy = true; requestAnimationFrame(() => measure('scrolling')); setTimeout(() => { busy = false; }, 50); }
    }, { passive: true });
    const cancel = () => { if (S.nav !== -1) { S.nav = -1; emit(); } };
    root.addEventListener('touchstart', cancel, { passive: true });
    root.addEventListener('wheel', cancel, { passive: true });
    root.addEventListener('pointerdown', cancel, { passive: true });
    new ResizeObserver(() => { S.progress = progress(); S.enabled = root.scrollWidth > root.offsetWidth; emit(); }).observe(root);
    S.progress = last; S.enabled = root.scrollWidth > root.offsetWidth;

    if (mq('(hover: hover) and (pointer: fine)')) {
      let dragging = false, off = [0, 0], from = [0, 0], dir = 0;
      const swallow = e => { if (dragging) e.stopPropagation(); };
      const move = e => {
        off = [off[0] + e.movementX, off[1] + e.movementY];
        const mv = [off[0] - from[0], off[1] - from[1]]; dir = Math.sign(mv[0]);
        if (dragging) { root.scrollBy({ left: -e.movementX, behavior: 'instant' }); return; }
        if (Math.abs(mv[0]) > 5 || Math.abs(mv[1]) > 5) {
          if (snap !== 'none') root.style.scrollSnapType = 'none';
          root.setAttribute('data-drag-state', 'dragging'); dragging = true;
        }
      };
      const up = () => {
        window.removeEventListener('pointermove', move); window.removeEventListener('pointerup', up); window.removeEventListener('pointerleave', up);
        setTimeout(() => {
          dragging = false; root.setAttribute('data-drag-state', 'idle');
          if (snap !== 'none') {
            const it = items()[indexAt(root, items(), dir)];
            root.style.scrollSnapType = `x ${snap}`;
            if (it) root.scrollTo({ left: posAt(it), behavior: 'smooth' });
          }
          window.removeEventListener('click', swallow, true);
        }, 0);
      };
      root.addEventListener('pointerdown', () => {
        if (!S.enabled) return;
        from = off; dragging = false;
        window.addEventListener('pointermove', move, { passive: true }); window.addEventListener('pointerup', up); window.addEventListener('pointerleave', up);
        window.addEventListener('click', swallow, true);
      });
    }
    return api;
  };

  /* curva cúbica (GSAP CustomEase de España: regular .45,.02,.09,.98 · exit .4,0,1,1) y animación de una propiedad numérica */
  const bezier = (x1, y1, x2, y2) => t => {
    let u = t;
    for (let i = 0; i < 8; i++) {
      const x = 3 * (1 - u) * (1 - u) * u * x1 + 3 * (1 - u) * u * u * x2 + u * u * u - t;
      const dx = 3 * (1 - u) * (1 - u) * x1 + 6 * (1 - u) * u * (x2 - x1) + 3 * u * u * (1 - x2);
      if (Math.abs(x) < 1e-5 || !dx) break;
      u -= x / dx;
    }
    return 3 * (1 - u) * (1 - u) * u * y1 + 3 * (1 - u) * u * u * y2 + u * u * u;
  };
  DMES.ease = { regular: bezier(0.45, 0.02, 0.09, 0.98), exit: bezier(0.4, 0, 1, 1) };
  DMES.tween = ({ from, to, ms, ease = DMES.ease.regular, onUpdate, onComplete }) => {
    let t0 = null, dead = false;
    const tick = now => {
      if (dead) return;
      if (t0 === null) t0 = now;
      const k = Math.min(1, (now - t0) / ms);
      onUpdate(from + (to - from) * ease(k));
      if (k < 1) requestAnimationFrame(tick); else if (onComplete) onComplete();
    };
    requestAnimationFrame(tick);
    return { kill() { dead = true; } };
  };
}

/* ═══ 71-pdp-gallery.js ═══ */
/* ───────── galería del PDP (función eF de España, js 1jm4nhu…: pdp-gallery + popup a pantalla completa; useCarouselNudge, módulo 123793) ─────────
   Marcado: [data-dm-gallery] > .es-pdp-gallery__indicators · flechas · .es-pdp-gallery__carousel[data-dm-carousel] · y dialog#pdp-gallery-popup con
   <template data-dm-gallery-popup> (España monta el contenido del popup solo mientras está abierto: acá se clona al abrir y se quita al cerrar).
   · foto actual = round(scrollLeft / ancho de la primera foto) → barra de progreso móvil (--fill), aria-hidden/tabindex de cada foto
   · flechas = CarouselControl previous/next (deshabilitadas en los extremos)
   · clic en una foto (solo escritorio: en móvil el CSS le quita los eventos) abre el popup en esa foto
   · popup: flechas y ← → mueven; miniaturas van a su foto; clic en la foto actual alterna zoom (data-zoomed), en otra foto va a ella
   · en táctil, a los 2 s la galería «asoma» la segunda foto (15 % del ancho, ida 200 ms / espera 600 ms / vuelta 200 ms) y repite una vez a los 3,5 s; tocar la corta */
{
  DMES.on('[data-dm-gallery]', g => {
    const root = $('.es-pdp-gallery__carousel', g); if (!root) return;
    const c = DMES.carousel(root), slides = c.items(), n = slides.length;
    const ind = $('.es-pdp-gallery__indicators', g);
    const prev = $(':scope > .es-pdp-gallery__arrow[data-direction="prev"]', g), next = $(':scope > .es-pdp-gallery__arrow[data-direction="next"]', g);
    const popup = document.getElementById('pdp-gallery-popup'), tpl = popup && $('template[data-dm-gallery-popup]', popup);
    let index = 0, nudging = false;

    const render = () => {
      if (ind) ind.style.setProperty('--fill', `${((index + 1) / n) * 100}%`);
      slides.forEach((s, i) => {
        const b = s.firstElementChild; if (!b) return;
        b.setAttribute('aria-hidden', String(i !== index));
        if (i === index) b.removeAttribute('tabindex'); else b.setAttribute('tabindex', '-1');
      });
    };
    root.addEventListener('scroll', () => {
      if (nudging) return;
      const w = (root.firstElementChild && root.firstElementChild.offsetWidth) || root.offsetWidth; if (!w) return;
      const l = Math.round(root.scrollLeft / w);
      if (l !== index) { index = l; render(); }
    }, { passive: true });
    if (prev) prev.addEventListener('click', () => c.previous());
    if (next) next.addEventListener('click', () => c.next());
    c.subscribe(() => { if (prev) prev.disabled = !c.canMove('previous'); if (next) next.disabled = !c.canMove('next'); });

    /* popup */
    let zoomed = false, pc = null, off = [];
    const close = () => {
      off.forEach(f => f()); off = []; zoomed = false; pc = null;
      if (popup) { popup.removeAttribute('data-zoomed'); [...popup.children].forEach(e => { if (e !== tpl) e.remove(); }); }
    };
    const open = i => {
      if (!popup || !tpl) return;
      close(); index = i; render();
      popup.append(tpl.content.cloneNode(true));
      const proot = $('.es-pdp-gallery__popupCarousel', popup); pc = DMES.carousel(proot);
      const pprev = $('.es-pdp-gallery__arrow[data-direction="prev"]', popup), pnext = $('.es-pdp-gallery__arrow[data-direction="next"]', popup);
      const thumbs = $$('.es-pdp-gallery__thumbnail', popup), zooms = $$('.es-pdp-gallery__popupZoomButton', popup);
      const sync = () => {
        const x = pc.activeIndex;
        if (pprev) pprev.disabled = x === 0;
        if (pnext) pnext.disabled = x === n - 1;
        thumbs.forEach((t, k) => t.setAttribute('data-active', String(k === x)));
      };
      off.push(pc.subscribe(sync));
      if (pprev) pprev.addEventListener('click', () => pc.previous());
      if (pnext) pnext.addEventListener('click', () => pc.next());
      thumbs.forEach((t, k) => t.addEventListener('click', () => pc.goTo(k)));
      zooms.forEach((z, k) => z.addEventListener('click', () => {
        if (k !== pc.activeIndex) { pc.goTo(k); return; }
        zoomed = !zoomed;
        if (zoomed) popup.setAttribute('data-zoomed', 'true'); else popup.removeAttribute('data-zoomed');
        zooms.forEach(b => b.setAttribute('aria-label', zoomed ? tpl.dataset.dmZoomOut : tpl.dataset.dmZoomIn));
      }));
      const key = e => {
        if (e.key === 'ArrowLeft') { e.preventDefault(); if (pc.activeIndex > 0) pc.previous(); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); if (pc.activeIndex < n - 1) pc.next(); }
      };
      document.addEventListener('keydown', key); off.push(() => document.removeEventListener('keydown', key));
      popup.showModal();
      requestAnimationFrame(() => { proot.scrollTo({ left: index * proot.clientWidth, behavior: 'instant' }); });
    };
    slides.forEach((s, i) => { const b = s.firstElementChild; if (b) b.addEventListener('click', () => open(i)); });
    if (popup) popup.addEventListener('close', close);

    /* «asomo» en táctil */
    if (n > 1 && mq('(hover: none) and (pointer: coarse)')) {
      let timer = null, tw = null, runs = 0;
      const stop = () => {
        clearTimeout(timer);
        if (!nudging) return;
        nudging = false; if (tw) tw.kill();
        root.scrollTo({ left: 0, behavior: 'instant' }); root.style.scrollSnapType = '';
      };
      const set = v => root.scrollTo({ left: v, behavior: 'instant' });
      const run = () => {
        runs++; nudging = true; root.style.scrollSnapType = 'none';
        tw = DMES.tween({ from: 0, to: 0.15 * root.offsetWidth, ms: 200, ease: DMES.ease.regular, onUpdate: set, onComplete: () => {
          timer = setTimeout(() => {
            tw = DMES.tween({ from: root.scrollLeft, to: 0, ms: 200, ease: DMES.ease.exit, onUpdate: set, onComplete: () => {
              root.style.scrollSnapType = ''; nudging = false;
              if (runs < 2) timer = setTimeout(run, 3500);
            } });
          }, 600);
        } });
      };
      timer = setTimeout(run, 2000);
      root.addEventListener('touchstart', stop, { passive: true });
    }
    render();
  });
}

/* ═══ 72-pdp-buy.js ═══ */
/* ───────── zona de compra del PDP: FACHADA sobre el formulario de Horizon ─────────
   La interfaz es la de España (ProductDetailPage eK, selector de talla el, panel L = SizeSelectorPanelContent, botones ed / AddToCartSubmitButton,
   SizeGuideTable, js 1jm4nhu… y 3mzpabyumw4i9…); el carrito lo sigue haciendo Horizon. Esta pieza traduce de una a otro:
     elegir talla (panel o fila de la guía)  →  clic REAL en el radio de esa talla del <variant-picker> de Horizon (dispara change: precio, ?variant=,
                                               rr-variant-guard, CTA del fix CRO, product-form, inventario, Klaviyo «avísame»)
     «Añadir al carrito»                     →  clic REAL en button[name=add] del product-form de Horizon (submit → /cart/add → cart:update → panel «Añadido al carrito» de España, es/js/81-upsell-panel.js; el cajón de Horizon ya no se abre)
     talla agotada · «Avísame»               →  abre el bloque local de Klaviyo «avísame» (klaviyo-back-in-stock) de esa variante
   Estado visible igual que React: rótulo «Talla 42», data-selected de cada celda, input[name=size], fila resaltada de la guía, pie de los paneles
   (pocas unidades / agotado / avísame / falta talla), data-loading y texto de los botones (añadiendo… / añadido 3 s con el check), barra fija
   (data-visible cuando el bloque de botones sale de pantalla) y mensajes bajo el botón que rotan cada 3 s.
   Si la sección de Horizon no está o trae más de una opción además del color, no se arriesga: body.dm-pdp-native muestra el selector nativo. */
{
  const ADDED_MS = 3000;                         // ADD_TO_CART_CONFIRMATION_MS
  DMES.on('[data-dm-pdp-root]', root => {
    const form = $('[data-dm-pdp-form]', root); if (!form) return;
    let L = {}; try { L = JSON.parse(($('[data-dm-pdp-labels]', root.parentNode) || {}).textContent || '{}'); } catch (e) {}
    const soldOut = root.dataset.dmSoldOut === 'true';
    const tpl = k => { const t = $(`template[data-dm-tpl="${k}"]`, form); return t ? t.content.firstElementChild.cloneNode(true) : null; };
    const sizeDialog = document.getElementById('select-size-dialog'), guideDialog = document.getElementById('size-guide');
    const cells = () => $$('[data-dm-sizes] [data-dm-size]', form);
    const hasSizes = !!$('input[name="size"]', form);

    /* ── motor de Horizon (se vuelve a buscar cada vez: Horizon re-renderiza su selector) ── */
    const hSection = () => { const f = document.querySelector('#MainContent product-form-component'); return f ? f.closest('.shopify-section') : null; };
    const hPicker = () => { const s = hSection(); return s ? s.querySelector('variant-picker') : null; };
    const hSizeFs = () => { const p = hPicker(); if (!p) return null; const fs = [...p.querySelectorAll('fieldset.variant-option:not(.variant-option--swatches)')]; return fs[fs.length - 1] || null; };
    const hRadios = () => { const fs = hSizeFs(); return fs ? [...fs.querySelectorAll('input[type="radio"][data-option-value-id]')] : []; };
    const hRadio = v => hRadios().find(r => r.value === v) || null;
    const hAdd = () => { const s = hSection(); return s ? s.querySelector('product-form-component button[name="add"]') : null; };
    const hBis = () => { const s = hSection(); return s ? s.querySelector('klaviyo-back-in-stock') : null; };

    const native = () => { document.body.classList.add('dm-pdp-native'); form.hidden = true; };
    if (!hSection()) { native(); return; }
    { const p = hPicker(); if (p && p.querySelectorAll('fieldset.variant-option:not(.variant-option--swatches)').length > 1) { native(); return; } }

    /* ── estado ── */
    const st = { size: null, loading: false, added: false, error: '', needSize: false };
    const cellOf = v => cells().find(c => c.dataset.dmSize === v) || null;
    const info = v => {
      const c = cellOf(v), r = hRadio(v);
      const available = c ? c.dataset.unavailable !== 'true' : (r ? r.dataset.optionAvailable !== 'false' : true);
      return { available, low: !!c && available && c.dataset.dmLow === 'true' };
    };
    const cur = () => (st.size ? info(st.size) : null);
    const panelAdd = $('[data-dm-add="panel"]', form);
    // data-dm-auto-add, como on.cl: tocar una talla disponible ya agrega y abre «Añadido al carrito»; el panel de tallas queda sin botón propio
    const autoAdd = form.hasAttribute('data-dm-auto-add');
    if (autoAdd && panelAdd) panelAdd.remove();

    /* ── pintar ── */
    const addButtons = () => $$('[data-dm-add]', root);
    const setLabel = (btn, text) => {
      const slot = $('[data-dm-add-label]', btn) || $('.es-add-to-cart-submit-button__appearance', btn); if (!slot) return;
      const node = [...slot.childNodes].find(x => x.nodeType === 3);
      if (node) { if (node.nodeValue !== text) node.nodeValue = text; } else slot.prepend(document.createTextNode(text));
    };
    const errorSlot = (btn, cls, show) => {
      let p = btn.nextElementSibling && btn.nextElementSibling.matches('.es-add-to-cart-submit-button__error') ? btn.nextElementSibling : null;
      if (!st.error || !show) { if (p) p.remove(); return; }
      if (!p) { p = tpl('error'); if (!p) return; if (cls) p.classList.add(cls); btn.after(p); }
      if (p.textContent !== st.error) p.textContent = st.error;
    };
    const paint = () => {
      const c = cur(), out = !!c && !c.available, low = !!c && c.low;
      // botón «Selecciona la talla» / «Talla 42» (+ pocas unidades)
      const lab = $('[data-dm-size-label]', form);
      if (lab) {
        const text = st.size ? (lab.dataset.dmSelected || '').replace('[talla]', st.size) : lab.dataset.dmEmpty;
        const node = [...lab.childNodes].find(x => x.nodeType === 3);
        if (node) { if (node.nodeValue !== text) node.nodeValue = text; } else lab.prepend(document.createTextNode(text));
        const msg = $('.es-size-stock-message__message', lab);
        if (low && !msg) { const m = tpl('low'); if (m) lab.append(m); } else if (!low && msg) msg.remove();
      }
      // celdas del panel
      cells().forEach(cell => {
        const on = cell.dataset.dmSize === st.size, input = $('input', cell);
        cell.dataset.selected = String(on); if (input) input.checked = on;
        const showLow = on && cell.dataset.dmLow === 'true' && cell.dataset.unavailable !== 'true';
        cell.dataset.lowStock = String(showLow);
        const icon = $('.es-selector__cellIcon', cell), bell = cell.dataset.unavailable === 'true';
        if (!bell) { if (showLow && !icon) { const m = tpl('cell-low'); if (m) input.after(m); } else if (!showLow && icon) icon.remove(); }
      });
      const hidden = $('input[name="size"]', form); if (hidden) hidden.value = st.size || '';
      // guía de tallas: fila resaltada y pie con el botón cuando hay talla
      if (guideDialog) {
        $$('tr[data-dm-row]', guideDialog).forEach(tr => tr.setAttribute('data-highlighted', String(tr.dataset.dmRow === st.size)));
        const content = $('.es-panel__content', guideDialog), ft = $(':scope > footer', content), t = $('template[data-dm-guide-footer]', guideDialog);
        if (st.size && !ft && t) content.append(t.content.firstElementChild.cloneNode(true));
        else if (!st.size && ft) ft.remove();
        const gf = $(':scope > footer', content);
        if (gf) {
          if (!gf.__dmAdd) gf.__dmAdd = $('[data-dm-add]', gf);
          const nb = $('[data-dm-notify]', gf);
          if (out) { gf.__dmAdd.remove(); if (!nb) { const b = tpl('notify'); if (b) { b.removeAttribute('class'); gf.append(b); } } }
          else { if (nb) nb.remove(); if (!gf.__dmAdd.isConnected) gf.append(gf.__dmAdd); }
        }
      }
      // pie del panel de tallas: mensajes + botón
      const fa = $('[data-dm-size-footer]', form);
      if (fa) {
        const footer = fa.parentNode;
        $$(':scope > .es-size-selector-panel__footerMessage', footer).forEach(e => e.remove());
        if (low) { const m = tpl('footer-low'); if (m) fa.before(m); }
        if (out) { const m = tpl('footer-out'); if (m) fa.before(m); }
        const nb = $('[data-dm-notify]', fa), err = $('.es-size-selector-panel__sizeRequiredError', fa);
        if (out) { if (panelAdd) { errorSlot(panelAdd, '', false); panelAdd.remove(); } if (!nb) { const b = tpl('notify'); if (b) fa.prepend(b); } }
        else { if (nb) nb.remove(); if (panelAdd && !autoAdd && !panelAdd.isConnected) fa.prepend(panelAdd); }
        const showErr = st.needSize && !st.size && !out;
        if (showErr && !err) { const p = tpl('size-error'); if (p) fa.append(p); } else if (!showErr && err) err.remove();
      }
      // botones de compra
      addButtons().forEach(btn => {
        const where = btn.dataset.dmAdd;
        const base = (where === 'main' || where === 'sticky') ? (out || soldOut ? L.notify : L.add) : (soldOut ? L.notify : L.add);
        // barra fija con precio (lo pone el Liquid en data-dm-price; sin el atributo queda el texto solo)
        const rest = where === 'sticky' && base === L.add && btn.dataset.dmPrice ? `${base} · ${btn.dataset.dmPrice}` : base;
        setLabel(btn, st.loading ? L.adding : (st.added && where !== 'panel' ? L.added : rest));
        btn.dataset.loading = String(st.loading); btn.disabled = st.loading;
        const check = $('.es-add-to-cart-submit-button__checkIcon', btn);
        if (check) { if (st.added) check.setAttribute('data-added', 'true'); else check.removeAttribute('data-added'); }
      });
      const main = $('[data-dm-add="main"]', root), sticky = $('[data-dm-add="sticky"]', root);
      const stickyOn = $('[data-dm-sticky]', root) && $('[data-dm-sticky]', root).dataset.visible === 'true';
      if (main) errorSlot(main, 'es-product-purchase-actions__bagError', !stickyOn);
      if (sticky) errorSlot(sticky, 'es-product-detail__stickyAddToBagError', !!stickyOn);
      if (panelAdd && panelAdd.isConnected) errorSlot(panelAdd, 'es-size-selector-panel__addToCartError', true);
      // «Agotado» bajo los botones
      const actions = $('[data-dm-actions]', form);
      if (actions) {
        const p = $(':scope > .es-product-detail__unavailableMessage', actions), need = out || soldOut;
        if (need && !p) { const m = tpl('unavailable'); if (m) actions.append(m); } else if (!need && p) p.remove();
      }
      // pago exprés de Shopify en la ficha (hoy solo México: Apple Pay / Google Pay del bloque de Horizon, que sigue el radio de talla real).
      // Se muestra recién con una talla ELEGIDA y disponible (es/glue.d/compra-movil.css): antes compraría la talla que Horizon trae por defecto.
      // Solo la ficha de la página (no la de un «agregar rápido» dentro de un diálogo). Pedido del user, 17-oct-2026.
      if (!root.closest('dialog')) document.body.classList.toggle('dm-size-chosen', !!c && c.available && !soldOut);
    };

    /* ── elegir talla = clic real en el radio de Horizon ── */
    const choose = v => {
      st.needSize = false; st.error = ''; st.size = v;
      const r = hRadio(v);
      if (r && !r.checked) r.click();
      paint();
    };
    // Se elige con el clic (ratón, toque o teclado sobre la casilla) y se cancela el cambio nativo de la casilla: así este formulario de fachada no emite
    // «change» y la analítica de formularios (GTM / GA4 form_start) sigue viendo solo el formulario real de Horizon, como hasta ahora.
    form.addEventListener('click', e => {
      const cell = e.target.closest && e.target.closest('[data-dm-sizes] [data-dm-size]'); if (!cell) return;
      e.preventDefault();
      choose(cell.dataset.dmSize);
      setTimeout(paint, 0);            // el navegador repone la casilla al cancelar el clic: se vuelve a pintar el estado
      if (!autoAdd) return;
      const c = cur(); if (c && c.available) submit();      // talla agotada: el panel se queda con «Avísame»
    });
    if (guideDialog) {
      const pick = tr => { if (tr && tr.dataset.dmRow && tr.dataset.clickable === 'true') choose(tr.dataset.dmRow); };
      guideDialog.addEventListener('click', e => pick(e.target.closest('tr[data-dm-row]')));
      guideDialog.addEventListener('keydown', e => {
        const tr = e.target.closest && e.target.closest('tr[data-dm-row]');
        if (tr && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); pick(tr); }
      });
      // cm / in (ContentContainerSwitchAppearance)
      const sw = $('[data-dm-unit-switch]', guideDialog);
      if (sw) {
        const [bCm, bIn] = $$('.es-switch__label', sw), chk = $('.es-toggle__input', sw);
        const unit = on => {
          chk.checked = on; bCm.dataset.active = String(!on); bIn.dataset.active = String(on);
          $$('td[data-dm-cm]', guideDialog).forEach(td => { td.textContent = on ? td.dataset.dmIn : td.dataset.dmCm; });
        };
        bCm.addEventListener('click', () => unit(false)); bIn.addEventListener('click', () => unit(true));
        chk.addEventListener('change', () => unit(chk.checked));
      }
    }

    /* ── «avísame»: bloque local de Klaviyo ── */
    const notify = () => {
      DMES.dialog.closeAll();
      const b = hBis(); if (!b) return;
      b.removeAttribute('hidden');
      setTimeout(() => {
        const t = b.querySelector('[data-bis-action="open"]'), panel = b.querySelector('.klaviyo-bis__panel');
        if (t && panel && panel.hasAttribute('hidden')) t.click();
        b.scrollIntoView({ block: 'center', behavior: reduced() ? 'auto' : 'smooth' });
        const input = b.querySelector('input[type="email"]'); if (input) setTimeout(() => input.focus({ preventScroll: true }), 400);
      }, 60);
    };

    /* ── añadir = clic real en el botón de Horizon ── */
    let waitT = null, addedT = null;
    const settle = (ok, message) => {
      clearTimeout(waitT); if (!st.loading) return;
      st.loading = false;
      if (ok) {
        st.added = true; st.error = '';
        clearTimeout(addedT); addedT = setTimeout(() => { st.added = false; paint(); }, ADDED_MS);
      } else st.error = message || L.error || '';
      paint();
    };
    const submit = () => {
      if (st.loading) return;
      const go = tries => {
        const btn = hAdd(); if (!btn) { settle(false); return; }
        if (hasSizes && st.size) { const r = hRadio(st.size); if (r && !r.checked) r.click(); }
        if (btn.disabled && tries > 0) { waitT = setTimeout(() => go(tries - 1), 60); return; }   // Horizon lo deshabilita un instante mientras resuelve la variante
        if (btn.disabled) { settle(false); return; }
        btn.click();
        waitT = setTimeout(() => settle(false), 12000);
      };
      st.loading = true; st.error = ''; st.added = false; paint();
      // los paneles de España se cierran ANTES de pedir el alta (España hace closeAllDialogs al agregar): al terminar se abre el panel «Añadido al carrito»
      const anyOpen = $$('.es dialog[open]').length > 0;
      if (anyOpen) DMES.dialog.closeAll();
      waitT = setTimeout(() => go(40), anyOpen ? 60 : 0);
    };
    document.addEventListener('cart:update', e => {
      const d = (e.detail && e.detail.data) || {};
      if (!st.loading || d.source !== 'product-form-component') return;
      if (d.didError) { const m = hSection() && hSection().querySelector('.product-form-text__error:not(.hidden)'); settle(false, m ? m.textContent.trim() : ''); }
      else settle(true);
    });
    document.addEventListener('cart:error', e => { if (st.loading) settle(false, (e.detail && e.detail.data && e.detail.data.message) || ''); });
    // avisos del guard de variantes (se escriben dentro del selector oculto): se muestran bajo el botón
    new MutationObserver(() => {
      const s = hSection(), m = s && s.querySelector('.rr-variant-guard-msg');
      const text = m ? m.textContent.trim() : '';
      if (text && st.loading) settle(false, text);
      else if (text && text !== st.error) { st.error = text; paint(); }
    }).observe(hSection(), { childList: true, subtree: true });

    const openSizes = () => { if (sizeDialog) DMES.dialog.show(sizeDialog); };
    root.addEventListener('click', e => {
      const nb = e.target.closest('[data-dm-notify]'); if (nb) { e.preventDefault(); notify(); return; }
      const btn = e.target.closest('[data-dm-add]'); if (!btn) return;
      e.preventDefault();
      const where = btn.dataset.dmAdd, c = cur();
      if (where === 'panel') { if (!st.size) { st.needSize = true; paint(); return; } submit(); return; }
      if (where === 'guide') { submit(); return; }
      if (c && !c.available) { notify(); return; }
      if (!hasSizes || st.size) { submit(); return; }
      openSizes();
    });
    form.addEventListener('submit', e => e.preventDefault());

    /* ── precio y disponibilidad cuando Horizon resuelve la variante (trae la página ya renderizada para esa talla) ── */
    document.addEventListener('variant:update', e => {
      const html = e.detail && e.detail.data && e.detail.data.html; if (!html || !html.querySelector) return;
      const meta = $('.es-product-detail__meta', root), nm = html.querySelector('.es-product-detail__meta');
      if (meta && nm) {
        $$(':scope > .es-product-detail__price, :scope > .es-product-detail__discountedPrice', meta).forEach(x => x.remove());
        nm.querySelectorAll(':scope > .es-product-detail__price, :scope > .es-product-detail__discountedPrice').forEach(x => meta.append(document.importNode(x, true)));
      }
      html.querySelectorAll('[data-dm-sizes] [data-dm-size]').forEach(nc => {
        const c = cellOf(nc.dataset.dmSize); if (!c) return;
        if (c.dataset.unavailable !== nc.dataset.unavailable) {
          c.dataset.unavailable = nc.dataset.unavailable;
          const icon = $('.es-selector__cellIcon', c); if (icon) icon.remove();
          const ni = nc.querySelector('.es-selector__cellIcon'); if (ni) $('input', c).after(document.importNode(ni, true));
        }
        c.dataset.dmLow = nc.dataset.dmLow; c.dataset.dmVariantId = nc.dataset.dmVariantId;
        ['hasAvailableRight', 'hasAvailableBottom'].forEach(k => { if (nc.dataset[k]) c.dataset[k] = nc.dataset[k]; else delete c.dataset[k]; });
      });
      paint();
    });

    /* ── barra fija: visible mientras el botón principal no se ve ENTERO. En celular el borde de abajo es la barra de navegación fija
       (.es-nav-bar-mobile__nav, 56 px): un botón que queda detrás no se puede tocar, así que el observador descuenta su alto (rootMargin
       inferior negativo; 0 en escritorio, donde la barra no se muestra). Antes (umbral 0 sobre todo el bloque de botones) bastaba que asomara
       1 px del bloque para ocultar la fija y quedaban tramos sin ningún botón de compra a la vista (QA de compra en celular, 17-oct-2026). ── */
    const sticky = $('[data-dm-sticky]', root), actions = $('[data-dm-actions]', form);
    if (sticky && actions) {
      const set = v => { if (sticky.dataset.visible !== String(v)) { sticky.dataset.visible = String(v); paint(); } };
      const target = $('[data-dm-add="main"]', actions) || actions;
      const covered = () => {
        const n = document.querySelector('.es-nav-bar-mobile__nav'); if (!n) return 0;
        const r = n.getBoundingClientRect();
        return r.height > 0 && r.top < window.innerHeight ? Math.max(0, Math.round(window.innerHeight - r.top)) : 0;
      };
      { const r = target.getBoundingClientRect(); set(!(r.height > 0 && r.top >= 0 && r.bottom <= window.innerHeight - covered())); }
      let io = null, inset = -1;
      const watch = () => {
        const i = covered(); if (i === inset) return; inset = i;
        if (io) io.disconnect();
        io = new IntersectionObserver(([en]) => set(!(en && en.isIntersecting && en.intersectionRatio > 0.98)), { rootMargin: `0px 0px -${i}px 0px`, threshold: [0, 0.99, 1] });
        io.observe(target);
      };
      watch();
      window.addEventListener('resize', watch, { passive: true });
      window.addEventListener('load', watch, { once: true });
      window.addEventListener('scroll', watch, { passive: true, once: true });
    }

    /* ── mensajes bajo el botón (trustBadge): avanza cada 3 s, 500 ms de transición, vuelve al inicio sin transición; se detiene con mouse/foco/dedo encima ── */
    const badge = $('[data-dm-trust]', form);
    if (badge) {
      const track = badge.firstElementChild, count = Number(badge.dataset.dmTrust) || 0;
      if (count > 1 && track) {
        let j = 0, anim = true, hover = false, t1 = null, t2 = null;
        const draw = () => { track.style.transform = `translateY(-${2.75 * j}rem)`; track.style.transitionDuration = anim ? '500ms' : '0ms'; };
        const plan = () => {
          clearTimeout(t1); clearTimeout(t2);
          if (!hover) t1 = setTimeout(() => { anim = true; j += 1; draw(); plan(); }, 3000);
          if (j === count) t2 = setTimeout(() => { anim = false; j = 0; draw(); plan(); }, reduced() ? 0 : 500);
        };
        const pause = v => { hover = v; plan(); };
        badge.addEventListener('mouseenter', () => pause(true)); badge.addEventListener('mouseleave', () => pause(false));
        badge.addEventListener('focusin', () => pause(true));
        badge.addEventListener('focusout', e => { if (!badge.contains(e.relatedTarget)) pause(false); });
        badge.addEventListener('pointerdown', e => { if (e.pointerType === 'touch') pause(true); });
        badge.addEventListener('pointerup', e => { if (e.pointerType === 'touch') pause(false); });
        badge.addEventListener('pointercancel', e => { if (e.pointerType === 'touch') pause(false); });
        [...track.children].slice(0, count).forEach((it, k) => it.addEventListener('focus', () => { anim = false; j = k; draw(); }));
        track.addEventListener('transitionend', () => { if (j === count) { anim = false; draw(); } });
        anim = true; draw(); plan();
      }
    }

    /* ── colores: el seleccionado queda a la vista dentro de su carrusel (efecto de ProductVariantSelector) ── */
    const vroot = $('[data-dm-variants] .es-product-variant-selector__carousel', root);
    if (vroot) {
      DMES.carousel(vroot);
      const sel = $('[data-selected="true"]', vroot);
      if (sel) {
        const t = vroot.getBoundingClientRect().width, a = sel.getBoundingClientRect().width, s = (sel.offsetLeft || 0) + a;
        if (s >= t) vroot.scrollTo({ left: s - t + a / 2, behavior: 'instant' });
      }
    }

    /* ── arranque ── */
    if (root.dataset.dmSingleSize === 'true') {       // talla única: queda elegida (España: K → U = X[0].value)
      const boot = n => { const r = hRadios()[0]; if (r) { st.size = r.value; if (!r.checked) r.click(); paint(); } else if (n > 0) setTimeout(() => boot(n - 1), 150); };
      setTimeout(() => boot(20), 700);                // después del «desmarcar» inicial del fix CRO
    }
    window.addEventListener('pageshow', e => { if (e.persisted) { st.loading = false; paint(); } });
    paint();
    DMES.pdp = { state: st, choose, submit, paint, openSizes };
  });
}

/* ═══ 73-pdp-info.js ═══ */
/* ───────── PDP: descripción, filas de información, panel de contenido, tiles de material, migas ─────────
   · «Leer más» = ProductDescription de España (js 23dntvkle44pu…): el botón solo existe si el texto recortado desborda (>4 px); al abrir pone
     data-expanded="true" y anima la altura con la línea de tiempo escalonada (paso = máx(15 % del tramo, alto de línea, 2 px), 10 ms + 60 ms).
   · Filas (ProductInfoPanels, js 3mzpabyumw4i9…): abren dialog#content-panel. España pide el contenido al CMS; acá sale de los <template data-dm-panel-tpl>
     que deja la sección (nuestros textos). Al abrir se arma <article> (título + cuerpo) dentro del panel y al cerrar se quita, como allá.
     El diálogo se mueve a <body> al iniciar (en España es un portal hijo de body).
   · Panel sobre panel (PanelControls): aparece «atrás» (cierra solo el de encima) y la X cierra todos.
   · Reseñas y calce ([data-dm-reviews-open]): España abre el panel de Yotpo; acá baja al bloque de Klaviyo Reviews de la página.
   · Tiles de material (función eB): --thumbnail-activeness = 1 − |avance del scroll − posición del tile| cuando el par se puede deslizar (móvil).
   · Migas: si la ruta no salió del menú, usa la última colección visitada (localStorage «seo_breadcrumb_last_collection», máx. 1 h), igual que Horizon. */
{
  /* leer más */
  DMES.on('[data-dm-readmore]', btn => {
    const block = btn.parentNode, el = block.querySelector('[data-dm-desc]'), label = btn.firstElementChild; if (!el) return;
    let open = false, collapsed = 0, line = 0, tl = null, lock = false;
    const measure = () => {
      if (lock || el.dataset.animating) return;
      const need = el.scrollHeight - el.clientHeight > 4;          // España no dibuja el botón si el texto entra completo
      if (need && !btn.isConnected) block.append(btn); else if (!need && btn.isConnected) btn.remove();
      collapsed = el.clientHeight; line = Number.parseFloat(getComputedStyle(el).lineHeight) || 0;
    };
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
    new ResizeObserver(measure).observe(el);
    btn.addEventListener('click', () => {
      open = !open; lock = open;
      if (open) el.setAttribute('data-expanded', 'true'); else el.removeAttribute('data-expanded');
      btn.setAttribute('aria-expanded', String(open));
      if (label) label.textContent = open ? btn.dataset.dmLess : btn.dataset.dmMore;
      if (reduced()) return;
      const was = !!tl, h0 = was ? el.getBoundingClientRect().height : 0;
      if (tl) tl.kill();
      const i = collapsed || el.clientHeight;
      el.dataset.animating = 'true';
      const a = el.scrollHeight, r = Math.max(a - i, 0), end = open ? a : i;
      if (r === 0) { el.style.removeProperty('height'); delete el.dataset.animating; tl = null; return; }
      const start = was ? h0 : (open ? i : a);
      el.style.height = `${start}px`;
      tl = DMES.stepped({ el, start, end, stepPx: Math.max(0.15 * r, line || r, 2), moveMs: DMES.MOVE_MS, pauseMs: DMES.PAUSE_MS, vars: v => ({ height: `${v}px` }),
        onComplete: () => { el.style.removeProperty('height'); delete el.dataset.animating; tl = null; } });
    });
    measure();
  });

  /* panel de contenido */
  DMES.on('dialog[data-dm-content-panel]', panel => {
    // España monta #content-panel como hijo directo de <body> (portal), FUERA del contenedor de contenido: por eso los bloques de adentro no responden a las
    // container queries del ancho de página (quedan con su estilo base, de panel angosto). Acá la sección lo trae dentro de <main>; se lleva a <body> igual que allá.
    let host = document.querySelector('body > .es[data-dm-pdp-portal]');
    if (!host) { host = document.createElement('div'); host.className = 'es'; host.setAttribute('data-dm-pdp-portal', ''); document.body.append(host); }
    $$('dialog[data-dm-content-panel]', host).forEach(d => { if (d !== panel) d.remove(); });
    if (panel.parentNode !== host) host.append(panel);
    const content = $('.es-panel__content', panel), art = () => $(':scope > article', content);
    let clearT = null;
    const fill = key => {
      const t = document.querySelector(`template[data-dm-panel-tpl="${key}"]`), a = document.querySelector('template[data-dm-panel-article]');
      if (!t || !a) return false;
      clearTimeout(clearT); if (art()) art().remove();
      const node = a.content.firstElementChild.cloneNode(true);
      $('.es-panel-header__title', node).textContent = t.dataset.dmTitle || '';
      $('[data-panel-content-container]', node).append(t.content.cloneNode(true));
      content.append(node);
      return true;
    };
    // antes que el disparador común (commandfor) abra el diálogo: así el título ya existe y recibe el foco
    window.addEventListener('click', e => {
      const b = e.target.closest && e.target.closest('[data-dm-panel]'); if (!b || b.classList.contains('es-menu__panel')) return; /* 2-nov-2026: los paneles del menú del celular (15-nav.js) también llevan data-dm-panel; sin esta exclusión, en la ficha se cancelaban todos los toques del menú */
      const ok = fill(b.dataset.dmPanel);
      if (b.tagName === 'A') { e.preventDefault(); if (ok) DMES.dialog.show(panel); }
      else if (!ok) { e.preventDefault(); e.stopPropagation(); }
    }, true);
    panel.addEventListener('close', () => { clearTimeout(clearT); clearT = setTimeout(() => { if (!panel.open && art()) art().remove(); }, 900); });
  });

  /* panel sobre panel: «atrás» + la X cierra todos. Solo en los paneles de la ficha (talla, guía de tallas, contenido): los demás son de otros módulos */
  const PDP_PANELS = ['select-size-dialog', 'size-guide', 'content-panel'];
  document.addEventListener('dm:dialog', e => {
    const d = e.target; if (!(d instanceof HTMLDialogElement) || !PDP_PANELS.includes(d.id) || !$('[data-panel-appearance]', d)) return;
    const controls = $('.es-panel-controls__controls', d), header = $('.es-panel-header__container', d); if (!controls) return;
    const back = $('[data-control="back"]', controls);
    if (e.detail && e.detail.open) {
      const nested = $$('.es dialog[open]').some(o => o !== d && $('[data-panel-appearance]', o));
      const t = document.querySelector('template[data-dm-panel-back]');
      if (nested && !back && t) { const b = t.content.firstElementChild.cloneNode(true); b.setAttribute('commandfor', d.id); controls.prepend(b); if (header) header.dataset.hasBackButton = 'true'; }
    } else if (back) { back.remove(); if (header) header.dataset.hasBackButton = 'false'; }
  });
  document.addEventListener('click', e => {
    const x = e.target.closest && e.target.closest('.es dialog [data-control="close"]'); if (!x) return;
    const d = x.closest('dialog');
    if (d && PDP_PANELS.includes(d.id) && $$('.es dialog[open]').length > 1) DMES.dialog.closeAll();
  });

  /* reseñas / calce → bloque de Klaviyo Reviews */
  document.addEventListener('click', e => {
    const b = e.target.closest && e.target.closest('[data-dm-reviews-open]'); if (!b) return;
    const target = document.getElementById('fulfilled-reviews-all') || document.querySelector('[id*="klaviyo_reviews_product_reviews"], .klaviyo-reviews, [id*="product_reviews"]');
    if (!target) return;
    e.preventDefault(); DMES.dialog.closeAll();
    setTimeout(() => target.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'start' }), 60);
  });

  /* tiles de material */
  DMES.on('[data-dm-thumbs]', pair => {
    DMES.carousel(pair);
    const items = [...pair.children];
    const draw = () => {
      const max = pair.scrollWidth - pair.clientWidth, can = pair.scrollWidth > pair.clientWidth + 1, o = max > 0 ? pair.scrollLeft / max : 0;
      items.forEach((it, t) => { const th = it.firstElementChild; if (th) th.style.setProperty('--thumbnail-activeness', can && items.length > 1 ? 1 - Math.abs(o - t / (items.length - 1)) : 1); });
    };
    pair.addEventListener('scroll', draw, { passive: true });
    new ResizeObserver(draw).observe(pair);
    draw();
  });

  /* migas: última colección visitada cuando la ruta no salió del menú */
  DMES.on('a[data-dm-crumb-dynamic]', a => {
    let data = {}; try { data = JSON.parse(localStorage.getItem('seo_breadcrumb_last_collection') || '{}'); } catch (e) { return; }
    const fresh = data.timestamp && Date.now() - data.timestamp < 3600000;
    if (!fresh || !data.url || data.url === '/collections/all' || data.url.indexOf('/collections/') !== 0 || !data.title) return;
    const li = a.closest('li');
    (data.path || []).forEach(level => {
      if (!level || !level.url || !level.title) return;
      const n = li.cloneNode(true), l = $('a', n);
      l.removeAttribute('data-dm-crumb-dynamic'); l.setAttribute('href', level.url); l.textContent = level.title;
      if (!$('span', n)) { const s = document.createElement('span'); s.setAttribute('aria-hidden', 'true'); s.textContent = '/'; n.append(s); }
      li.before(n);
    });
    a.setAttribute('href', data.url); a.textContent = data.title;
  });
}

/* ═══ 74-pdp-products.js ═══ */
/* ───────── PDP: «También te puede gustar» (block-products de España con las recomendaciones de Shopify) ─────────
   La página trae solo el marcador [data-dm-recs]; se pide la sección a /recommendations/products (misma fuente que usaba product-recommendations de
   Horizon) cuando el marcador se acerca a la pantalla y se reemplaza por el <section> que devuelve el servidor (marcado de España). */
{
  DMES.on('[data-dm-recs]', slot => {
    const url = slot.dataset.dmUrl; if (!url) return;
    let done = false;
    const load = () => {
      if (done) return; done = true;
      fetch(url).then(r => r.text()).then(t => {
        const doc = new DOMParser().parseFromString(t, 'text/html'), sec = doc.querySelector('[data-dm-recs-loaded]');
        if (!sec) return;
        const node = document.importNode(sec, true); slot.replaceWith(node); DMES.init(node);
      }).catch(() => {});
    };
    if (!('IntersectionObserver' in window)) { load(); return; }
    const io = new IntersectionObserver(en => { if (en.some(x => x.isIntersecting)) { io.disconnect(); load(); } }, { rootMargin: '1200px 0px' });
    io.observe(slot);
  });
}

/* ═══ 80-cart.js ═══ */
/* ───────── página de carrito (CartPage · CartLineItem · CartCostSummary · cupón · CartChangeSizePanel de España) ─────────
   Marcado: sections/dm-cart.liquid + snippets/dm-es-cart-line.liquid. De dónde sale cada parte (referencia_global/live/js_legible):
     1 cantidad / quitar        ← 2ufsafnswg1ev.js · useCart: updateLineQuantity (cambio optimista + espera de 400 ms) y deleteLine (optimista)
                                  24kzvth5hi2vd.js · CartPage: mientras hay una mutación → cartCostSummaryInner[data-loading] y «Finalizar compra»
                                  deja de ser <a> y pasa a <span role="link" aria-disabled="true">
     2 desplegable de cantidad  ← 0jrg4k82j6xzh.js · Dropdown (misma lógica que el de 50-footer.js; con error: data-invalid + p.hint[role=alert])
     3 código promocional       ← 24kzvth5hi2vd.js · componente `F` (botón +/−, formulario, «Aplicando...», «¡Aplicado!», «Este código no es válido»)
                                  sobre los descuentos de Shopify como assets/cart-discount.js de Horizon: POST /cart/update.js { discount: 'A,B' }
     4 «Editar talla»           ← 0q4ogydaqhugq.js · componente `W` (CartChangeSizePanel) + SizeSelectorPanelContent (el panel de tallas del PDP)
     5 contador                 ← 24kzvth5hi2vd.js · CartQuantity
   España guarda el carrito en el cliente (React) y pinta de forma optimista; acá la verdad es el servidor: cada cambio pide de vuelta ESTA sección
   (Section Rendering API, parámetro `sections` de /cart/change.js y /cart/update.js) y se reemplaza solo lo que cambió.
   Avisos al resto del sitio: «cart:update» (document; lo escuchan 15-nav.js para el contador del header y el theme). La analítica de carrito
   (cart_viewed, product_added_to_cart, product_removed_from_cart → gtag/Meta) la emite Shopify al usar /cart/*.js: no depende de este archivo;
   assets/rr-klaviyo-cart-sync.js engancha fetch sobre /cart/(add|change|update) y sigue sincronizando. */
{
  const S = { busy: 0, timers: new Map(), chain: Promise.resolve(), cfg: null, fmtOk: null, last: '' };      // last = último HTML de la sección pintado por el servidor
  const base = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const flag = (el, name, on) => { on ? el.setAttribute(name, 'true') : el.removeAttribute(name); };
  const chunk = h => Math.max(20, Math.ceil(h / 5));
  const esc = s => String(s == null ? '' : s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const pageEl = () => $('[data-dm-cart-page]');
  const tpl = n => { const t = $(`template[data-dm-cart-tpl="${n}"]`); return t ? t.content.firstElementChild.cloneNode(true) : document.createTextNode(''); };
  const cfg = () => {
    if (S.cfg) return S.cfg;
    const c = { moneyFormat: '${{amount}}', t: { one: 'producto en tu carrito.', many: 'productos en tu carrito.', apply: 'Aplicar', applying: 'Aplicando...', applied: '¡Aplicado!', invalid: 'Este código no es válido', shippingCode: '', error: 'No pudimos actualizar el carrito. Inténtalo de nuevo.', sizeTitle: 'Editar talla', sizeSave: 'Guardar cambios', sizeSaving: 'Guardando...', sizeLoad: 'No se pudo cargar el producto. Inténtalo de nuevo más tarde.' } };
    const e = $('script[data-dm-cart-config]');
    if (e) { try { const j = JSON.parse(e.textContent); if (j.moneyFormat) c.moneyFormat = j.moneyFormat; Object.assign(c.t, j.t); } catch (err) { /* quedan los textos por defecto */ } }
    return (S.cfg = c);
  };
  // formato de moneda de la tienda (shop.money_format) para los valores optimistas; si no reproduce lo que pintó Liquid, no se usa
  const money = cents => {
    const v = Math.abs(Math.round(cents));
    const num = (prec, th, dec) => { const [a, b] = (v / 100).toFixed(prec).split('.'); return a.replace(/\B(?=(\d{3})+(?!\d))/g, th) + (b ? dec + b : ''); };
    const map = { amount: () => num(2, ',', '.'), amount_no_decimals: () => num(0, ',', '.'), amount_with_comma_separator: () => num(2, '.', ','), amount_no_decimals_with_comma_separator: () => num(0, '.', ','), amount_with_apostrophe_separator: () => num(2, "'", '.'), amount_no_decimals_with_space_separator: () => num(0, ' ', ','), amount_with_space_separator: () => num(2, ' ', ','), amount_with_period_and_space_separator: () => num(2, ' ', '.') };
    return (cents < 0 ? '-' : '') + cfg().moneyFormat.replace(/<[^>]*>/g, '').replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => (map[k] || map.amount)());
  };
  const fmtOk = () => {
    if (S.fmtOk !== null) return S.fmtOk;
    const p = pageEl(), el = p && $('[data-dm-subtotal-text]', p);
    return (S.fmtOk = !!el && money(Number(p.dataset.dmSubtotal)) === el.textContent.trim());
  };
  const setText = (sel, v, root) => { const e = $(sel, root || pageEl()); if (e && e.textContent !== v) e.textContent = v; };
  const setCount = n => {
    const p = pageEl(); if (!p) return;
    setText('[data-dm-count-n]', String(n), p);
    setText('[data-dm-count-label]', `${n} ${n === 1 ? cfg().t.one : cfg().t.many}`, p);
  };
  const announce = msg => { const st = $('[data-dm-cart-status]'); if (st) st.textContent = msg || ''; };

  /* ── estado «mutando» (CartPage: D = isMutating) ── */
  const applyBusy = () => {
    const p = pageEl(); if (!p) return;
    const inner = $('[data-dm-summary]', p), on = S.busy > 0;
    if (inner) flag(inner, 'data-loading', on);
    const link = $('[data-dm-checkout]', p);
    if (!link) return;
    if (on && link.tagName === 'A') {
      const sp = document.createElement('span');
      sp.className = link.className; sp.setAttribute('role', 'link'); sp.setAttribute('aria-disabled', 'true'); sp.dataset.dmCheckout = ''; sp.dataset.dmHref = link.getAttribute('href');
      sp.append(...link.childNodes); link.replaceWith(sp);
    } else if (!on && link.tagName !== 'A') {
      const a = document.createElement('a');
      a.className = link.className; a.setAttribute('href', link.dataset.dmHref || `${base()}checkout`); a.dataset.dmCheckout = '';
      a.append(...link.childNodes); link.replaceWith(a);
    }
  };

  /* ── pintar con la respuesta del servidor ── */
  const sectionId = () => { const p = pageEl(); return p ? p.dataset.dmSection : ''; };
  const render = html => {
    const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-dm-cart-page]'), page = pageEl();
    if (!fresh || !page) return false;
    const host = page.parentElement, focusId = document.activeElement && page.contains(document.activeElement) ? document.activeElement.id : '';
    const ul = $('[data-dm-lines]', page), ful = $('[data-dm-lines]', fresh);
    if (!ul || !ful) page.replaceWith(fresh);               // pasa a vacío (o deja de estarlo): cambia toda la página
    else {
      for (const k of ['dmCount', 'dmSubtotal', 'dmDiscount']) page.dataset[k] = fresh.dataset[k];
      // líneas: se conserva el nodo si no cambió (mismo data-dm-sig y sin cambios optimistas); si cambió, entra el nuevo con la foto ya cargada
      const old = new Map($$(':scope > li', ul).map(li => [li.dataset.dmItem, li])), next = [];
      for (const li of [...ful.children]) {
        const cur = old.get(li.dataset.dmItem);
        if (cur && cur.querySelector('dialog[open]')) { cur.dataset.dmStale = '1'; next.push(cur); continue; }   // con su panel abierto no se toca; se repinta al cerrar
        if (cur && cur.dataset.dmSig === li.dataset.dmSig && !cur.dataset.dmDirty) { next.push(cur); continue; }
        if (cur) {
          const a = $('.es-cart-line-item__asset', cur), b = $('.es-cart-line-item__asset', li), ia = a && $('img', a), ib = b && $('img', b);
          if (ia && ib && ia.getAttribute('src') === ib.getAttribute('src')) b.replaceWith(a);
        }
        next.push(li);
      }
      let ref = ul.firstElementChild;
      for (const li of next) { if (li === ref) { ref = ref.nextElementSibling; continue; } ul.insertBefore(li, ref); }
      while (ref) { const n = ref.nextElementSibling; ref.remove(); ref = n; }
      // resumen (totales, botón, cuotas, medios de pago)
      const sum = $('[data-dm-summary]', page), fsum = $('[data-dm-summary]', fresh);
      if (sum && fsum) { const open = !!$('details[open]', sum); sum.replaceChildren(...fsum.childNodes); const d = open && $('details', sum); if (d) d.open = true; }
      // códigos aplicados (el botón y el formulario del cupón conservan su estado)
      const w = $('[data-dm-promo]', page), cur = w && $('[data-dm-applied]', w), fa = $('[data-dm-applied]', fresh);
      if (w) { if (cur && fa) cur.replaceWith(fa); else if (cur) cur.remove(); else if (fa) w.append(fa); }
      setCount(Number(fresh.dataset.dmCount) || 0);
    }
    S.fmtOk = null; S.last = html;
    DMES.init(host);
    applyBusy();
    if (focusId && !host.contains(document.activeElement)) { const f = document.getElementById(focusId); if (f) f.focus({ preventScroll: true }); }
    return true;
  };
  // refresh: vuelve a pedir la sección (true si se pudo pintar) · restore: deshace los valores optimistas con lo último que pintó el servidor, sin pedir nada
  const refresh = () => fetch(`${location.pathname}?section_id=${encodeURIComponent(sectionId())}`, { credentials: 'same-origin', headers: { Accept: 'text/html' } })
    .then(r => { if (!r.ok) throw new Error(String(r.status)); return r.text(); })
    .then(html => render(html), () => false);
  const restore = () => (S.last ? render(S.last) : false);

  /* ── una mutación del carrito (en fila: de a una; solo la última respuesta repinta) ── */
  const mutate = (path, body, opt = {}) => {
    S.busy++; applyBusy(); announce('');
    const id = sectionId();
    const run = S.chain.then(() => fetch(`${base()}${path}`, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ ...body, sections: id, sections_url: location.pathname }) })
      .then(r => r.json().then(j => ({ ok: r.ok, j }), () => ({ ok: false, j: {} }))));
    S.chain = run.then(() => {}, () => {});
    return run.then(async ({ ok, j }) => {
      const failed = !ok || j.errors || (j.status && j.status >= 400);
      const last = () => S.busy === 1 && S.timers.size === 0;
      if (failed) {
        const msg = (typeof j.errors === 'string' && j.errors) || j.description || j.message || cfg().t.error;
        // rechazo de Shopify (422: p. ej. no hay stock para esa cantidad): el carrito no cambió, se deshace lo optimista. Otro fallo (red, 429, 5xx):
        // se le pregunta al servidor cómo quedó y, si tampoco responde, se deshace igual. Nunca se recarga la página.
        if (last()) { if (j.status === 422 || j.errors) restore(); else if (!(await refresh())) restore(); }
        return { ok: false, j, msg };
      }
      const html = j.sections && j.sections[id];
      if (opt.before) await opt.before();
      if (last() && (!html || !render(html))) await refresh();
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: j, sourceId: 'dm-cart', data: { source: 'dm-cart', itemCount: j.item_count, sections: j.sections || {} } } }));
      return { ok: true, j };
    }, () => { refresh().then(done => { if (!done) restore(); }); return { ok: false, j: {}, msg: cfg().t.error }; })
      .finally(() => { S.busy = Math.max(0, S.busy - 1); applyBusy(); });
  };

  /* ── valores optimistas (updateLineQuantity / deleteLine de España: total de la línea = unitario × cantidad; subtotal = suma; el descuento se mantiene) ── */
  const paintLine = line => {
    if (!fmtOk()) return;
    const q = Number(line.dataset.dmQty), u = Number(line.dataset.dmUnit), w = Number(line.dataset.dmUnitWas);
    setText('[data-dm-line-price] > span', money(u * q), line);
    setText('[data-dm-line-was]', money(w * q), line);
  };
  const paintTotals = () => {
    const p = pageEl(); if (!p) return;
    let sub = 0, n = 0;
    $$('[data-dm-line]', p).forEach(l => { const q = Number(l.dataset.dmQty); sub += q * Number(l.dataset.dmUnit); n += q; });
    setCount(n);
    if (!fmtOk()) return;
    setText('[data-dm-subtotal-text]', money(sub), p);
    setText('[data-dm-total-text]', money(Math.max(0, sub - (Number(p.dataset.dmDiscount) || 0))), p);
  };
  const lineError = (key, msg) => {
    const line = $$('[data-dm-line]').find(l => l.dataset.dmKey === key), w = line && $('[data-dm-qty-dropdown]', line);
    if (!w) { announce(msg); return; }
    const trigger = $('.es-dropdown__trigger', w), hint = $('.es-dropdown__hint', w);
    flag(trigger, 'data-invalid', !!msg);
    if (msg) hint.setAttribute('role', 'alert'); else hint.removeAttribute('role');
    hint.textContent = msg || '';
  };

  /* ── 2 · desplegable (Dropdown de España; igual al de 50-footer.js) ── */
  const dropdown = (w, onChange) => {
    const trigger = $('.es-dropdown__trigger', w), list = $('.es-dropdown__optionsList', w), native = $('.es-dropdown__hiddenSelect', w), iconBox = $('.es-dropdown__icon', w);
    if (!trigger || !list || !native) return;
    const opts = $$('.es-dropdown__option', list), labels = [...native.options].map(o => o.textContent.trim().toLowerCase()), last = opts.length - 1;
    native.selectedIndex = Math.max(0, opts.findIndex(o => o.dataset.selected === 'true'));      // el <select> oculto no trae `selected` en el marcado (España lo fija por JS)
    let open = false, active = -1, tl = null, typed = '', typedT = 0;
    const setActive = i => {
      active = i;
      opts.forEach((o, k) => { o.tabIndex = k === i ? 0 : -1; flag(o, 'data-active', k === i); });
      if (open && i >= 0 && opts[i]) { opts[i].focus(); opts[i].scrollIntoView({ block: 'nearest', behavior: 'instant' }); }
    };
    const setOpen = v => {
      if (open === v) return;
      open = v;
      trigger.setAttribute('aria-expanded', String(v));
      flag(trigger, 'data-is-open', v);
      v ? list.removeAttribute('aria-hidden') : list.setAttribute('aria-hidden', 'true');
      if (iconBox) iconBox.replaceChildren(tpl(v ? 'chevron-up' : 'chevron'));
      if (tl) tl.kill();
      const h = list.offsetHeight, clip = x => ({ clipPath: `inset(0 0 ${x}px 0)` });
      if (v) { if (reduced()) list.style.clipPath = 'inset(0 0 0px 0)'; else tl = DMES.stepped({ el: list, start: h, end: 0, stepPx: chunk(h), moveMs: 10, pauseMs: 50, vars: clip }); }
      else if (reduced() || h === 0) list.style.clipPath = 'inset(0 0 100% 0)';
      else tl = DMES.stepped({ el: list, start: 0, end: h, stepPx: chunk(h), moveMs: 10, pauseMs: 50, vars: clip });
    };
    const show = () => { setOpen(true); setActive(native.selectedIndex >= 0 ? native.selectedIndex : 0); };
    const hide = focus => { setOpen(false); setActive(-1); if (focus) trigger.focus(); };
    const select = i => {
      const changed = native.selectedIndex !== i;
      native.selectedIndex = i;
      opts.forEach((o, k) => { o.setAttribute('aria-selected', String(k === i)); flag(o, 'data-selected', k === i); });
      const node = $('.es-dropdown__optionLabel', opts[i]);
      if (node) trigger.replaceChildren(...[...node.childNodes].map(n => n.cloneNode(true)));
      trigger.setAttribute('data-has-value', 'true');
      hide(true);
      if (changed && onChange) onChange(native.value);
    };
    const typeahead = e => {
      if (!(e.key.length === 1 && !e.altKey && !e.ctrlKey && !e.metaKey) || (e.key === ' ' && !typed)) return false;
      e.preventDefault();
      clearTimeout(typedT); typedT = setTimeout(() => { typed = ''; }, 1000);
      const t = (typed += e.key.toLowerCase()), same = t.length > 1 && [...t].every(c => c === t[0]), s = same ? t.slice(0, 1) : t;
      const from = (active >= 0 ? active : native.selectedIndex) + (t.length === 1 || same ? 1 : 0);
      for (let k = 0; k < labels.length; k++) { const i = (from + k + labels.length) % labels.length; if (labels[i].startsWith(s)) { setOpen(true); setActive(i); break; } }
      return true;
    };
    trigger.addEventListener('click', () => (open ? hide(true) : show()));
    trigger.addEventListener('keydown', e => { if (!typeahead(e) && ['ArrowDown', 'ArrowUp', 'Enter', ' '].includes(e.key)) { e.preventDefault(); show(); } });
    list.addEventListener('keydown', e => {
      if (typeahead(e)) return;
      switch (e.key) {
        case 'ArrowDown': e.preventDefault(); setActive(Math.min(active + 1, last)); break;
        case 'ArrowUp': e.preventDefault(); setActive(Math.max(active - 1, 0)); break;
        case 'Home': e.preventDefault(); setActive(0); break;
        case 'End': e.preventDefault(); setActive(last); break;
        case 'Enter': case ' ': e.preventDefault(); if (active >= 0 && opts[active]) select(active); break;
        case 'Escape': hide(true); break;
        case 'Tab': hide(false); break;
      }
    });
    opts.forEach((o, i) => {
      o.addEventListener('mousedown', e => e.preventDefault());
      o.addEventListener('click', () => select(i));
      o.addEventListener('mousemove', () => { if (active !== i) setActive(i); });
    });
    const away = e => { if (!w.isConnected) { document.removeEventListener('mousedown', away); return; } if (open && !w.contains(e.target)) hide(false); };
    document.addEventListener('mousedown', away);
  };

  /* ── 4 · «Editar talla»: tallas del producto (buildSizeOptions) con las demás opciones de la línea fijas; ordenadas por número como el PDP ── */
  const products = new Map();
  const product = handle => {
    if (!products.has(handle)) products.set(handle, fetch(`${base()}products/${encodeURIComponent(handle)}.js`, { headers: { Accept: 'application/json' } }).then(r => { if (!r.ok) throw new Error(String(r.status)); return r.json(); }).catch(e => { products.delete(handle); throw e; }));
    return products.get(handle);
  };
  const sizesOf = (p, variantId) => {
    const cur = p.variants.find(v => String(v.id) === String(variantId)), names = (p.options || []).map(o => (o.name || o)), n = names.length;
    if (!cur || !n) return [];
    let oi = names.findIndex(x => /talla|talle|size|n[uú]mero/i.test(x));
    if (oi < 0) oi = names.findIndex(x => !/colou?r/i.test(x));
    if (oi < 0) return [];
    const by = new Map();
    for (const v of p.variants) {
      if (v.options.some((val, k) => k !== oi && val !== cur.options[k])) continue;
      const k = v.options[oi], had = by.get(k);
      if (!had || (!had.available && v.available)) by.set(k, v);
    }
    const num = s => { const x = parseFloat(String(s).replace(',', '.')); return Number.isFinite(x) ? x : Infinity; };
    return [...by.keys()].map((k, i) => ({ label: k, variant: by.get(k), available: !!by.get(k).available, current: k === cur.options[oi], i }))
      .sort((a, b) => (num(a.label) - num(b.label)) || (a.i - b.i));
  };
  const use = (n, t) => `<svg aria-hidden="true" viewBox="0 0 20 20" xml:space="preserve"><title>${t}</title><use x="0" y="0" href="#_RI-${n}"></use></svg>`;
  const inline = (n, t, cls) => { const g = document.getElementById(`_RI-${n}`); return `<svg class="${cls}" aria-hidden="true" viewBox="0 0 20 20" xml:space="preserve"><title>${t}</title><g>${g ? g.innerHTML : ''}</g></svg>`; };
  const sizePanel = (line, dlg) => {
    const T = cfg().t, content = $('[data-panel-appearance]', dlg), id = dlg.id, key = line.dataset.dmKey;
    const head = `<div class="es-panel-controls__container"><div class="es-panel-controls__controls"><button aria-label="Cerrar" class="es-dialog-dismiss__dismiss es-panel-controls__control" command="request-close" commandfor="${id}" data-control="close" type="button">${use('close', 'Close')}</button></div></div><header class="es-panel-header__container" data-has-back-button="false" data-variant="default"><div class="es-panel-header__headerGroup"><h2 autofocus class="es-panel-header__title" id="${id}-title" tabindex="-1">${esc(T.sizeTitle)}</h2></div></header>`;
    let state = 'idle';
    const fail = () => { content.innerHTML = `<div>${head}<div class="es-panel-content__content" data-variant="default"><p class="es-cart-change-size-panel__error" role="alert">${esc(T.sizeLoad)}</p></div></div>`; state = 'idle'; };
    const build = p => {
      const sizes = sizesOf(p, line.dataset.dmVariant), n = sizes.length;
      if (!n) { fail(); return; }
      const cells = sizes.map((s, i) => {
        const col = i % 5, right = col < 4 && i + 1 < n && sizes[i + 1].available, below = i + 5 < n && sizes[i + 5].available;
        return `<label aria-disabled="false" class="es-selector__selector" data-disabled="false"${col === 0 ? ' data-first-column="true"' : ''}${i < 5 ? ' data-first-row="true"' : ''} data-grouped="true"${below ? ' data-has-available-bottom="true"' : ''}${right ? ' data-has-available-right="true"' : ''} data-low-stock="false" data-selected="${s.current ? 'true' : 'false'}" data-selection-mode="multiple" data-unavailable="${s.available ? 'false' : 'true'}" data-variant="size"><input class="es-sr-only__container" type="checkbox" value="${i}"${s.current ? ' checked' : ''}>${s.available ? '' : inline('bell', 'Notify me', 'es-selector__cellIcon')}<span class="es-selector__textWrapper"><span class="es-selector__label" data-text="${esc(s.label)}">${esc(s.label)}</span></span></label>`;
      }).join('');
      content.innerHTML = `<form class="es-cart-change-size-panel__form">${head}<div class="es-panel-content__content" data-variant="default"><div class="es-selector__sizeGroupGrid" style="grid-template-columns:repeat(5, 1fr)">${cells}</div></div><footer class="es-panel-footer__footer" data-theme="solid" data-variant="default"><div class="es-size-selector-panel__footerActions"><button class="es-add-to-cart-submit-button__button es-size-selector-panel__addToCart" data-loading="false" type="submit"><span class="es-box-appearance__button es-add-to-cart-submit-button__appearance" data-theme="primary" data-variant="text">${esc(T.sizeSave)}</span></button></div></footer></form>`;
      const form = content.firstElementChild, fa = $('.es-size-selector-panel__footerActions', form), btn = $('button[type="submit"]', form), label = btn.firstElementChild;
      const h2 = $('h2', form); if (h2 && dlg.open) h2.focus({ preventScroll: true });
      let chosen = sizes.find(s => s.current) || null, busy = false;
      const note = msg => { $$('p[role="alert"]', fa).forEach(e => e.remove()); if (msg) fa.insertAdjacentHTML('beforeend', `<p class="es-size-selector-panel__addToCartError" role="alert">${esc(msg)}</p>`); };
      form.addEventListener('change', e => {
        const inp = e.target; if (!inp.matches('.es-selector__selector input')) return;
        const s = sizes[Number(inp.value)];
        if (!s.available) { window.location.href = `${p.url || `${base()}products/${p.handle}`}?variant=${s.variant.id}`; return; }   // agotada: a la ficha, donde está «Avísame» (igual que el agregar rápido)
        chosen = s;                                                                                                     // siempre queda una talla elegida (la actual o la nueva)
        $$('.es-selector__selector', form).forEach(l => { const x = $('input', l), on = x === inp; x.checked = on; l.dataset.selected = String(on); });
        note('');
      });
      // guía de tallas (España: CartChangeSizePanel con withSizeGuide → mismo panel de la ficha). El diálogo lo pinta el servidor por línea
      // (snippets/dm-es-cart-size-guide.liquid, id «<panel>-guia»); acá: enlace en la fila de info, filas que eligen la talla, cm / in y pie «Guardar cambios»
      const gdlg = document.getElementById(`${id}-guia`);
      if (gdlg) {
        const gt = $('h2', gdlg), body = $('.es-panel-content__content', form);
        body.insertAdjacentHTML('afterbegin', `<div class="es-size-selector-panel__sizeInfo"><button class="es-action__action es-size-selector-panel__sizeGuideLink" command="show-modal" commandfor="${gdlg.id}" type="button"><span class="es-underline-appearance__container" data-size="small" data-theme="dark">${esc(gt ? gt.textContent.trim() : 'Guía de tallas')}</span></button></div>`);
        const paintGuide = () => {
          $$('tr[data-dm-row]', gdlg).forEach(tr => tr.setAttribute('data-highlighted', String(!!chosen && tr.dataset.dmRow === chosen.label)));
          const content = $('.es-panel__content', gdlg), ft = content && $(':scope > footer', content), t = $('template[data-dm-guide-footer]', gdlg);
          if (content && chosen && !ft && t) content.append(t.content.firstElementChild.cloneNode(true));
        };
        const pickRow = tr => {
          if (!tr || tr.dataset.clickable !== 'true') return;
          const i = sizes.findIndex(x => x.label === tr.dataset.dmRow), inp = i >= 0 && $(`.es-selector__selector input[value="${i}"]`, form);
          if (!inp) return;
          inp.checked = true; inp.dispatchEvent(new Event('change', { bubbles: true }));
        };
        form.addEventListener('change', () => setTimeout(paintGuide, 0));
        if (!gdlg.__dmCart) {
          gdlg.__dmCart = true;
          gdlg.addEventListener('click', e => {
            if (e.target.closest('[data-dm-guide-save]')) { DMES.dialog.requestClose(gdlg); if (gdlg.__dmForm) gdlg.__dmForm.requestSubmit(); return; }
            if (gdlg.__dmPick) gdlg.__dmPick(e.target.closest('tr[data-dm-row]'));
          });
          gdlg.addEventListener('keydown', e => {
            const tr = e.target.closest && e.target.closest('tr[data-dm-row]');
            if (tr && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); if (gdlg.__dmPick) gdlg.__dmPick(tr); }
          });
          const sw = $('[data-dm-unit-switch]', gdlg);
          if (sw) {
            const [bCm, bIn] = $$('.es-switch__label', sw), chk = $('.es-toggle__input', sw);
            const unit = on => { chk.checked = on; bCm.dataset.active = String(!on); bIn.dataset.active = String(on); $$('td[data-dm-cm]', gdlg).forEach(td => { td.textContent = on ? td.dataset.dmIn : td.dataset.dmCm; }); };
            bCm.addEventListener('click', () => unit(false)); bIn.addEventListener('click', () => unit(true)); chk.addEventListener('change', () => unit(chk.checked));
          }
        }
        gdlg.__dmPick = pickRow; gdlg.__dmForm = form;
        paintGuide();
      }
      form.addEventListener('submit', e => {
        e.preventDefault();
        if (busy) return;
        if (!chosen || chosen.current) { DMES.dialog.requestClose(dlg); return; }                                      // sin cambio: solo cierra (como España)
        busy = true; note(''); btn.dataset.loading = 'true'; label.textContent = T.sizeSaving;
        // Shopify no «cambia» la variante de una línea: se quita la línea y entra la nueva talla con la misma cantidad (sumada si ya estaba en el carrito)
        const qty = Number(line.dataset.dmQty) || 1, other = $$('[data-dm-line]').find(l => l !== line && l.dataset.dmVariant === String(chosen.variant.id));
        const updates = { [key]: 0, [chosen.variant.id]: qty + (other ? Number(other.dataset.dmQty) || 0 : 0) };
        clearTimeout(S.timers.get(key)); S.timers.delete(key);
        mutate('cart/update.js', { updates }, { before: () => new Promise(done => { DMES.dialog.requestClose(dlg); setTimeout(done, reduced() ? 0 : 450); }) })
          .then(res => { if (res.ok) return; busy = false; btn.dataset.loading = 'false'; label.textContent = T.sizeSave; note(res.msg); });
      });
    };
    return () => {
      if (state !== 'idle') return;
      state = 'loading';
      product(line.dataset.dmHandle).then(p => { state = 'ready'; build(p); }, fail);
    };
  };

  // foto inicial de lo que pintó el servidor (este registro va antes que los de línea/cupón: corre primero)
  DMES.on('[data-dm-cart-page]', page => { if (!S.last) S.last = page.outerHTML; });

  /* ── 1 · línea: cantidad, quitar, talla ── */
  DMES.on('[data-dm-line]', line => {
    const li = line.closest('li'), key = line.dataset.dmKey, dd = $('[data-dm-qty-dropdown]', line), rm = $('[data-dm-remove]', line);
    if (dd) dropdown(dd, v => {
      const q = Number(v);
      line.dataset.dmQty = String(q); if (li) li.dataset.dmDirty = '1';
      lineError(key, ''); paintLine(line); paintTotals();
      clearTimeout(S.timers.get(key));
      S.timers.set(key, setTimeout(() => {
        S.timers.delete(key);
        mutate('cart/change.js', { id: key, quantity: q }).then(res => { if (!res.ok) lineError(key, res.msg); });
      }, 400));
    });
    if (rm) rm.addEventListener('click', () => {
      clearTimeout(S.timers.get(key)); S.timers.delete(key);
      if (li) li.remove();
      paintTotals();
      mutate('cart/change.js', { id: key, quantity: 0 }).then(res => { if (!res.ok) announce(res.msg); });
    });
    const dlg = li && $('[data-dm-size-panel]', li), open = $('[data-dm-size-open]', line);
    if (dlg && open) {
      const load = sizePanel(line, dlg);
      open.addEventListener('click', load);
      dlg.addEventListener('dm:dialog', e => { if (e.target === dlg && !e.detail.open && li.dataset.dmStale) refresh(); });
    }
  });

  /* ── 3 · código promocional ── */
  DMES.on('[data-dm-promo]', w => {
    const T = cfg().t, toggle = $('[data-dm-promo-toggle]', w), iconBox = $('[data-dm-promo-icon]', w), formTpl = $('template[data-dm-promo-form]', w);
    if (!toggle || !formTpl) return;
    let isOpen = false, busy = false, form = null, input = null, hintW = null, hint = null, btn = null, label = null;
    const icon = n => { const t = $(`template[data-dm-promo-icon-tpl="${n}"]`, w); return t ? t.content.firstElementChild.cloneNode(true) : document.createTextNode(''); };
    const codes = () => $$('[data-dm-applied] [data-dm-code]', w).map(li => li.dataset.dmCode);
    const has = (list, c) => list.some(x => x.toLowerCase() === c.toLowerCase());
    // Input de España: error → aria-invalid + p.hint[role=alert]; ayuda → solo texto; el envoltorio lleva data-visible si hay cualquiera de los dos
    const message = (error, help) => {
      if (!form) return;
      error ? input.setAttribute('aria-invalid', 'true') : input.removeAttribute('aria-invalid');
      error ? hint.setAttribute('role', 'alert') : hint.removeAttribute('role');
      hint.textContent = error || help || '';
      flag(hintW, 'data-visible', !!(error || help));
    };
    const sync = () => {
      if (form) { input.disabled = busy; btn.disabled = busy || !input.value.trim(); label.textContent = busy ? T.applying : T.apply; }
      $$('[data-dm-promo-remove]', w).forEach(b => { b.disabled = busy; });
    };
    const setBusy = v => { busy = v; sync(); };
    const submit = async e => {
      e.preventDefault();
      const code = input.value.trim(), before = codes();
      if (!code || busy) return;
      if (has(before, code)) { message('', T.applied); input.value = ''; sync(); return; }
      message(); setBusy(true);
      const res = await mutate('cart/update.js', { discount: [...before, code].join(',') });
      setBusy(false);
      const dc = ((res.j && res.j.discount_codes) || []).find(d => String(d.code).toLowerCase() === code.toLowerCase());
      if (!res.ok) { message(res.msg || T.error); return; }
      if (!dc || dc.applicable === false) { message(T.invalid); return; }
      input.value = ''; sync();
      // aplicable pero no aparece entre los descuentos del carrito = descuento de envío: Shopify lo aplica en el checkout (mismo aviso que Horizon)
      message('', has(codes(), code) || !T.shippingCode ? T.applied : T.shippingCode);
    };
    const open = v => {
      isOpen = v;
      iconBox.replaceChildren(icon(v ? 'minus' : 'plus'));
      if (v) {
        form = formTpl.content.firstElementChild.cloneNode(true);
        input = $('input', form); hintW = $('.es-input__hintWrapper', form); hint = $('.es-input__hint', form); btn = $('button[type="submit"]', form); label = btn.firstElementChild;
        input.addEventListener('input', () => { if (input.hasAttribute('aria-invalid') || hint.textContent) message(); sync(); });
        form.addEventListener('submit', submit);
        toggle.after(form); sync();
      } else if (form) { form.remove(); form = input = hintW = hint = btn = label = null; }
    };
    toggle.addEventListener('click', () => open(!isOpen));
    w.addEventListener('click', async e => {
      const b = e.target.closest('[data-dm-promo-remove]'), li = b && b.closest('[data-dm-code]');
      if (!li || busy) return;
      message(); setBusy(true);
      const res = await mutate('cart/update.js', { discount: codes().filter(c => c !== li.dataset.dmCode).join(',') });
      setBusy(false);
      if (!res.ok) announce(res.msg);
    });
    const news = $('[data-dm-newsletter]', w);
    if (news) news.addEventListener('click', () => { if (DMES.dialog) DMES.dialog.show('newsletter-dialog'); });
  });

  /* ── medios de pago: los símbolos (#_RI-…) los define el footer; el que no exista no se dibuja ── */
  DMES.on('[data-dm-pay]', li => {
    const u = $('use', li), id = u && (u.getAttribute('href') || '').replace(/^#/, '');
    if (id && !document.getElementById(id)) li.hidden = true;
  });

  // agregado hecho por otra pieza estando en /cart (p. ej. una tarjeta del panel «Añadido al carrito»): la página se repinta con lo que diga el servidor
  document.addEventListener('cart:update', e => { const d = (e.detail && e.detail.data) || {}; if (pageEl() && d.source !== 'dm-cart' && !d.didError) refresh(); });

  // vuelta atrás desde el checkout (página restaurada de la caché del navegador): el carrito pudo cambiar
  window.addEventListener('pageshow', e => { if (e.persisted && pageEl()) refresh(); });

  /* ── 6 · «Finalizar compra» siempre a mano en celular (QA de compra en celular, 17-oct-2026: con 1 par el botón quedaba debajo de la barra de
     navegación fija y había que deslizar para encontrarlo). Barra fija con las mismas clases que la «Añadir al carrito» de la ficha, creada al
     final del <body> para no tocar el árbol de la página que compara qa/treecmp.py. Se ve mientras el botón real no está entero a la vista
     sobre la barra de abajo; copia su texto, el total y su estado (deshabilitada mientras el carrito se actualiza); sin botón real (carrito
     vacío) no se ve. Solo celular y tablet: es/glue.d/compra-movil.css la oculta desde 1024 px, donde el resumen ya está a la vista. ── */
  {
    let bar = null, raf = 0, wired = false;
    const covered = () => {
      const n = document.querySelector('.es-nav-bar-mobile__nav'); if (!n) return 0;
      const r = n.getBoundingClientRect();
      return r.height > 0 && r.top < window.innerHeight ? Math.max(0, Math.round(window.innerHeight - r.top)) : 0;
    };
    const make = () => {
      const host = document.createElement('div'); host.className = 'es'; host.dataset.dmCartStickyHost = '';
      host.innerHTML = '<div class="es-product-detail__stickyAddToBag" data-visible="false" data-dm-cart-sticky><a class="es-add-to-cart-submit-button__button es-product-detail__stickyAddToBagButton" data-tracking-context="cart sticky"><span class="es-box-appearance__button es-add-to-cart-submit-button__appearance es-product-detail__stickyAddToBagAppearance" data-theme="primary" data-variant="text"></span></a></div>';
      document.body.append(host);
      // franja blanca en el espacio bajo el botón: si no, el botón real se asoma entre la barra y la navegación
      host.firstElementChild.style.background = 'linear-gradient(to top,#fff var(--page-gutter,.5rem),transparent 0)';
      return host.firstElementChild;
    };
    const check = () => {
      raf = 0;
      const p = pageEl(), link = p && $('[data-dm-checkout]', p);
      if (!link) { if (bar) bar.dataset.visible = 'false'; return; }
      if (!bar) bar = make();
      const a = bar.firstElementChild, label = a.firstElementChild;
      const txt = (link.textContent || '').trim(), total = (($('[data-dm-total-text]', p) || {}).textContent || '').trim();
      const want = total ? `${txt} · ${total}` : txt;
      if (label.textContent !== want) label.textContent = want;
      if (link.tagName === 'A') { a.setAttribute('href', link.getAttribute('href')); a.removeAttribute('aria-disabled'); }
      else { a.removeAttribute('href'); a.setAttribute('aria-disabled', 'true'); }
      const r = link.getBoundingClientRect();
      // 2-nov-2026 (user: «el botón está sobrepuesto»): la barra se va justo cuando el botón real llega a su altura, así nunca se ven los dos; antes esperaba a verlo entero y por un tramo quedaban encimados
      const tope = window.innerHeight - covered() - (parseFloat(getComputedStyle(bar).paddingBottom) || 0) - a.offsetHeight;
      const v = String(!(r.height > 0 && r.bottom > 0 && r.top <= tope));
      if (bar.dataset.visible !== v) bar.dataset.visible = v;
    };
    const plan = () => { if (!raf) raf = requestAnimationFrame(check); };
    DMES.on('[data-dm-cart-page]', () => {
      plan();
      if (wired) return; wired = true;
      ['scroll', 'resize'].forEach(ev => window.addEventListener(ev, plan, { passive: true }));
      window.addEventListener('load', plan, { once: true });
      // la página se repinta por partes (cantidad, quitar, cupón, estado «mutando»): cualquier cambio de nodos vuelve a mirar (una vez por cuadro)
      new MutationObserver(plan).observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
    });
  }
}

/* ═══ 81-upsell-panel.js ═══ */
/* ───────── panel «Añadido al carrito» (UpsellPanel + SimpleProductCard de España: js_legible/41rvnxj5yzquj.js; estado pdp_d1440_atc) ─────────
   Como allá es UN panel global: dialog#upsell-panel.es-panel__container al final del <body>. Lo crea este archivo la primera vez que se usa
   (sirve en cualquier página, sin tocar el layout) y su contenido lo pinta Liquid: sections/dm-upsell-panel.liquid, pedida con la Section
   Rendering API en /recommendations/products (así llegan los complementarios de Shopify; si no hay, los relacionados; si no hay, sin tarjetas).
   Cuándo se abre: después de CUALQUIER agregado exitoso. El aviso único es el que ya emite todo el theme: «cart:update» en document con
   detail.data.source = 'product-form-component' (lo dispara assets/product-form.js de Horizon —PDP, compra rápida nativa— y es/js/62-quick-add.js);
   trae la variante (detail.sourceId) y el producto (detail.data.productId). España usa «add-to-cart:success» con el mismo fin.
   El cajón de Horizon sigue en el theme pero ya no se abre solo (ver abajo «cart-drawer-component»); queda de respaldo si el panel no se puede armar.
   Qué muestra (igual que España):
     · con sugeridos   → título «Maximiza tu comodidad» + tarjetas. «Añadir al carrito» de la tarjeta = openQuickAdd con skipPanel: una sola talla
                         se agrega directo; varias, abre el panel de agregar rápido encima. Al agregarse: botón «Añadido al carrito ✓» 3 s
                         (data-added, tema primary) y el panel NO se vuelve a abrir (UpsellPanel: `t`).
     · sin sugeridos   → título «Añadido al carrito» + la línea agregada (CartLineItem de solo lectura).
     · pie             → entra deslizando (data-animated; se vuelve a montar en cada agregado), nombre del producto y «[n] Ver carrito» → /cart.
   Ancho del rótulo del botón de la tarjeta: España lo fija en línea (ResizeObserver sobre el rótulo visible) para animar el cambio de texto. */
{
  const ID = 'upsell-panel', ADDED_MS = 3000, ADDING_MS = 15000;      // ADD_TO_CART_CONFIRMATION_MS · tope del estado «añadiendo» de la tarjeta
  const base = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  let dialog = null, content = null, token = 0, count = 0;
  const cards = new Map();                                             // id de producto → control de la tarjeta visible

  // El cajón de Horizon se abría solo ante cada «cart:update» si su elemento lleva el atributo auto-open (ajuste del theme «abrir el cajón al agregar»).
  // No alcanza con quitarlo una vez: cada actualización del carrito hace morph de la sección del header y el atributo vuelve desde el HTML del
  // servidor. Por eso, además, el elemento responde «no» cuando su propio código pregunta por auto-open. Lo demás del cajón queda intacto.
  DMES.on('cart-drawer-component', el => {
    el.removeAttribute('auto-open');
    const has = Element.prototype.hasAttribute;
    el.hasAttribute = name => (name === 'auto-open' ? false : has.call(el, name));
  });

  const ensure = () => {
    if (dialog && dialog.isConnected) return;
    const host = document.createElement('div'); host.className = 'es';
    host.innerHTML = `<dialog id="${ID}" closedby="any" class="es-panel__container" aria-labelledby="${ID}-title"><div class="es-panel__content" data-panel-appearance="true" data-alignment="end" data-size="default" data-expanded="false"></div></dialog>`;
    document.body.append(host); dialog = host.firstElementChild; content = dialog.firstElementChild;
    DMES.init(host);
  };
  const parse = html => new DOMParser().parseFromString(html, 'text/html').querySelector('[data-dm-upsell-payload]');
  const get = url => fetch(url, { credentials: 'same-origin', headers: { Accept: 'text/html' } }).then(r => { if (!r.ok) throw new Error(String(r.status)); return r.text(); }).then(parse);
  const recs = (productId, intent) => get(`${base()}recommendations/products?section_id=dm-upsell-panel&product_id=${encodeURIComponent(productId)}&limit=6&intent=${intent}`);
  // ¿trae tarjetas, sin contar la del propio producto agregado?
  const hasCards = (p, own) => !!p && [...p.querySelector('template[data-dm-upsell-tpl="panel"]').content.querySelectorAll('[data-dm-upsell-card]')].some(c => c.dataset.dmProduct !== String(own));
  // complementarios → relacionados (o la colección de recomendaciones del theme: lo decide la sección) → la sección sola (colección, o nada).
  // Los productos sin complementarios se recuerdan en la sesión: la próxima vez se piden directo los relacionados (una petición menos por agregado)
  const KEY = 'dm-upsell-nocomp';
  const noComp = () => { try { return JSON.parse(sessionStorage.getItem(KEY) || '[]'); } catch (e) { return []; } };
  const load = async productId => {
    let p = null;
    if (productId) {
      const id = String(productId), skip = noComp().includes(id);
      // las dos listas a la vez: en serie el panel tardaba una consulta más en abrir (~0,6 s, 2-nov-2026)
      const [c, r] = await Promise.all([skip ? null : recs(id, 'complementary').catch(() => null), recs(id, 'related').catch(() => null)]);
      p = c;
      if (c && !hasCards(c, id)) { try { sessionStorage.setItem(KEY, JSON.stringify([...noComp(), id].slice(-40))); } catch (e) { /* sin sessionStorage */ } }
      if (!hasCards(p, id) && (hasCards(r, id) || !p)) p = r;
    }
    return p || get(`${base()}?section_id=dm-upsell-panel`);
  };

  const setCount = n => { count = n; const e = content && $('[data-dm-upsell-count]', content); if (e) e.textContent = String(n); };

  /* SimpleProductCard */
  const card = el => {
    const btn = $('[data-dm-upsell-add]', el), box = btn && $('.es-box-appearance__button', btn), wrap = btn && $('.es-simple-product-card__buttonContent', btn);
    const lDef = btn && $('.es-simple-product-card__labelDefault', btn), lAdd = btn && $('.es-simple-product-card__labelAdded', btn), text = lDef && $('.es-simple-product-card__labelText', lDef);
    $$('.es-simple-product-card__swatch[data-dm-color]', el).forEach(sw => { if (DMES.isLightColor && DMES.isLightColor(sw.dataset.dmColor)) sw.setAttribute('data-light', 'true'); });
    if (!btn || !wrap) return null;
    let adding = false, added = false, tAdding = null, tAdded = null, ro = null;
    const watch = () => {
      if (ro) ro.disconnect();
      if (!('ResizeObserver' in window)) return;
      const target = added ? lAdd : lDef;
      ro = new ResizeObserver(() => { const w = target.getBoundingClientRect().width; if (w !== 0) wrap.style.width = `${Math.ceil(w)}px`; });
      ro.observe(target);
    };
    const paint = () => {
      btn.disabled = adding;
      adding ? btn.setAttribute('data-adding', 'true') : btn.removeAttribute('data-adding');
      added ? btn.setAttribute('data-added', 'true') : btn.removeAttribute('data-added');
      box.dataset.theme = added ? 'primary' : 'outline';
      text.textContent = adding ? btn.dataset.dmLabelAdding : btn.dataset.dmLabelAdd;
      added ? lDef.setAttribute('aria-hidden', 'true') : lDef.removeAttribute('aria-hidden');
      added ? lAdd.removeAttribute('aria-hidden') : lAdd.setAttribute('aria-hidden', 'true');
      watch();
    };
    const ctl = {
      el,
      idle() { if (!adding) return; adding = false; clearTimeout(tAdding); paint(); },
      confirm() { adding = false; clearTimeout(tAdding); added = true; clearTimeout(tAdded); tAdded = setTimeout(() => { added = false; paint(); }, ADDED_MS); paint(); },
      stop() { clearTimeout(tAdding); clearTimeout(tAdded); if (ro) ro.disconnect(); },
    };
    btn.addEventListener('click', () => {
      if (adding) return;
      adding = true; clearTimeout(tAdding); tAdding = setTimeout(() => { adding = false; paint(); }, ADDING_MS); paint();
      const d = el.dataset, free = window.dispatchEvent(new CustomEvent('quick-add:open', { cancelable: true, detail: { handle: d.dmHandle, url: d.dmUrl, title: d.dmTitle, skipPanel: true, trackingContext: 'upsell' } }));
      if (free) window.location.href = d.dmUrl;                       // nadie atendió el agregar rápido: a la ficha
    });
    watch();
    return ctl;
  };

  const build = (p, variantId, productId) => {
    const panel = p.querySelector('template[data-dm-upsell-tpl="panel"]').content.cloneNode(true);
    const line = [...p.querySelectorAll('template[data-dm-upsell-tpl="line"]')].find(t => t.dataset.dmVariant === String(variantId));
    const title = $('[data-dm-upsell-title]', panel), box = $('[data-dm-upsell-content]', panel), name = $('[data-dm-upsell-name]', panel), list = $('.es-upsell-panel__products', panel);
    if (list) {                                                        // no se sugiere el mismo producto que se acaba de agregar; tope de tarjetas
      $$('[data-dm-upsell-card]', list).forEach(c => { if (c.dataset.dmProduct === String(productId)) c.remove(); });
      $$('[data-dm-upsell-card]', list).slice(Number(list.dataset.dmLimit) || 3).forEach(c => c.remove());
      if (!$('[data-dm-upsell-card]', list)) list.remove();
    }
    // Pedido del user (17-oct-2026, «al agregar no me sale el producto agregado», CL/AR/MX): el producto recién agregado se ve SIEMPRE arriba
    // (foto, nombre, talla, cantidad y precio) bajo el título «Añadido al carrito». Las sugerencias van debajo con su título como subtítulo.
    // Antes, como en España, con sugerencias el título pasaba a «También te puede interesar» y la línea agregada no salía (solo el nombre en el pie).
    if (line) box.prepend(line.content.cloneNode(true));
    const cardsBox = $('.es-upsell-panel__products', panel);
    if (cardsBox && $('[data-dm-upsell-card]', cardsBox)) {
      const sub = document.createElement('h3'); sub.dataset.dmUpsellSubtitle = ''; sub.textContent = title.dataset.dmTitleUpsell;
      cardsBox.before(sub);
    }
    if (name) name.textContent = line ? line.dataset.dmName : '';
    cards.forEach(c => c.stop()); cards.clear();
    content.replaceChildren(panel);
    $$('[data-dm-upsell-card]', content).forEach(el => { const c = card(el); if (c) cards.set(el.dataset.dmProduct, c); });
    dialog.dataset.dmVariant = String(variantId || ''); dialog.dataset.dmVariantTitle = line ? line.dataset.dmVariantTitle : ''; dialog.dataset.dmQty = line ? line.dataset.dmQty : '';
    setCount(Number(p.dataset.dmCount) || 0);
    const go = $('[data-dm-upsell-cart]', content);
    if (go) go.addEventListener('click', () => { if (window.location.pathname.includes('/cart')) DMES.dialog.closeAll(); });
    DMES.init(dialog.parentElement);
  };

  const onAdded = async (variantId, productId, qty) => {
    // agregado desde una tarjeta del panel abierto: no se vuelve a abrir; la tarjeta confirma y el pie suma
    const own = dialog && dialog.open && cards.get(String(productId));
    if (own) { own.confirm(); setCount(count + (qty || 1)); return; }
    const my = ++token;
    let p = null;
    try { p = await load(productId); } catch (e) { p = null; }
    if (my !== token) return;
    if (!p) {                                                          // sin la sección (theme sin sections/dm-upsell-panel.liquid, o falló la red): se confirma con el cajón de Horizon, como antes
      const drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.open === 'function' && !$$('.es dialog[open]').length) drawer.open();
      return;
    }
    ensure(); build(p, variantId, productId);
    DMES.dialog.show(dialog);
  };

  document.addEventListener('cart:update', e => {
    const d = (e.detail && e.detail.data) || {};
    if (d.source !== 'product-form-component' || d.didError) return;
    onAdded(e.detail.sourceId, d.productId, Number(d.itemCount) || 1);
  });
  // el panel de agregar rápido se cerró sin agregar: la tarjeta deja de estar «añadiendo»
  document.addEventListener('dm:dialog', e => { if (e.target && e.target.id === 'dm-quick-add-dialog' && e.detail && !e.detail.open) setTimeout(() => cards.forEach(c => c.idle()), 300); });
}

/* ═══ 99-boot.js ═══ */
/* ───────── arranque ───────── */
const boot = () => DMES.init();
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
document.addEventListener('shopify:section:load', e => DMES.init(e.target));
})();
